/*! UIkit 3.23.1 | https://www.getuikit.com | (c) 2014 - 2025 YOOtheme | MIT License */ (function (
  ye,
  ke
) {
  typeof exports == "object" && typeof module < "u"
    ? (module.exports = ke())
    : typeof define == "function" && define.amd
    ? define("uikit", ke)
    : ((ye = typeof globalThis < "u" ? globalThis : ye || self),
      (ye.UIkit = ke()));
})(this, function () {
  "use strict";
  const { hasOwnProperty: ye, toString: ke } = Object.prototype;
  function gt(t, e) {
    return ye.call(t, e);
  }
  const nr = /\B([A-Z])/g,
    Bt = ct((t) => t.replace(nr, "-$1").toLowerCase()),
    or = /-(\w)/g,
    Se = ct((t) =>
      (t.charAt(0).toLowerCase() + t.slice(1)).replace(or, (e, i) =>
        i.toUpperCase()
      )
    ),
    Nt = ct((t) => t.charAt(0).toUpperCase() + t.slice(1));
  function mt(t, e) {
    var i;
    return (i = t == null ? void 0 : t.startsWith) == null
      ? void 0
      : i.call(t, e);
  }
  function ee(t, e) {
    var i;
    return (i = t == null ? void 0 : t.endsWith) == null
      ? void 0
      : i.call(t, e);
  }
  function b(t, e) {
    var i;
    return (i = t == null ? void 0 : t.includes) == null
      ? void 0
      : i.call(t, e);
  }
  function xt(t, e) {
    var i;
    return (i = t == null ? void 0 : t.findIndex) == null
      ? void 0
      : i.call(t, e);
  }
  const { isArray: J, from: ie } = Array,
    { assign: ft } = Object;
  function nt(t) {
    return typeof t == "function";
  }
  function Tt(t) {
    return t !== null && typeof t == "object";
  }
  function Ie(t) {
    return ke.call(t) === "[object Object]";
  }
  function Qe(t) {
    return Tt(t) && t === t.window;
  }
  function Te(t) {
    return Hi(t) === 9;
  }
  function Ee(t) {
    return Hi(t) >= 1;
  }
  function se(t) {
    return Hi(t) === 1;
  }
  function Hi(t) {
    return !Qe(t) && Tt(t) && t.nodeType;
  }
  function ne(t) {
    return typeof t == "boolean";
  }
  function H(t) {
    return typeof t == "string";
  }
  function Ce(t) {
    return typeof t == "number";
  }
  function vt(t) {
    return Ce(t) || (H(t) && !isNaN(t - parseFloat(t)));
  }
  function ti(t) {
    return !(J(t) ? t.length : Tt(t) && Object.keys(t).length);
  }
  function X(t) {
    return t === void 0;
  }
  function Li(t) {
    return ne(t)
      ? t
      : t === "true" || t === "1" || t === ""
      ? !0
      : t === "false" || t === "0"
      ? !1
      : t;
  }
  function $t(t) {
    const e = Number(t);
    return isNaN(e) ? !1 : e;
  }
  function k(t) {
    return parseFloat(t) || 0;
  }
  function R(t) {
    return t && T(t)[0];
  }
  function T(t) {
    return Ee(t) ? [t] : Array.from(t || []).filter(Ee);
  }
  function zt(t) {
    if (Qe(t)) return t;
    t = R(t);
    const e = Te(t) ? t : t == null ? void 0 : t.ownerDocument;
    return (e == null ? void 0 : e.defaultView) || window;
  }
  function Pe(t, e) {
    return (
      t === e ||
      (Tt(t) &&
        Tt(e) &&
        Object.keys(t).length === Object.keys(e).length &&
        oe(t, (i, s) => i === e[s]))
    );
  }
  function Wi(t, e, i) {
    return t.replace(new RegExp(`${e}|${i}`, "g"), (s) => (s === e ? i : e));
  }
  function Ft(t) {
    return t[t.length - 1];
  }
  function oe(t, e) {
    for (const i in t) if (e(t[i], i) === !1) return !1;
    return !0;
  }
  function Rs(t, e) {
    return t
      .slice()
      .sort(({ [e]: i = 0 }, { [e]: s = 0 }) => (i > s ? 1 : s > i ? -1 : 0));
  }
  function Ht(t, e) {
    return t.reduce((i, s) => i + k(nt(e) ? e(s) : s[e]), 0);
  }
  function qs(t, e) {
    const i = new Set();
    return t.filter(({ [e]: s }) => (i.has(s) ? !1 : i.add(s)));
  }
  function ei(t, e) {
    return e.reduce((i, s) => ({ ...i, [s]: t[s] }), {});
  }
  function K(t, e = 0, i = 1) {
    return Math.min(Math.max($t(t) || 0, e), i);
  }
  function A() {}
  function ii(...t) {
    return [
      ["bottom", "top"],
      ["right", "left"],
    ].every(
      ([e, i]) =>
        Math.min(...t.map(({ [e]: s }) => s)) -
          Math.max(...t.map(({ [i]: s }) => s)) >
        0
    );
  }
  function si(t, e) {
    return t.x <= e.right && t.x >= e.left && t.y <= e.bottom && t.y >= e.top;
  }
  function ji(t, e, i) {
    const s = e === "width" ? "height" : "width";
    return { [s]: t[e] ? Math.round((i * t[s]) / t[e]) : t[s], [e]: i };
  }
  function Us(t, e) {
    t = { ...t };
    for (const i in t) t = t[i] > e[i] ? ji(t, i, e[i]) : t;
    return t;
  }
  function rr(t, e) {
    t = Us(t, e);
    for (const i in t) t = t[i] < e[i] ? ji(t, i, e[i]) : t;
    return t;
  }
  const Ri = { ratio: ji, contain: Us, cover: rr };
  function ot(t, e, i = 0, s = !1) {
    e = T(e);
    const { length: n } = e;
    return n
      ? ((t = vt(t)
          ? $t(t)
          : t === "next"
          ? i + 1
          : t === "previous"
          ? i - 1
          : t === "last"
          ? n - 1
          : e.indexOf(R(t))),
        s ? K(t, 0, n - 1) : ((t %= n), t < 0 ? t + n : t))
      : -1;
  }
  function ct(t) {
    const e = Object.create(null);
    return (i, ...s) => e[i] || (e[i] = t(i, ...s));
  }
  function S(t, ...e) {
    for (const i of T(t)) {
      const s = Lt(e).filter((n) => !$(i, n));
      s.length && i.classList.add(...s);
    }
  }
  function _(t, ...e) {
    for (const i of T(t)) {
      const s = Lt(e).filter((n) => $(i, n));
      s.length && i.classList.remove(...s);
    }
  }
  function ni(t, e, i) {
    (i = Lt(i)), (e = Lt(e).filter((s) => !b(i, s))), _(t, e), S(t, i);
  }
  function $(t, e) {
    return ([e] = Lt(e)), T(t).some((i) => i.classList.contains(e));
  }
  function L(t, e, i) {
    const s = Lt(e);
    X(i) || (i = !!i);
    for (const n of T(t)) for (const o of s) n.classList.toggle(o, i);
  }
  function Lt(t) {
    return t
      ? J(t)
        ? t.map(Lt).flat()
        : String(t).split(" ").filter(Boolean)
      : [];
  }
  function p(t, e, i) {
    var s;
    if (Tt(e)) {
      for (const n in e) p(t, n, e[n]);
      return;
    }
    if (X(i)) return (s = R(t)) == null ? void 0 : s.getAttribute(e);
    for (const n of T(t))
      nt(i) && (i = i.call(n, p(n, e))),
        i === null ? _e(n, e) : n.setAttribute(e, i);
  }
  function Et(t, e) {
    return T(t).some((i) => i.hasAttribute(e));
  }
  function _e(t, e) {
    T(t).forEach((i) => i.removeAttribute(e));
  }
  function Z(t, e) {
    for (const i of [e, `data-${e}`]) if (Et(t, i)) return p(t, i);
  }
  const Wt = typeof window < "u",
    U = Wt && document.dir === "rtl",
    re = Wt && "ontouchstart" in window,
    ae = Wt && window.PointerEvent,
    ut = ae ? "pointerdown" : re ? "touchstart" : "mousedown",
    oi = ae ? "pointermove" : re ? "touchmove" : "mousemove",
    Ct = ae ? "pointerup" : re ? "touchend" : "mouseup",
    jt = ae ? "pointerenter" : re ? "" : "mouseenter",
    le = ae ? "pointerleave" : re ? "" : "mouseleave",
    ri = ae ? "pointercancel" : "touchcancel",
    ar = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0,
    };
  function qi(t) {
    return T(t).some((e) => ar[e.tagName.toLowerCase()]);
  }
  const lr =
    (Wt && Element.prototype.checkVisibility) ||
    function () {
      return (
        this.offsetWidth || this.offsetHeight || this.getClientRects().length
      );
    };
  function q(t) {
    return T(t).some((e) => lr.call(e));
  }
  const Ae = "input,select,textarea,button";
  function ai(t) {
    return T(t).some((e) => C(e, Ae));
  }
  const he = `${Ae},a[href],[tabindex]`;
  function li(t) {
    return C(t, he);
  }
  function O(t) {
    var e;
    return (e = R(t)) == null ? void 0 : e.parentElement;
  }
  function Oe(t, e) {
    return T(t).filter((i) => C(i, e));
  }
  function C(t, e) {
    return T(t).some((i) => i.matches(e));
  }
  function ce(t, e) {
    const i = [];
    for (; (t = O(t)); ) (!e || C(t, e)) && i.push(t);
    return i;
  }
  function B(t, e) {
    t = R(t);
    const i = t ? ie(t.children) : [];
    return e ? Oe(i, e) : i;
  }
  function yt(t, e) {
    return e ? T(t).indexOf(R(e)) : B(O(t)).indexOf(t);
  }
  function ue(t) {
    return (
      (t = R(t)),
      t && ["origin", "pathname", "search"].every((e) => t[e] === location[e])
    );
  }
  function Ui(t) {
    if (ue(t)) {
      const { hash: e, ownerDocument: i } = R(t),
        s = decodeURIComponent(e).slice(1);
      return s
        ? i.getElementById(s) || i.getElementsByName(s)[0]
        : i.documentElement;
    }
  }
  function tt(t, e) {
    return Vi(t, Vs(t, e));
  }
  function De(t, e) {
    return Me(t, Vs(t, e));
  }
  function Vi(t, e) {
    return R(Xs(t, R(e), "querySelector"));
  }
  function Me(t, e) {
    return T(Xs(t, R(e), "querySelectorAll"));
  }
  function Vs(t, e = document) {
    return Te(e) || Ys(t).isContextSelector ? e : e.ownerDocument;
  }
  const hr = /([!>+~-])(?=\s+[!>+~-]|\s*$)/g,
    cr = /(\([^)]*\)|[^,])+/g,
    Ys = ct((t) => {
      let e = !1;
      if (!t || !H(t)) return {};
      const i = [];
      for (let s of t.match(cr))
        (s = s.trim().replace(hr, "$1 *")),
          e || (e = ["!", "+", "~", "-", ">"].includes(s[0])),
          i.push(s);
      return { selector: i.join(","), selectors: i, isContextSelector: e };
    }),
    ur = /(\([^)]*\)|\S)*/,
    Gs = ct((t) => {
      t = t.slice(1).trim();
      const [e] = t.match(ur);
      return [e, t.slice(e.length + 1)];
    });
  function Xs(t, e = document, i) {
    const s = Ys(t);
    if (!s.isContextSelector) return s.selector ? Yi(e, i, s.selector) : t;
    t = "";
    const n = s.selectors.length === 1;
    for (let o of s.selectors) {
      let r,
        a = e;
      if (
        (o[0] === "!" &&
          (([r, o] = Gs(o)), (a = e.parentElement.closest(r)), !o && n)) ||
        (a &&
          o[0] === "-" &&
          (([r, o] = Gs(o)),
          (a = a.previousElementSibling),
          (a = C(a, r) ? a : null),
          !o && n))
      )
        return a;
      if (a) {
        if (n)
          return (
            o[0] === "~" || o[0] === "+"
              ? ((o = `:scope > :nth-child(${yt(a) + 1}) ${o}`),
                (a = a.parentElement))
              : o[0] === ">" && (o = `:scope ${o}`),
            Yi(a, i, o)
          );
        t += `${t ? "," : ""}${dr(a)} ${o}`;
      }
    }
    return Te(e) || (e = e.ownerDocument), Yi(e, i, t);
  }
  function Yi(t, e, i) {
    try {
      return t[e](i);
    } catch {
      return null;
    }
  }
  function dr(t) {
    const e = [];
    for (; t.parentNode; ) {
      const i = p(t, "id");
      if (i) {
        e.unshift(`#${Gi(i)}`);
        break;
      } else {
        let { tagName: s } = t;
        s !== "HTML" && (s += `:nth-child(${yt(t) + 1})`),
          e.unshift(s),
          (t = t.parentNode);
      }
    }
    return e.join(" > ");
  }
  function Gi(t) {
    return H(t) ? CSS.escape(t) : "";
  }
  function y(...t) {
    let [e, i, s, n, o = !1] = Xi(t);
    n.length > 1 && (n = pr(n)),
      o != null && o.self && (n = gr(n)),
      s && (n = fr(s, n));
    for (const r of i) for (const a of e) a.addEventListener(r, n, o);
    return () => Rt(e, i, n, o);
  }
  function Rt(...t) {
    let [e, i, , s, n = !1] = Xi(t);
    for (const o of i) for (const r of e) r.removeEventListener(o, s, n);
  }
  function z(...t) {
    const [e, i, s, n, o = !1, r] = Xi(t),
      a = y(
        e,
        i,
        s,
        (l) => {
          const c = !r || r(l);
          c && (a(), n(l, c));
        },
        o
      );
    return a;
  }
  function v(t, e, i) {
    return Ji(t).every((s) => s.dispatchEvent(de(e, !0, !0, i)));
  }
  function de(t, e = !0, i = !1, s) {
    return (
      H(t) &&
        (t = new CustomEvent(t, { bubbles: e, cancelable: i, detail: s })),
      t
    );
  }
  function Xi(t) {
    return (
      (t[0] = Ji(t[0])),
      H(t[1]) && (t[1] = t[1].split(" ")),
      nt(t[2]) && t.splice(2, 0, !1),
      t
    );
  }
  function fr(t, e) {
    return (i) => {
      const s =
        t[0] === ">"
          ? Me(t, i.currentTarget)
              .reverse()
              .find((n) => n.contains(i.target))
          : i.target.closest(t);
      s && ((i.current = s), e.call(this, i), delete i.current);
    };
  }
  function pr(t) {
    return (e) => (J(e.detail) ? t(e, ...e.detail) : t(e));
  }
  function gr(t) {
    return function (e) {
      if (e.target === e.currentTarget || e.target === e.current)
        return t.call(null, e);
    };
  }
  function Js(t) {
    return t && "addEventListener" in t;
  }
  function mr(t) {
    return Js(t) ? t : R(t);
  }
  function Ji(t) {
    return J(t) ? t.map(mr).filter(Boolean) : H(t) ? Me(t) : Js(t) ? [t] : T(t);
  }
  function pt(t) {
    return t.pointerType === "touch" || !!t.touches;
  }
  function kt(t) {
    var e, i;
    const { clientX: s, clientY: n } =
      ((e = t.touches) == null ? void 0 : e[0]) ||
      ((i = t.changedTouches) == null ? void 0 : i[0]) ||
      t;
    return { x: s, y: n };
  }
  const vr = {
    "animation-iteration-count": !0,
    "column-count": !0,
    "fill-opacity": !0,
    "flex-grow": !0,
    "flex-shrink": !0,
    "font-weight": !0,
    "line-height": !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    "stroke-dasharray": !0,
    "stroke-dashoffset": !0,
    widows: !0,
    "z-index": !0,
    zoom: !0,
  };
  function h(t, e, i, s) {
    const n = T(t);
    for (const o of n)
      if (H(e)) {
        if (((e = hi(e)), X(i))) return getComputedStyle(o).getPropertyValue(e);
        o.style.setProperty(
          e,
          vt(i) && !vr[e] ? `${i}px` : i || Ce(i) ? i : "",
          s
        );
      } else if (J(e)) {
        const r = {};
        for (const a of e) r[a] = h(o, a);
        return r;
      } else if (Tt(e)) for (const r in e) h(o, r, e[r], i);
    return n[0];
  }
  const hi = ct((t) => {
      if (mt(t, "--")) return t;
      t = Bt(t);
      const { style: e } = document.documentElement;
      if (t in e) return t;
      for (const i of ["webkit", "moz"]) {
        const s = `-${i}-${t}`;
        if (s in e) return s;
      }
    }),
    Ki = "uk-transition",
    Zi = "transitionend",
    Qi = "transitioncanceled";
  function br(t, e, i = 400, s = "linear") {
    return (
      (i = Math.round(i)),
      Promise.all(
        T(t).map(
          (n) =>
            new Promise((o, r) => {
              for (const l in e) h(n, l);
              const a = setTimeout(() => v(n, Zi), i);
              z(
                n,
                [Zi, Qi],
                ({ type: l }) => {
                  clearTimeout(a),
                    _(n, Ki),
                    h(n, {
                      transitionProperty: "",
                      transitionDuration: "",
                      transitionTimingFunction: "",
                    }),
                    l === Qi ? r() : o(n);
                },
                { self: !0 }
              ),
                S(n, Ki),
                h(n, {
                  transitionProperty: Object.keys(e).map(hi).join(","),
                  transitionDuration: `${i}ms`,
                  transitionTimingFunction: s,
                  ...e,
                });
            })
        )
      )
    );
  }
  const N = {
      start: br,
      async stop(t) {
        v(t, Zi), await Promise.resolve();
      },
      async cancel(t) {
        v(t, Qi), await Promise.resolve();
      },
      inProgress(t) {
        return $(t, Ki);
      },
    },
    Be = "uk-animation",
    Ks = "animationend",
    ci = "animationcanceled";
  function Zs(t, e, i = 200, s, n) {
    return Promise.all(
      T(t).map(
        (o) =>
          new Promise((r, a) => {
            $(o, Be) && v(o, ci);
            const l = [
                e,
                Be,
                `${Be}-${n ? "leave" : "enter"}`,
                s && `uk-transform-origin-${s}`,
                n && `${Be}-reverse`,
              ],
              c = setTimeout(() => v(o, Ks), i);
            z(
              o,
              [Ks, ci],
              ({ type: u }) => {
                clearTimeout(c),
                  u === ci ? a() : r(o),
                  h(o, "animationDuration", ""),
                  _(o, l);
              },
              { self: !0 }
            ),
              h(o, "animationDuration", `${i}ms`),
              S(o, l);
          })
      )
    );
  }
  const Pt = {
    in: Zs,
    out(t, e, i, s) {
      return Zs(t, e, i, s, !0);
    },
    inProgress(t) {
      return $(t, Be);
    },
    cancel(t) {
      v(t, ci);
    },
  };
  function wr(t) {
    if (document.readyState !== "loading") {
      t();
      return;
    }
    z(document, "DOMContentLoaded", t);
  }
  function F(t, ...e) {
    return e.some((i) => {
      var s;
      return (
        ((s = t == null ? void 0 : t.tagName) == null
          ? void 0
          : s.toLowerCase()) === i.toLowerCase()
      );
    });
  }
  function Qs(t) {
    return (t = x(t)), t && (t.innerHTML = ""), t;
  }
  function bt(t, e) {
    return X(e) ? x(t).innerHTML : W(Qs(t), e);
  }
  const xr = fi("prepend"),
    W = fi("append"),
    ui = fi("before"),
    di = fi("after");
  function fi(t) {
    return function (e, i) {
      var s;
      const n = T(H(i) ? St(i) : i);
      return (s = x(e)) == null || s[t](...n), tn(n);
    };
  }
  function Q(t) {
    T(t).forEach((e) => e.remove());
  }
  function Ne(t, e) {
    for (e = R(ui(t, e)); e.firstElementChild; ) e = e.firstElementChild;
    return W(e, t), e;
  }
  function ts(t, e) {
    return T(
      T(t).map((i) => (i.hasChildNodes() ? Ne(ie(i.childNodes), e) : W(i, e)))
    );
  }
  function ze(t) {
    T(t)
      .map(O)
      .filter((e, i, s) => s.indexOf(e) === i)
      .forEach((e) => e.replaceWith(...e.childNodes));
  }
  const $r = /^<(\w+)\s*\/?>(?:<\/\1>)?$/;
  function St(t) {
    const e = $r.exec(t);
    if (e) return document.createElement(e[1]);
    const i = document.createElement("template");
    return (i.innerHTML = t.trim()), tn(i.content.childNodes);
  }
  function tn(t) {
    return t.length > 1 ? t : t[0];
  }
  function _t(t, e) {
    if (se(t))
      for (e(t), t = t.firstElementChild; t; )
        _t(t, e), (t = t.nextElementSibling);
  }
  function x(t, e) {
    return en(t) ? R(St(t)) : Vi(t, e);
  }
  function D(t, e) {
    return en(t) ? T(St(t)) : Me(t, e);
  }
  function en(t) {
    return H(t) && mt(t.trim(), "<");
  }
  const qt = { width: ["left", "right"], height: ["top", "bottom"] };
  function m(t) {
    const e = se(t)
      ? R(t).getBoundingClientRect()
      : { height: et(t), width: pi(t), top: 0, left: 0 };
    return {
      height: e.height,
      width: e.width,
      top: e.top,
      left: e.left,
      bottom: e.top + e.height,
      right: e.left + e.width,
    };
  }
  function E(t, e) {
    e && h(t, { left: 0, top: 0 });
    const i = m(t);
    if (t) {
      const { scrollY: s, scrollX: n } = zt(t),
        o = { height: s, width: n };
      for (const r in qt) for (const a of qt[r]) i[a] += o[r];
    }
    if (!e) return i;
    for (const s of ["left", "top"]) h(t, s, e[s] - i[s]);
  }
  function es(t) {
    let { top: e, left: i } = E(t);
    const {
      ownerDocument: { body: s, documentElement: n },
      offsetParent: o,
    } = R(t);
    let r = o || n;
    for (; r && (r === s || r === n) && h(r, "position") === "static"; )
      r = r.parentNode;
    if (se(r)) {
      const a = E(r);
      (e -= a.top + k(h(r, "borderTopWidth"))),
        (i -= a.left + k(h(r, "borderLeftWidth")));
    }
    return { top: e - k(h(t, "marginTop")), left: i - k(h(t, "marginLeft")) };
  }
  function Fe(t) {
    t = R(t);
    const e = [t.offsetTop, t.offsetLeft];
    for (; (t = t.offsetParent); )
      if (
        ((e[0] += t.offsetTop + k(h(t, "borderTopWidth"))),
        (e[1] += t.offsetLeft + k(h(t, "borderLeftWidth"))),
        h(t, "position") === "fixed")
      ) {
        const i = zt(t);
        return (e[0] += i.scrollY), (e[1] += i.scrollX), e;
      }
    return e;
  }
  const et = sn("height"),
    pi = sn("width");
  function sn(t) {
    const e = Nt(t);
    return (i, s) => {
      if (X(s)) {
        if (Qe(i)) return i[`inner${e}`];
        if (Te(i)) {
          const n = i.documentElement;
          return Math.max(n[`offset${e}`], n[`scroll${e}`]);
        }
        return (
          (i = R(i)),
          (s = h(i, t)),
          (s = s === "auto" ? i[`offset${e}`] : k(s) || 0),
          s - fe(i, t)
        );
      } else return h(i, t, !s && s !== 0 ? "" : +s + fe(i, t) + "px");
    };
  }
  function fe(t, e, i = "border-box") {
    return h(t, "boxSizing") === i
      ? Ht(qt[e], (s) => k(h(t, `padding-${s}`)) + k(h(t, `border-${s}-width`)))
      : 0;
  }
  function gi(t) {
    for (const e in qt)
      for (const i in qt[e]) if (qt[e][i] === t) return qt[e][1 - i];
    return t;
  }
  function G(t, e = "width", i = window, s = !1) {
    return H(t)
      ? Ht(kr(t), (n) => {
          const o = Ir(n);
          return o
            ? Tr(
                o === "vh"
                  ? Er()
                  : o === "vw"
                  ? pi(zt(i))
                  : s
                  ? i[`offset${Nt(e)}`]
                  : m(i)[e],
                n
              )
            : n;
        })
      : k(t);
  }
  const yr = /-?\d+(?:\.\d+)?(?:v[wh]|%|px)?/g,
    kr = ct((t) => t.toString().replace(/\s/g, "").match(yr) || []),
    Sr = /(?:v[hw]|%)$/,
    Ir = ct((t) => (t.match(Sr) || [])[0]);
  function Tr(t, e) {
    return (t * k(e)) / 100;
  }
  let He, pe;
  function Er() {
    return (
      He ||
      (pe ||
        ((pe = x("<div>")),
        h(pe, { height: "100vh", position: "fixed" }),
        y(window, "resize", () => (He = null))),
      W(document.body, pe),
      (He = pe.clientHeight),
      Q(pe),
      He)
    );
  }
  const At = { read: Cr, write: Pr, clear: _r, flush: nn },
    mi = [],
    vi = [];
  function Cr(t) {
    return mi.push(t), ss(), t;
  }
  function Pr(t) {
    return vi.push(t), ss(), t;
  }
  function _r(t) {
    rn(mi, t), rn(vi, t);
  }
  let is = !1;
  function nn() {
    on(mi), on(vi.splice(0)), (is = !1), (mi.length || vi.length) && ss();
  }
  function ss() {
    is || ((is = !0), queueMicrotask(nn));
  }
  function on(t) {
    let e;
    for (; (e = t.shift()); )
      try {
        e();
      } catch (i) {
        console.error(i);
      }
  }
  function rn(t, e) {
    const i = t.indexOf(e);
    return ~i && t.splice(i, 1);
  }
  class an {
    init() {
      this.positions = [];
      let e;
      (this.unbind = y(document, "mousemove", (i) => (e = kt(i)))),
        (this.interval = setInterval(() => {
          e &&
            (this.positions.push(e),
            this.positions.length > 5 && this.positions.shift());
        }, 50));
    }
    cancel() {
      var e;
      (e = this.unbind) == null || e.call(this), clearInterval(this.interval);
    }
    movesTo(e) {
      if (!this.positions || this.positions.length < 2) return !1;
      const i = m(e),
        { left: s, right: n, top: o, bottom: r } = i,
        [a] = this.positions,
        l = Ft(this.positions),
        c = [a, l];
      return si(l, i)
        ? !1
        : [
            [
              { x: s, y: o },
              { x: n, y: r },
            ],
            [
              { x: s, y: r },
              { x: n, y: o },
            ],
          ].some((d) => {
            const f = Ar(c, d);
            return f && si(f, i);
          });
    }
  }
  function Ar(
    [{ x: t, y: e }, { x: i, y: s }],
    [{ x: n, y: o }, { x: r, y: a }]
  ) {
    const l = (a - o) * (i - t) - (r - n) * (s - e);
    if (l === 0) return !1;
    const c = ((r - n) * (e - o) - (a - o) * (t - n)) / l;
    return c < 0 ? !1 : { x: t + c * (i - t), y: e + c * (s - e) };
  }
  function ln(t, e, i = {}, { intersecting: s = !0 } = {}) {
    const n = new IntersectionObserver(
      s
        ? (o, r) => {
            o.some((a) => a.isIntersecting) && e(o, r);
          }
        : e,
      i
    );
    for (const o of T(t)) n.observe(o);
    return n;
  }
  const Or = Wt && window.ResizeObserver;
  function Le(t, e, i = { box: "border-box" }) {
    if (Or) return hn(ResizeObserver, t, e, i);
    const s = [
      y(window, "load resize", e),
      y(document, "loadedmetadata load", e, !0),
    ];
    return { disconnect: () => s.map((n) => n()) };
  }
  function ns(t) {
    return { disconnect: y([window, window.visualViewport], "resize", t) };
  }
  function os(t, e, i) {
    return hn(MutationObserver, t, e, i);
  }
  function hn(t, e, i, s) {
    const n = new t(i);
    for (const o of T(e)) n.observe(o, s);
    return n;
  }
  function rs(t) {
    ls(t) && hs(t, { func: "playVideo", method: "play" }),
      as(t) && t.play().catch(A);
  }
  function bi(t) {
    ls(t) && hs(t, { func: "pauseVideo", method: "pause" }), as(t) && t.pause();
  }
  function cn(t) {
    ls(t) && hs(t, { func: "mute", method: "setVolume", value: 0 }),
      as(t) && (t.muted = !0);
  }
  function as(t) {
    return F(t, "video");
  }
  function ls(t) {
    return F(t, "iframe") && (un(t) || dn(t));
  }
  function un(t) {
    return !!t.src.match(
      /\/\/.*?youtube(-nocookie)?\.[a-z]+\/(watch\?v=[^&\s]+|embed)|youtu\.be\/.*/
    );
  }
  function dn(t) {
    return !!t.src.match(/vimeo\.com\/video\/.*/);
  }
  async function hs(t, e) {
    await Mr(t), fn(t, e);
  }
  function fn(t, e) {
    t.contentWindow.postMessage(
      JSON.stringify({ event: "command", ...e }),
      "*"
    );
  }
  const cs = "_ukPlayer";
  let Dr = 0;
  function Mr(t) {
    if (t[cs]) return t[cs];
    const e = un(t),
      i = dn(t),
      s = ++Dr;
    let n;
    return (t[cs] = new Promise((o) => {
      e &&
        z(t, "load", () => {
          const r = () => fn(t, { event: "listening", id: s });
          (n = setInterval(r, 100)), r();
        }),
        z(window, "message", o, !1, ({ data: r }) => {
          try {
            return (
              (r = JSON.parse(r)),
              (e &&
                (r == null ? void 0 : r.id) === s &&
                r.event === "onReady") ||
                (i && Number(r == null ? void 0 : r.player_id) === s)
            );
          } catch {}
        }),
        (t.src = `${t.src}${b(t.src, "?") ? "&" : "?"}${
          e ? "enablejsapi=1" : `api=1&player_id=${s}`
        }`);
    }).then(() => clearInterval(n)));
  }
  function Br(t, e = 0, i = 0) {
    return q(t)
      ? ii(
          ...Vt(t)
            .map((s) => {
              const { top: n, left: o, bottom: r, right: a } = rt(s);
              return { top: n - e, left: o - i, bottom: r + e, right: a + i };
            })
            .concat(E(t))
        )
      : !1;
  }
  function pn(t, { offset: e = 0 } = {}) {
    const i = q(t) ? Ut(t, !1, ["hidden"]) : [];
    return i.reduce(
      (r, a, l) => {
        const { scrollTop: c, scrollHeight: u, offsetHeight: d } = a,
          f = rt(a),
          g = u - f.height,
          { height: w, top: I } = i[l - 1] ? rt(i[l - 1]) : E(t);
        let P = Math.ceil(I - f.top - e + c);
        return (
          e > 0 && d < w + e ? (P += e) : (e = 0),
          P > g ? ((e -= P - g), (P = g)) : P < 0 && ((e -= P), (P = 0)),
          () => s(a, P - c, t, g).then(r)
        );
      },
      () => Promise.resolve()
    )();
    function s(r, a, l, c) {
      return new Promise((u) => {
        const d = r.scrollTop,
          f = n(Math.abs(a)),
          g = Date.now(),
          w = fs(r) === r,
          I = E(l).top + (w ? 0 : d);
        let P = 0,
          ht = 15;
        (function It() {
          const Mt = o(K((Date.now() - g) / f));
          let wt = 0;
          i[0] === r &&
            d + a < c &&
            (wt = E(l).top + (w ? 0 : r.scrollTop) - I - m(us(l)).height),
            h(r, "scrollBehavior") !== "auto" && h(r, "scrollBehavior", "auto"),
            (r.scrollTop = d + (a + wt) * Mt),
            h(r, "scrollBehavior", ""),
            Mt === 1 && (P === wt || !ht--)
              ? u()
              : ((P = wt), requestAnimationFrame(It));
        })();
      });
    }
    function n(r) {
      return 40 * Math.pow(r, 0.375);
    }
    function o(r) {
      return 0.5 * (1 - Math.cos(Math.PI * r));
    }
  }
  function wi(t, e = 0, i = 0) {
    if (!q(t)) return 0;
    const s = Ot(t, !0),
      { scrollHeight: n, scrollTop: o } = s,
      { height: r } = rt(s),
      a = n - r,
      l = Fe(t)[0] - Fe(s)[0],
      c = Math.max(0, l - r + e),
      u = Math.min(a, l + t.offsetHeight - i);
    return c < u ? K((o - c) / (u - c)) : 1;
  }
  function Ut(t, e = !1, i = []) {
    const s = fs(t);
    let n = ce(t).reverse();
    n = n.slice(n.indexOf(s) + 1);
    const o = xt(n, (r) => h(r, "position") === "fixed");
    return (
      ~o && (n = n.slice(o)),
      [s]
        .concat(
          n.filter(
            (r) =>
              h(r, "overflow")
                .split(" ")
                .some((a) => b(["auto", "scroll", ...i], a)) &&
              (!e || r.scrollHeight > rt(r).height)
          )
        )
        .reverse()
    );
  }
  function Ot(...t) {
    return Ut(...t)[0];
  }
  function Vt(t) {
    return Ut(t, !1, ["hidden", "clip"]);
  }
  function rt(t) {
    const e = zt(t),
      i = fs(t),
      s = !Ee(t) || t.contains(i);
    if (s && e.visualViewport) {
      let {
        height: l,
        width: c,
        scale: u,
        pageTop: d,
        pageLeft: f,
      } = e.visualViewport;
      return (
        (l = Math.round(l * u)),
        (c = Math.round(c * u)),
        { height: l, width: c, top: d, left: f, bottom: d + l, right: f + c }
      );
    }
    let n = E(s ? e : t);
    if (h(t, "display") === "inline") return n;
    const { body: o, documentElement: r } = e.document,
      a = s ? (i === r || i.clientHeight < o.clientHeight ? i : o) : t;
    for (let [l, c, u, d] of [
      ["width", "x", "left", "right"],
      ["height", "y", "top", "bottom"],
    ]) {
      const f = n[l] % 1;
      (n[u] += k(h(a, `border-${u}-width`))),
        (n[l] = n[c] = a[`client${Nt(l)}`] - (f ? (f < 0.5 ? -f : 1 - f) : 0)),
        (n[d] = n[l] + n[u]);
    }
    return n;
  }
  function us(t) {
    const { left: e, width: i, top: s } = m(t);
    for (const n of s ? [0, s] : [0]) {
      let o;
      for (const r of zt(t).document.elementsFromPoint(e + i / 2, n))
        !r.contains(t) &&
          !$(r, "uk-togglable-leave") &&
          ((ds(r, "fixed") &&
            gn(
              ce(t)
                .reverse()
                .find((a) => !a.contains(r) && !ds(a, "static"))
            ) < gn(r)) ||
            (ds(r, "sticky") && O(r).contains(t))) &&
          (!o || m(o).height < m(r).height) &&
          (o = r);
      if (o) return o;
    }
  }
  function gn(t) {
    return k(h(t, "zIndex"));
  }
  function ds(t, e) {
    return h(t, "position") === e;
  }
  function fs(t) {
    return zt(t).document.scrollingElement;
  }
  const at = [
    ["width", "x", "left", "right"],
    ["height", "y", "top", "bottom"],
  ];
  function mn(t, e, i) {
    (i = {
      attach: {
        element: ["left", "top"],
        target: ["left", "top"],
        ...i.attach,
      },
      offset: [0, 0],
      placement: [],
      ...i,
    }),
      J(e) || (e = [e, e]),
      E(t, vn(t, e, i));
  }
  function vn(t, e, i) {
    const s = bn(t, e, i),
      { boundary: n, viewportOffset: o = 0, placement: r } = i;
    let a = s;
    for (const [l, [c, , u, d]] of Object.entries(at)) {
      const f = Nr(t, e[l], o, n, l);
      if (xi(s, f, l)) continue;
      let g = 0;
      if (r[l] === "flip") {
        const w = i.attach.target[l];
        if ((w === d && s[d] <= f[d]) || (w === u && s[u] >= f[u])) continue;
        g = Fr(t, e, i, l)[u] - s[u];
        const I = zr(t, e[l], o, l);
        if (!xi(ps(s, g, l), I, l)) {
          if (xi(s, I, l)) continue;
          if (i.recursion) return !1;
          const P = Hr(t, e, i);
          if (P && xi(P, I, 1 - l)) return P;
          continue;
        }
      } else if (r[l] === "shift") {
        const w = E(e[l]),
          { offset: I } = i;
        g =
          K(K(s[u], f[u], f[d] - s[c]), w[u] - s[c] + I[l], w[d] - I[l]) - s[u];
      }
      a = ps(a, g, l);
    }
    return a;
  }
  function bn(t, e, i) {
    let { attach: s, offset: n } = {
        attach: {
          element: ["left", "top"],
          target: ["left", "top"],
          ...i.attach,
        },
        offset: [0, 0],
        ...i,
      },
      o = E(t);
    for (const [r, [a, , l, c]] of Object.entries(at)) {
      const u = s.target[r] === s.element[r] ? rt(e[r]) : E(e[r]);
      o = ps(
        o,
        u[l] -
          o[l] +
          wn(s.target[r], c, u[a]) -
          wn(s.element[r], c, o[a]) +
          +n[r],
        r
      );
    }
    return o;
  }
  function ps(t, e, i) {
    const [, s, n, o] = at[i],
      r = { ...t };
    return (r[n] = t[s] = t[n] + e), (r[o] += e), r;
  }
  function wn(t, e, i) {
    return t === "center" ? i / 2 : t === e ? i : 0;
  }
  function Nr(t, e, i, s, n) {
    let o = $n(...xn(t, e).map(rt));
    return (
      i && ((o[at[n][2]] += i), (o[at[n][3]] -= i)),
      s && (o = $n(o, E(J(s) ? s[n] : s))),
      o
    );
  }
  function zr(t, e, i, s) {
    const [n, o, r, a] = at[s],
      [l] = xn(t, e),
      c = rt(l);
    return (
      ["auto", "scroll"].includes(h(l, `overflow-${o}`)) &&
        ((c[r] -= l[`scroll${Nt(r)}`]), (c[a] = c[r] + l[`scroll${Nt(n)}`])),
      (c[r] += i),
      (c[a] -= i),
      c
    );
  }
  function xn(t, e) {
    return Vt(e).filter((i) => i.contains(t));
  }
  function $n(...t) {
    let e = {};
    for (const i of t)
      for (const [, , s, n] of at)
        (e[s] = Math.max(e[s] || 0, i[s])),
          (e[n] = Math.min(...[e[n], i[n]].filter(Boolean)));
    return e;
  }
  function xi(t, e, i) {
    const [, , s, n] = at[i];
    return t[s] >= e[s] && t[n] <= e[n];
  }
  function Fr(t, e, { offset: i, attach: s }, n) {
    return bn(t, e, {
      attach: { element: yn(s.element, n), target: yn(s.target, n) },
      offset: Lr(i, n),
    });
  }
  function Hr(t, e, i) {
    return vn(t, e, {
      ...i,
      attach: {
        element: i.attach.element.map(kn).reverse(),
        target: i.attach.target.map(kn).reverse(),
      },
      offset: i.offset.reverse(),
      placement: i.placement.reverse(),
      recursion: !0,
    });
  }
  function yn(t, e) {
    const i = [...t],
      s = at[e].indexOf(t[e]);
    return ~s && (i[e] = at[e][1 - (s % 2) + 2]), i;
  }
  function kn(t) {
    for (let e = 0; e < at.length; e++) {
      const i = at[e].indexOf(t);
      if (~i) return at[1 - e][(i % 2) + 2];
    }
  }
  function Lr(t, e) {
    return (t = [...t]), (t[e] *= -1), t;
  }
  var Wr = Object.freeze({
      __proto__: null,
      $: x,
      $$: D,
      Animation: Pt,
      Dimensions: Ri,
      MouseTracker: an,
      Transition: N,
      addClass: S,
      after: di,
      append: W,
      apply: _t,
      assign: ft,
      attr: p,
      before: ui,
      boxModelAdjust: fe,
      camelize: Se,
      children: B,
      clamp: K,
      createEvent: de,
      css: h,
      data: Z,
      dimensions: m,
      each: oe,
      empty: Qs,
      endsWith: ee,
      escape: Gi,
      fastdom: At,
      filter: Oe,
      find: Vi,
      findAll: Me,
      findIndex: xt,
      flipPosition: gi,
      fragment: St,
      getCoveringElement: us,
      getEventPos: kt,
      getIndex: ot,
      getTargetedElement: Ui,
      hasAttr: Et,
      hasClass: $,
      hasOwn: gt,
      hasTouch: re,
      height: et,
      html: bt,
      hyphenate: Bt,
      inBrowser: Wt,
      includes: b,
      index: yt,
      intersectRect: ii,
      isArray: J,
      isBoolean: ne,
      isDocument: Te,
      isElement: se,
      isEmpty: ti,
      isEqual: Pe,
      isFocusable: li,
      isFunction: nt,
      isInView: Br,
      isInput: ai,
      isNode: Ee,
      isNumber: Ce,
      isNumeric: vt,
      isObject: Tt,
      isPlainObject: Ie,
      isRtl: U,
      isSameSiteAnchor: ue,
      isString: H,
      isTag: F,
      isTouch: pt,
      isUndefined: X,
      isVisible: q,
      isVoidElement: qi,
      isWindow: Qe,
      last: Ft,
      matches: C,
      memoize: ct,
      mute: cn,
      noop: A,
      observeIntersection: ln,
      observeMutation: os,
      observeResize: Le,
      observeViewportResize: ns,
      off: Rt,
      offset: E,
      offsetPosition: Fe,
      offsetViewport: rt,
      on: y,
      once: z,
      overflowParents: Vt,
      parent: O,
      parents: ce,
      pause: bi,
      pick: ei,
      play: rs,
      pointInRect: si,
      pointerCancel: ri,
      pointerDown: ut,
      pointerEnter: jt,
      pointerLeave: le,
      pointerMove: oi,
      pointerUp: Ct,
      position: es,
      positionAt: mn,
      prepend: xr,
      propName: hi,
      query: tt,
      queryAll: De,
      ready: wr,
      remove: Q,
      removeAttr: _e,
      removeClass: _,
      replaceClass: ni,
      scrollIntoView: pn,
      scrollParent: Ot,
      scrollParents: Ut,
      scrolledOver: wi,
      selFocusable: he,
      selInput: Ae,
      sortBy: Rs,
      startsWith: mt,
      sumBy: Ht,
      swap: Wi,
      toArray: ie,
      toBoolean: Li,
      toEventTargets: Ji,
      toFloat: k,
      toNode: R,
      toNodes: T,
      toNumber: $t,
      toPx: G,
      toWindow: zt,
      toggleClass: L,
      trigger: v,
      ucfirst: Nt,
      uniqueBy: qs,
      unwrap: ze,
      width: pi,
      wrapAll: Ne,
      wrapInner: ts,
    }),
    it = {
      connected() {
        S(this.$el, this.$options.id);
      },
    };
  const jr = ["days", "hours", "minutes", "seconds"];
  var Rr = {
    mixins: [it],
    props: { date: String, clsWrapper: String, role: String, reload: Boolean },
    data: {
      date: "",
      clsWrapper: ".uk-countdown-%unit%",
      role: "timer",
      reload: !1,
    },
    connected() {
      p(this.$el, "role", this.role),
        (this.date = k(Date.parse(this.$props.date))),
        (this.started = this.end = !1),
        this.start();
    },
    disconnected() {
      this.stop();
    },
    events: {
      name: "visibilitychange",
      el: () => document,
      handler() {
        document.hidden ? this.stop() : this.start();
      },
    },
    methods: {
      start() {
        this.stop(), this.update();
      },
      stop() {
        this.timer &&
          (clearInterval(this.timer),
          v(this.$el, "countdownstop"),
          (this.timer = null));
      },
      update() {
        const t = qr(this.date);
        t.total
          ? this.timer ||
            ((this.started = !0),
            (this.timer = setInterval(this.update, 1e3)),
            v(this.$el, "countdownstart"))
          : (this.stop(),
            this.end ||
              (v(this.$el, "countdownend"),
              (this.end = !0),
              this.reload && this.started && window.location.reload()));
        for (const e of jr) {
          const i = x(this.clsWrapper.replace("%unit%", e), this.$el);
          if (!i) continue;
          let s = Math.trunc(t[e]).toString().padStart(2, "0");
          i.textContent !== s &&
            ((s = s.split("")),
            s.length !== i.children.length &&
              bt(i, s.map(() => "<span></span>").join("")),
            s.forEach((n, o) => (i.children[o].textContent = n)));
        }
      },
    },
  };
  function qr(t) {
    const e = Math.max(0, t - Date.now()) / 1e3;
    return {
      total: e,
      seconds: e % 60,
      minutes: (e / 60) % 60,
      hours: (e / 60 / 60) % 24,
      days: e / 60 / 60 / 24,
    };
  }
  const V = {};
  (V.events =
    V.watch =
    V.observe =
    V.created =
    V.beforeConnect =
    V.connected =
    V.beforeDisconnect =
    V.disconnected =
    V.destroy =
      gs),
    (V.args = function (t, e) {
      return e !== !1 && gs(e || t);
    }),
    (V.update = function (t, e) {
      return Rs(gs(t, nt(e) ? { read: e } : e), "order");
    }),
    (V.props = function (t, e) {
      if (J(e)) {
        const i = {};
        for (const s of e) i[s] = String;
        e = i;
      }
      return V.methods(t, e);
    }),
    (V.computed = V.methods =
      function (t, e) {
        return e ? (t ? { ...t, ...e } : e) : t;
      }),
    (V.i18n = V.data =
      function (t, e, i) {
        return i
          ? Sn(t, e, i)
          : e
          ? t
            ? function (s) {
                return Sn(t, e, s);
              }
            : e
          : t;
      });
  function Sn(t, e, i) {
    return V.computed(nt(t) ? t.call(i, i) : t, nt(e) ? e.call(i, i) : e);
  }
  function gs(t, e) {
    return (
      (t = t && !J(t) ? [t] : t), e ? (t ? t.concat(e) : J(e) ? e : [e]) : t
    );
  }
  function Ur(t, e) {
    return X(e) ? t : e;
  }
  function We(t, e, i) {
    const s = {};
    if (
      (nt(e) && (e = e.options),
      e.extends && (t = We(t, e.extends, i)),
      e.mixins)
    )
      for (const o of e.mixins) t = We(t, o, i);
    for (const o in t) n(o);
    for (const o in e) gt(t, o) || n(o);
    function n(o) {
      s[o] = (V[o] || Ur)(t[o], e[o], i);
    }
    return s;
  }
  function ge(t, e = []) {
    try {
      return t
        ? mt(t, "{")
          ? JSON.parse(t)
          : e.length && !b(t, ":")
          ? { [e[0]]: t }
          : t.split(";").reduce((i, s) => {
              const [n, o] = s.split(/:(.*)/);
              return n && !X(o) && (i[n.trim()] = o.trim()), i;
            }, {})
        : {};
    } catch {
      return {};
    }
  }
  function ms(t, e) {
    return t === Boolean
      ? Li(e)
      : t === Number
      ? $t(e)
      : t === "list"
      ? Yr(e)
      : t === Object && H(e)
      ? ge(e)
      : t
      ? t(e)
      : e;
  }
  const Vr = /,(?![^(]*\))/;
  function Yr(t) {
    return J(t)
      ? t
      : H(t)
      ? t.split(Vr).map((e) => (vt(e) ? $t(e) : Li(e.trim())))
      : [t];
  }
  function Gr(t) {
    (t._data = {}),
      (t._updates = [...(t.$options.update || [])]),
      t._disconnect.push(() => (t._updates = t._data = null));
  }
  function Xr(t, e) {
    t._updates.unshift(e);
  }
  function je(t, e = "update") {
    t._connected &&
      t._updates.length &&
      (t._queued ||
        ((t._queued = new Set()),
        At.read(() => {
          t._connected && Jr(t, t._queued), (t._queued = null);
        })),
      t._queued.add(e.type || e));
  }
  function Jr(t, e) {
    for (const { read: i, write: s, events: n = [] } of t._updates) {
      if (!e.has("update") && !n.some((r) => e.has(r))) continue;
      let o;
      i && ((o = i.call(t, t._data, e)), o && Ie(o) && ft(t._data, o)),
        s &&
          o !== !1 &&
          At.write(() => {
            t._connected && s.call(t, t._data, e);
          });
    }
  }
  function dt(t) {
    return qe(Le, t, "resize");
  }
  function me(t) {
    return qe(ln, t);
  }
  function $i(t) {
    return qe(os, t);
  }
  function yi(t = {}) {
    return me({
      handler: function (e, i) {
        const { targets: s = this.$el, preload: n = 5 } = t;
        for (const o of T(nt(s) ? s(this) : s))
          D('[loading="lazy"]', o)
            .slice(0, n - 1)
            .forEach((r) => _e(r, "loading"));
        for (const o of e
          .filter(({ isIntersecting: r }) => r)
          .map(({ target: r }) => r))
          i.unobserve(o);
      },
      ...t,
    });
  }
  function vs(t) {
    return qe((e, i) => ns(i), t, "resize");
  }
  function Re(t) {
    return qe(
      (e, i) => ({ disconnect: y(Zr(e), "scroll", i, { passive: !0 }) }),
      t,
      "scroll"
    );
  }
  function In(t) {
    return {
      observe(e, i) {
        return {
          observe: A,
          unobserve: A,
          disconnect: y(e, ut, i, { passive: !0 }),
        };
      },
      handler(e) {
        if (!pt(e)) return;
        const i = kt(e),
          s = "tagName" in e.target ? e.target : O(e.target);
        z(document, `${Ct} ${ri} scroll`, (n) => {
          const { x: o, y: r } = kt(n);
          ((n.type !== "scroll" && s && o && Math.abs(i.x - o) > 100) ||
            (r && Math.abs(i.y - r) > 100)) &&
            setTimeout(() => {
              v(s, "swipe"), v(s, `swipe${Kr(i.x, i.y, o, r)}`);
            });
        });
      },
      ...t,
    };
  }
  function qe(t, e, i) {
    return {
      observe: t,
      handler() {
        je(this, i);
      },
      ...e,
    };
  }
  function Kr(t, e, i, s) {
    return Math.abs(t - i) >= Math.abs(e - s)
      ? t - i > 0
        ? "Left"
        : "Right"
      : e - s > 0
      ? "Up"
      : "Down";
  }
  function Zr(t) {
    return T(t).map((e) => {
      const { ownerDocument: i } = e,
        s = Ot(e, !0);
      return s === i.scrollingElement ? i : s;
    });
  }
  var Tn = {
    props: { margin: String, firstColumn: Boolean },
    data: { margin: "uk-margin-small-top", firstColumn: "uk-first-column" },
    observe: [
      $i({ options: { childList: !0 } }),
      $i({
        options: { attributes: !0, attributeFilter: ["style"] },
        target: ({ $el: t }) => [t, ...B(t)],
      }),
      dt({ target: ({ $el: t }) => [t, ...B(t)] }),
    ],
    update: {
      read() {
        return { rows: bs(B(this.$el)) };
      },
      write({ rows: t }) {
        for (const e of t)
          for (const i of e)
            L(i, this.margin, t[0] !== e),
              L(i, this.firstColumn, e[U ? e.length - 1 : 0] === i);
      },
      events: ["resize"],
    },
  };
  function bs(t) {
    const e = [[]],
      i = t.some((s, n) => n && t[n - 1].offsetParent !== s.offsetParent);
    for (const s of t) {
      if (!q(s)) continue;
      const n = ws(s, i);
      for (let o = e.length - 1; o >= 0; o--) {
        const r = e[o];
        if (!r[0]) {
          r.push(s);
          break;
        }
        const a = ws(r[0], i);
        if (n.top >= a.bottom - 1 && n.top !== a.top) {
          e.push([s]);
          break;
        }
        if (n.bottom - 1 > a.top || n.top === a.top) {
          let l = r.length - 1;
          for (; l >= 0; l--) {
            const c = ws(r[l], i);
            if (n.left >= c.left) break;
          }
          r.splice(l + 1, 0, s);
          break;
        }
        if (o === 0) {
          e.unshift([s]);
          break;
        }
      }
    }
    return e;
  }
  function ws(t, e = !1) {
    let { offsetTop: i, offsetLeft: s, offsetHeight: n, offsetWidth: o } = t;
    return (
      e && ([i, s] = Fe(t)), { top: i, left: s, bottom: i + n, right: s + o }
    );
  }
  async function Qr(t, e, i) {
    await xs();
    let s = B(e);
    const n = s.map((g) => En(g, !0)),
      o = { ...h(e, ["height", "padding"]), display: "block" },
      r = s.concat(e);
    await Promise.all(r.map(N.cancel)),
      h(r, "transitionProperty", "none"),
      await t(),
      (s = s.concat(B(e).filter((g) => !b(s, g)))),
      await Promise.resolve(),
      h(r, "transitionProperty", "");
    const a = p(e, "style"),
      l = h(e, ["height", "padding"]),
      [c, u] = ta(e, s, n),
      d = s.map((g) => ({ style: p(g, "style") }));
    s.forEach((g, w) => u[w] && h(g, u[w])),
      h(e, o),
      v(e, "scroll"),
      await xs();
    const f = s
      .map((g, w) => O(g) === e && N.start(g, c[w], i, "ease"))
      .concat(N.start(e, l, i, "ease"));
    try {
      await Promise.all(f),
        s.forEach((g, w) => {
          p(g, d[w]),
            O(g) === e && h(g, "display", c[w].opacity === 0 ? "none" : "");
        }),
        p(e, "style", a);
    } catch {
      p(s, "style", ""), ea(e, o);
    }
  }
  function En(t, e) {
    const i = h(t, "zIndex");
    return q(t)
      ? {
          display: "",
          opacity: e ? h(t, "opacity") : "0",
          pointerEvents: "none",
          position: "absolute",
          zIndex: i === "auto" ? yt(t) : i,
          ...Cn(t),
        }
      : !1;
  }
  function ta(t, e, i) {
    const s = e.map((o, r) =>
        O(o) && r in i
          ? i[r]
            ? q(o)
              ? Cn(o)
              : { opacity: 0 }
            : { opacity: q(o) ? 1 : 0 }
          : !1
      ),
      n = s.map((o, r) => {
        const a = O(e[r]) === t && (i[r] || En(e[r]));
        if (!a) return !1;
        if (!o) delete a.opacity;
        else if (!("opacity" in o)) {
          const { opacity: l } = a;
          l % 1 ? (o.opacity = 1) : delete a.opacity;
        }
        return a;
      });
    return [s, n];
  }
  function ea(t, e) {
    for (const i in e) h(t, i, "");
  }
  function Cn(t) {
    const { height: e, width: i } = m(t);
    return {
      height: e,
      width: i,
      transform: "",
      ...es(t),
      ...h(t, ["marginTop", "marginLeft"]),
    };
  }
  function xs() {
    return new Promise((t) => requestAnimationFrame(t));
  }
  const $s = "uk-transition-leave",
    ys = "uk-transition-enter";
  function Pn(t, e, i, s = 0) {
    const n = ki(e, !0),
      o = { opacity: 1 },
      r = { opacity: 0 },
      a = (u) => () => n === ki(e) ? u() : Promise.reject(),
      l = a(async () => {
        S(e, $s),
          await Promise.all(
            An(e).map(
              (u, d) =>
                new Promise((f) =>
                  setTimeout(() => N.start(u, r, i / 2, "ease").then(f), d * s)
                )
            )
          ),
          _(e, $s);
      }),
      c = a(async () => {
        const u = et(e);
        S(e, ys), t(), h(B(e), { opacity: 0 }), await xs();
        const d = B(e),
          f = et(e);
        h(e, "alignContent", "flex-start"), et(e, u);
        const g = An(e);
        h(d, r);
        const w = g.map(async (I, P) => {
          await ia(P * s), await N.start(I, o, i / 2, "ease");
        });
        u !== f &&
          w.push(N.start(e, { height: f }, i / 2 + g.length * s, "ease")),
          await Promise.all(w).then(() => {
            _(e, ys),
              n === ki(e) &&
                (h(e, { height: "", alignContent: "" }),
                h(d, { opacity: "" }),
                delete e.dataset.transition);
          });
      });
    return $(e, $s)
      ? _n(e).then(c)
      : $(e, ys)
      ? _n(e).then(l).then(c)
      : l().then(c);
  }
  function ki(t, e) {
    return (
      e && (t.dataset.transition = 1 + ki(t)), $t(t.dataset.transition) || 0
    );
  }
  function _n(t) {
    return Promise.all(
      B(t)
        .filter(N.inProgress)
        .map(
          (e) => new Promise((i) => z(e, "transitionend transitioncanceled", i))
        )
    );
  }
  function An(t) {
    return bs(B(t)).flat().filter(q);
  }
  function ia(t) {
    return new Promise((e) => setTimeout(e, t));
  }
  var On = {
    props: { duration: Number, animation: Boolean },
    data: { duration: 150, animation: "slide" },
    methods: {
      animate(t, e = this.$el) {
        const i = this.animation;
        return (
          i === "fade"
            ? Pn
            : i === "delayed-fade"
            ? (...n) => Pn(...n, 40)
            : i
            ? Qr
            : () => (t(), Promise.resolve())
        )(t, e, this.duration).catch(A);
      },
    },
  };
  const M = {
    TAB: 9,
    ESC: 27,
    SPACE: 32,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
  };
  var sa = {
    mixins: [On],
    args: "target",
    props: { target: String, selActive: Boolean },
    data: {
      target: "",
      selActive: !1,
      attrItem: "uk-filter-control",
      cls: "uk-active",
      duration: 250,
    },
    computed: {
      children: ({ target: t }, e) => D(`${t} > *`, e),
      toggles: ({ attrItem: t }, e) => D(`[${t}],[data-${t}]`, e),
    },
    watch: {
      toggles(t) {
        this.updateState();
        const e = D(this.selActive, this.$el);
        for (const i of t) {
          this.selActive !== !1 && L(i, this.cls, b(e, i));
          const s = la(i);
          F(s, "a") && p(s, "role", "button");
        }
      },
      children(t, e) {
        e && this.updateState();
      },
    },
    events: {
      name: "click keydown",
      delegate: ({ attrItem: t }) => `[${t}],[data-${t}]`,
      handler(t) {
        (t.type === "keydown" && t.keyCode !== M.SPACE) ||
          (t.target.closest("a,button") &&
            (t.preventDefault(), this.apply(t.current)));
      },
    },
    methods: {
      apply(t) {
        const e = this.getState(),
          i = Mn(t, this.attrItem, this.getState());
        na(e, i) || this.setState(i);
      },
      getState() {
        return this.toggles
          .filter((t) => $(t, this.cls))
          .reduce((t, e) => Mn(e, this.attrItem, t), {
            filter: { "": "" },
            sort: [],
          });
      },
      async setState(t, e = !0) {
        (t = { filter: { "": "" }, sort: [], ...t }),
          v(this.$el, "beforeFilter", [this, t]);
        for (const i of this.toggles) L(i, this.cls, ra(i, this.attrItem, t));
        await Promise.all(
          D(this.target, this.$el).map((i) => {
            const s = () => oa(t, i, B(i));
            return e ? this.animate(s, i) : s();
          })
        ),
          v(this.$el, "afterFilter", [this]);
      },
      updateState() {
        At.write(() => this.setState(this.getState(), !1));
      },
    },
  };
  function Dn(t, e) {
    return ge(Z(t, e), ["filter"]);
  }
  function na(t, e) {
    return ["filter", "sort"].every((i) => Pe(t[i], e[i]));
  }
  function oa(t, e, i) {
    for (const o of i)
      h(
        o,
        "display",
        Object.values(t.filter).every((r) => !r || C(o, r)) ? "" : "none"
      );
    const [s, n] = t.sort;
    if (s) {
      const o = aa(i, s, n);
      Pe(o, i) || W(e, o);
    }
  }
  function Mn(t, e, i) {
    const { filter: s, group: n, sort: o, order: r = "asc" } = Dn(t, e);
    return (
      (s || X(o)) &&
        (n
          ? s
            ? (delete i.filter[""], (i.filter[n] = s))
            : (delete i.filter[n],
              (ti(i.filter) || "" in i.filter) && (i.filter = { "": s || "" }))
          : (i.filter = { "": s || "" })),
      X(o) || (i.sort = [o, r]),
      i
    );
  }
  function ra(t, e, { filter: i = { "": "" }, sort: [s, n] }) {
    const {
      filter: o = "",
      group: r = "",
      sort: a,
      order: l = "asc",
    } = Dn(t, e);
    return X(a)
      ? (r in i && o === i[r]) || (!o && r && !(r in i) && !i[""])
      : s === a && n === l;
  }
  function aa(t, e, i) {
    return [...t].sort(
      (s, n) =>
        Z(s, e).localeCompare(Z(n, e), void 0, { numeric: !0 }) *
        (i === "asc" || -1)
    );
  }
  function la(t) {
    return x("a,button", t) || t;
  }
  var ha = {
    args: "dataSrc",
    props: {
      dataSrc: String,
      sources: String,
      margin: String,
      target: String,
      loading: String,
    },
    data: {
      dataSrc: "",
      sources: !1,
      margin: "50%",
      target: !1,
      loading: "lazy",
    },
    connected() {
      this.loading !== "lazy"
        ? this.load()
        : Ss(this.$el) && ((this.$el.loading = "lazy"), ks(this.$el));
    },
    disconnected() {
      this.img && (this.img.onload = ""), delete this.img;
    },
    observe: me({
      handler(t, e) {
        this.load(), e.disconnect();
      },
      options: ({ margin: t }) => ({ rootMargin: t }),
      filter: ({ loading: t }) => t === "lazy",
      target: ({ $el: t, $props: e }) =>
        e.target ? [t, ...De(e.target, t)] : t,
    }),
    methods: {
      load() {
        if (this.img) return this.img;
        const t = Ss(this.$el)
          ? this.$el
          : ua(this.$el, this.dataSrc, this.sources);
        return _e(t, "loading"), ks(this.$el, t.currentSrc), (this.img = t);
      },
    },
  };
  function ks(t, e) {
    if (Ss(t)) {
      const i = O(t);
      (F(i, "picture") ? B(i) : [t]).forEach((n) => Bn(n, n));
    } else e && !b(t.style.backgroundImage, e) && (h(t, "backgroundImage", `url(${Gi(e)})`), v(t, de("load", !1)));
  }
  const ca = ["data-src", "data-srcset", "sizes"];
  function Bn(t, e) {
    for (const i of ca) {
      const s = Z(t, i);
      s && p(e, i.replace(/data-/g, ""), s);
    }
  }
  function ua(t, e, i) {
    const s = new Image();
    return (
      Nn(s, i),
      Bn(t, s),
      (s.onload = () => ks(t, s.currentSrc)),
      p(s, "src", e),
      s
    );
  }
  function Nn(t, e) {
    if (((e = da(e)), e.length)) {
      const i = St("<picture>");
      for (const s of e) {
        const n = St("<source>");
        p(n, s), W(i, n);
      }
      W(i, t);
    }
  }
  function da(t) {
    if (!t) return [];
    if (mt(t, "["))
      try {
        t = JSON.parse(t);
      } catch {
        t = [];
      }
    else t = ge(t);
    return J(t) || (t = [t]), t.filter((e) => !ti(e));
  }
  function Ss(t) {
    return F(t, "img");
  }
  let Is;
  function zn(t) {
    const e = y(
      t,
      "touchstart",
      (s) => {
        if (s.targetTouches.length !== 1 || C(s.target, 'input[type="range"'))
          return;
        let n = kt(s).y;
        const o = y(
          t,
          "touchmove",
          (r) => {
            const a = kt(r).y;
            a !== n &&
              ((n = a),
              Ut(r.target).some((l) => {
                if (!t.contains(l)) return !1;
                let { scrollHeight: c, clientHeight: u } = l;
                return u < c;
              }) || r.preventDefault());
          },
          { passive: !1 }
        );
        z(t, "scroll touchend touchcanel", o, { capture: !0 });
      },
      { passive: !0 }
    );
    if (Is) return e;
    Is = !0;
    const { scrollingElement: i } = document;
    return (
      h(i, {
        overflowY: CSS.supports("overflow", "clip") ? "clip" : "hidden",
        touchAction: "none",
        paddingRight: pi(window) - i.clientWidth || "",
      }),
      () => {
        (Is = !1),
          e(),
          h(i, { overflowY: "", touchAction: "", paddingRight: "" });
      }
    );
  }
  var Ue = {
      props: { container: Boolean },
      data: { container: !0 },
      computed: {
        container({ container: t }) {
          return (t === !0 && this.$container) || (t && x(t));
        },
      },
    },
    Fn = {
      props: {
        pos: String,
        offset: Boolean,
        flip: Boolean,
        shift: Boolean,
        inset: Boolean,
      },
      data: {
        pos: `bottom-${U ? "right" : "left"}`,
        offset: !1,
        flip: !0,
        shift: !0,
        inset: !1,
      },
      connected() {
        (this.pos = this.$props.pos.split("-").concat("center").slice(0, 2)),
          ([this.dir, this.align] = this.pos),
          (this.axis = b(["top", "bottom"], this.dir) ? "y" : "x");
      },
      methods: {
        positionAt(t, e, i) {
          let s = [this.getPositionOffset(t), this.getShiftOffset(t)];
          const n = [this.flip && "flip", this.shift && "shift"],
            o = {
              element: [this.inset ? this.dir : gi(this.dir), this.align],
              target: [this.dir, this.align],
            };
          if (this.axis === "y") {
            for (const l in o) o[l].reverse();
            s.reverse(), n.reverse();
          }
          const r = Ts(t),
            a = m(t);
          h(t, { top: -a.height, left: -a.width }),
            mn(t, e, {
              attach: o,
              offset: s,
              boundary: i,
              placement: n,
              viewportOffset: this.getViewportOffset(t),
            }),
            r();
        },
        getPositionOffset(t = this.$el) {
          return (
            G(
              this.offset === !1 ? h(t, "--uk-position-offset") : this.offset,
              this.axis === "x" ? "width" : "height",
              t
            ) *
            (b(["left", "top"], this.dir) ? -1 : 1) *
            (this.inset ? -1 : 1)
          );
        },
        getShiftOffset(t = this.$el) {
          return this.align === "center"
            ? 0
            : G(
                h(t, "--uk-position-shift-offset"),
                this.axis === "y" ? "width" : "height",
                t
              ) * (b(["left", "top"], this.align) ? 1 : -1);
        },
        getViewportOffset(t) {
          return G(h(t, "--uk-position-viewport-offset"));
        },
      },
    };
  function Ts(t) {
    const e = Ot(t),
      { scrollTop: i } = e;
    return () => {
      i !== e.scrollTop && (e.scrollTop = i);
    };
  }
  var Yt = {
    props: {
      cls: Boolean,
      animation: "list",
      duration: Number,
      velocity: Number,
      origin: String,
      transition: String,
    },
    data: {
      cls: !1,
      animation: [!1],
      duration: 200,
      velocity: 0.2,
      origin: !1,
      transition: "ease",
      clsEnter: "uk-togglable-enter",
      clsLeave: "uk-togglable-leave",
    },
    computed: {
      hasAnimation: ({ animation: t }) => !!t[0],
      hasTransition: ({ animation: t }) =>
        ["slide", "reveal"].some((e) => mt(t[0], e)),
    },
    methods: {
      async toggleElement(t, e, i) {
        try {
          return (
            await Promise.all(
              T(t).map((s) => {
                const n = ne(e) ? e : !this.isToggled(s);
                if (!v(s, `before${n ? "show" : "hide"}`, [this]))
                  return Promise.reject();
                const o = (
                    nt(i)
                      ? i
                      : i === !1 || !this.hasAnimation
                      ? fa
                      : this.hasTransition
                      ? pa
                      : ga
                  )(s, n, this),
                  r = n ? this.clsEnter : this.clsLeave;
                S(s, r), v(s, n ? "show" : "hide", [this]);
                const a = () => {
                  var l;
                  if ((_(s, r), v(s, n ? "shown" : "hidden", [this]), n)) {
                    const c = Ts(s);
                    (l = D("[autofocus]", s).find(q)) == null || l.focus(), c();
                  }
                };
                return o ? o.then(a, () => (_(s, r), Promise.reject())) : a();
              })
            ),
            !0
          );
        } catch {
          return !1;
        }
      },
      isToggled(t = this.$el) {
        return (
          (t = R(t)),
          $(t, this.clsEnter)
            ? !0
            : $(t, this.clsLeave)
            ? !1
            : this.cls
            ? $(t, this.cls.split(" ")[0])
            : q(t)
        );
      },
      _toggle(t, e) {
        if (!t) return;
        e = !!e;
        let i;
        this.cls
          ? ((i = b(this.cls, " ") || e !== $(t, this.cls)),
            i && L(t, this.cls, b(this.cls, " ") ? void 0 : e))
          : ((i = e === t.hidden), i && (t.hidden = !e)),
          i && v(t, "toggled", [e, this]);
      },
    },
  };
  function fa(t, e, { _toggle: i }) {
    return Pt.cancel(t), N.cancel(t), i(t, e);
  }
  async function pa(
    t,
    e,
    { animation: i, duration: s, velocity: n, transition: o, _toggle: r }
  ) {
    var a;
    const [l = "reveal", c = "top"] =
        ((a = i[0]) == null ? void 0 : a.split("-")) || [],
      u = [
        ["left", "right"],
        ["top", "bottom"],
      ],
      d = u[b(u[0], c) ? 0 : 1],
      f = d[1] === c,
      w = ["width", "height"][u.indexOf(d)],
      I = `margin-${d[0]}`,
      P = `margin-${c}`;
    let ht = m(t)[w];
    const It = N.inProgress(t);
    await N.cancel(t), e && r(t, !0);
    const Mt = Object.fromEntries(
        [
          "padding",
          "border",
          "width",
          "height",
          "minWidth",
          "minHeight",
          "overflowY",
          "overflowX",
          I,
          P,
        ].map((sr) => [sr, t.style[sr]])
      ),
      wt = m(t),
      js = k(h(t, I)),
      tr = k(h(t, P)),
      te = wt[w] + tr;
    !It && !e && (ht += tr);
    const [Fi] = ts(t, "<div>");
    h(Fi, {
      boxSizing: "border-box",
      height: wt.height,
      width: wt.width,
      ...h(t, [
        "overflow",
        "padding",
        "borderTop",
        "borderRight",
        "borderBottom",
        "borderLeft",
        "borderImage",
        P,
      ]),
    }),
      h(t, {
        padding: 0,
        border: 0,
        minWidth: 0,
        minHeight: 0,
        [P]: 0,
        width: wt.width,
        height: wt.height,
        overflow: "hidden",
        [w]: ht,
      });
    const er = ht / te;
    s = (n * te + s) * (e ? 1 - er : er);
    const ir = { [w]: e ? te : 0 };
    f && (h(t, I, te - ht + js), (ir[I] = e ? js : te + js)),
      !f ^ (l === "reveal") &&
        (h(Fi, I, -te + ht), N.start(Fi, { [I]: e ? 0 : -te }, s, o));
    try {
      await N.start(t, ir, s, o);
    } finally {
      h(t, Mt), ze(Fi.firstChild), e || r(t, !1);
    }
  }
  function ga(t, e, i) {
    const { animation: s, duration: n, _toggle: o } = i;
    return e
      ? (o(t, !0), Pt.in(t, s[0], n, i.origin))
      : Pt.out(t, s[1] || s[0], n, i.origin).then(() => o(t, !1));
  }
  const st = [];
  var Es = {
    mixins: [it, Ue, Yt],
    props: {
      selPanel: String,
      selClose: String,
      escClose: Boolean,
      bgClose: Boolean,
      stack: Boolean,
      role: String,
    },
    data: {
      cls: "uk-open",
      escClose: !0,
      bgClose: !0,
      overlay: !0,
      stack: !1,
      role: "dialog",
    },
    computed: {
      panel: ({ selPanel: t }, e) => x(t, e),
      transitionElement() {
        return this.panel;
      },
    },
    connected() {
      p(this.panel || this.$el, "role", this.role),
        this.overlay && p(this.panel || this.$el, "aria-modal", !0);
    },
    beforeDisconnect() {
      b(st, this) && this.toggleElement(this.$el, !1, !1);
    },
    events: [
      {
        name: "click",
        delegate: ({ selClose: t }) => `${t},a[href*="#"]`,
        handler(t) {
          const { current: e, defaultPrevented: i } = t,
            { hash: s } = e;
          !i && s && ue(e) && !this.$el.contains(x(s))
            ? this.hide()
            : C(e, this.selClose) && (t.preventDefault(), this.hide());
        },
      },
      {
        name: "toggle",
        self: !0,
        handler(t) {
          t.defaultPrevented ||
            (t.preventDefault(),
            this.isToggled() === b(st, this) && this.toggle());
        },
      },
      {
        name: "beforeshow",
        self: !0,
        handler(t) {
          if (b(st, this)) return !1;
          !this.stack && st.length
            ? (Promise.all(st.map((e) => e.hide())).then(this.show),
              t.preventDefault())
            : st.push(this);
        },
      },
      {
        name: "show",
        self: !0,
        handler() {
          this.stack &&
            h(this.$el, "zIndex", k(h(this.$el, "zIndex")) + st.length);
          const t = [
            this.overlay && va(this),
            this.overlay && zn(this.$el),
            this.bgClose && ba(this),
            this.escClose && wa(this),
          ];
          z(this.$el, "hidden", () => t.forEach((e) => e && e()), { self: !0 }),
            S(document.documentElement, this.clsPage);
        },
      },
      {
        name: "shown",
        self: !0,
        handler() {
          li(this.$el) || p(this.$el, "tabindex", "-1"),
            C(this.$el, ":focus-within") || this.$el.focus();
        },
      },
      {
        name: "hidden",
        self: !0,
        handler() {
          b(st, this) && st.splice(st.indexOf(this), 1),
            h(this.$el, "zIndex", ""),
            st.some((t) => t.clsPage === this.clsPage) ||
              _(document.documentElement, this.clsPage);
        },
      },
    ],
    methods: {
      toggle() {
        return this.isToggled() ? this.hide() : this.show();
      },
      show() {
        return this.container && O(this.$el) !== this.container
          ? (W(this.container, this.$el),
            new Promise((t) =>
              requestAnimationFrame(() => this.show().then(t))
            ))
          : this.toggleElement(this.$el, !0, Hn);
      },
      hide() {
        return this.toggleElement(this.$el, !1, Hn);
      },
    },
  };
  function Hn(t, e, { transitionElement: i, _toggle: s }) {
    return new Promise((n, o) =>
      z(t, "show hide", () => {
        var r;
        (r = t._reject) == null || r.call(t), (t._reject = o), s(t, e);
        const a = z(
            i,
            "transitionstart",
            () => {
              z(i, "transitionend transitioncancel", n, { self: !0 }),
                clearTimeout(l);
            },
            { self: !0 }
          ),
          l = setTimeout(() => {
            a(), n();
          }, ma(h(i, "transitionDuration")));
      })
    ).then(() => delete t._reject);
  }
  function ma(t) {
    return t ? (ee(t, "ms") ? k(t) : k(t) * 1e3) : 0;
  }
  function va(t) {
    return y(document, "focusin", (e) => {
      Ft(st) === t && !t.$el.contains(e.target) && t.$el.focus();
    });
  }
  function ba(t) {
    return y(document, ut, ({ target: e }) => {
      Ft(st) !== t ||
        (t.overlay && !t.$el.contains(e)) ||
        !t.panel ||
        t.panel.contains(e) ||
        z(
          document,
          `${Ct} ${ri} scroll`,
          ({ defaultPrevented: i, type: s, target: n }) => {
            !i && s === Ct && e === n && t.hide();
          },
          !0
        );
    });
  }
  function wa(t) {
    return y(document, "keydown", (e) => {
      e.keyCode === 27 && Ft(st) === t && t.hide();
    });
  }
  var Cs = {
    slide: {
      show(t) {
        return [{ transform: j(t * -100) }, { transform: j() }];
      },
      percent(t) {
        return Ve(t);
      },
      translate(t, e) {
        return [
          { transform: j(e * -100 * t) },
          { transform: j(e * 100 * (1 - t)) },
        ];
      },
    },
  };
  function Ve(t) {
    return Math.abs(new DOMMatrix(h(t, "transform")).m41 / t.offsetWidth);
  }
  function j(t = 0, e = "%") {
    return t ? `translate3d(${t + e}, 0, 0)` : "";
  }
  function xa(t, e, i, { animation: s, easing: n }) {
    const { percent: o, translate: r, show: a = A } = s,
      l = a(i),
      { promise: c, resolve: u } = Ln();
    return {
      dir: i,
      show(d, f = 0, g) {
        const w = g ? "linear" : n;
        return (
          (d -= Math.round(d * K(f, -1, 1))),
          this.translate(f),
          Gt(e, "itemin", { percent: f, duration: d, timing: w, dir: i }),
          Gt(t, "itemout", { percent: 1 - f, duration: d, timing: w, dir: i }),
          Promise.all([N.start(e, l[1], d, w), N.start(t, l[0], d, w)]).then(
            () => {
              this.reset(), u();
            },
            A
          ),
          c
        );
      },
      cancel() {
        return N.cancel([e, t]);
      },
      reset() {
        for (const d in l[0]) h([e, t], d, "");
      },
      async forward(d, f = this.percent()) {
        return await this.cancel(), this.show(d, f, !0);
      },
      translate(d) {
        this.reset();
        const f = r(d, i);
        h(e, f[1]),
          h(t, f[0]),
          Gt(e, "itemtranslatein", { percent: d, dir: i }),
          Gt(t, "itemtranslateout", { percent: 1 - d, dir: i });
      },
      percent() {
        return o(t || e, e, i);
      },
      getDistance() {
        return t == null ? void 0 : t.offsetWidth;
      },
    };
  }
  function Gt(t, e, i) {
    v(t, de(e, !1, !1, i));
  }
  function Ln() {
    let t;
    return { promise: new Promise((e) => (t = e)), resolve: t };
  }
  var Si = {
      props: { i18n: Object },
      data: { i18n: null },
      methods: {
        t(t, ...e) {
          var i, s, n;
          let o = 0;
          return (
            ((n =
              ((i = this.i18n) == null ? void 0 : i[t]) ||
              ((s = this.$options.i18n) == null ? void 0 : s[t])) == null
              ? void 0
              : n.replace(/%s/g, () => e[o++] || "")) || ""
          );
        },
      },
    },
    $a = {
      props: {
        autoplay: Boolean,
        autoplayInterval: Number,
        pauseOnHover: Boolean,
      },
      data: { autoplay: !1, autoplayInterval: 7e3, pauseOnHover: !0 },
      connected() {
        p(this.list, "aria-live", this.autoplay ? "off" : "polite"),
          this.autoplay && this.startAutoplay();
      },
      disconnected() {
        this.stopAutoplay();
      },
      update() {
        p(this.slides, "tabindex", "-1");
      },
      events: [
        {
          name: "visibilitychange",
          el: () => document,
          filter: ({ autoplay: t }) => t,
          handler() {
            document.hidden ? this.stopAutoplay() : this.startAutoplay();
          },
        },
      ],
      methods: {
        startAutoplay() {
          this.stopAutoplay(),
            (this.interval = setInterval(() => {
              this.stack.length ||
                (this.draggable &&
                  C(this.$el, ":focus-within") &&
                  !C(this.$el, ":focus")) ||
                (this.pauseOnHover && C(this.$el, ":hover")) ||
                this.show("next");
            }, this.autoplayInterval));
        },
        stopAutoplay() {
          clearInterval(this.interval);
        },
      },
    };
  const Ii = { passive: !1, capture: !0 },
    Wn = { passive: !0, capture: !0 },
    ya = "touchstart mousedown",
    Ps = "touchmove mousemove",
    jn = "touchend touchcancel mouseup click input scroll";
  var ka = {
    props: { draggable: Boolean },
    data: { draggable: !0, threshold: 10 },
    created() {
      for (const t of ["start", "move", "end"]) {
        const e = this[t];
        this[t] = (i) => {
          const s = kt(i).x * (U ? -1 : 1);
          (this.prevPos = s === this.pos ? this.prevPos : this.pos),
            (this.pos = s),
            e(i);
        };
      }
    },
    events: [
      {
        name: ya,
        passive: !0,
        delegate: ({ selList: t }) => `${t} > *`,
        handler(t) {
          !this.draggable ||
            this.parallax ||
            (!pt(t) && Sa(t.target)) ||
            t.target.closest(Ae) ||
            t.button > 0 ||
            this.length < 2 ||
            this.start(t);
        },
      },
      {
        name: "dragstart",
        handler(t) {
          t.preventDefault();
        },
      },
      { name: Ps, el: ({ list: t }) => t, handler: A, ...Ii },
    ],
    methods: {
      start() {
        (this.drag = this.pos),
          this._transitioner
            ? ((this.percent = this._transitioner.percent()),
              (this.drag +=
                this._transitioner.getDistance() * this.percent * this.dir),
              this._transitioner.cancel(),
              this._transitioner.translate(this.percent),
              (this.dragging = !0),
              (this.stack = []))
            : (this.prevIndex = this.index),
          y(document, Ps, this.move, Ii),
          y(document, jn, this.end, Wn),
          h(this.list, "userSelect", "none");
      },
      move(t) {
        const e = this.pos - this.drag;
        if (
          e === 0 ||
          this.prevPos === this.pos ||
          (!this.dragging && Math.abs(e) < this.threshold)
        )
          return;
        t.cancelable && t.preventDefault(),
          (this.dragging = !0),
          (this.dir = e < 0 ? 1 : -1);
        let { slides: i, prevIndex: s } = this,
          n = Math.abs(e),
          o = this.getIndex(s + this.dir),
          r = Rn.call(this, s, o);
        for (; o !== s && n > r; )
          (this.drag -= r * this.dir),
            (s = o),
            (n -= r),
            (o = this.getIndex(s + this.dir)),
            (r = Rn.call(this, s, o));
        this.percent = n / r;
        const a = i[s],
          l = i[o],
          c = this.index !== o,
          u = s === o;
        let d;
        for (const f of [this.index, this.prevIndex])
          b([o, s], f) ||
            (v(i[f], "itemhidden", [this]),
            u && ((d = !0), (this.prevIndex = s)));
        ((this.index === s && this.prevIndex !== s) || d) &&
          v(i[this.index], "itemshown", [this]),
          c &&
            ((this.prevIndex = s),
            (this.index = o),
            u || (v(a, "beforeitemhide", [this]), v(a, "itemhide", [this])),
            v(l, "beforeitemshow", [this]),
            v(l, "itemshow", [this])),
          (this._transitioner = this._translate(
            Math.abs(this.percent),
            a,
            !u && l
          ));
      },
      end() {
        if (
          (Rt(document, Ps, this.move, Ii),
          Rt(document, jn, this.end, Wn),
          this.dragging)
        )
          if (
            (setTimeout(y(this.list, "click", (t) => t.preventDefault(), Ii)),
            (this.dragging = null),
            this.index === this.prevIndex)
          )
            (this.percent = 1 - this.percent),
              (this.dir *= -1),
              this._show(!1, this.index, !0),
              (this._transitioner = null);
          else {
            const t =
              (U ? this.dir * (U ? 1 : -1) : this.dir) < 0 ==
              this.prevPos > this.pos;
            (this.index = t ? this.index : this.prevIndex),
              t &&
                (v(this.slides[this.prevIndex], "itemhidden", [this]),
                v(this.slides[this.index], "itemshown", [this]),
                (this.percent = 1 - this.percent)),
              this.show(
                (this.dir > 0 && !t) || (this.dir < 0 && t)
                  ? "next"
                  : "previous",
                !0
              );
          }
        h(this.list, { userSelect: "" }), (this.drag = this.percent = null);
      },
    },
  };
  function Rn(t, e) {
    return (
      this._getTransitioner(t, t !== e && e).getDistance() ||
      this.slides[t].offsetWidth
    );
  }
  function Sa(t) {
    return (
      h(t, "userSelect") !== "none" &&
      ie(t.childNodes).some((e) => e.nodeType === 3 && e.textContent.trim())
    );
  }
  function Ia(t) {
    t._watches = [];
    for (const e of t.$options.watch || [])
      for (const [i, s] of Object.entries(e)) qn(t, s, i);
    t._initial = !0;
  }
  function qn(t, e, i) {
    t._watches.push({ name: i, ...(Ie(e) ? e : { handler: e }) });
  }
  function Ta(t, e) {
    for (const { name: i, handler: s, immediate: n = !0 } of t._watches)
      ((t._initial && n) || (gt(e, i) && !Pe(e[i], t[i]))) &&
        s.call(t, t[i], e[i]);
    t._initial = !1;
  }
  function Ea(t) {
    const { computed: e } = t.$options;
    if (((t._computed = {}), e)) for (const i in e) Vn(t, i, e[i]);
  }
  const Un = { subtree: !0, childList: !0 };
  function Vn(t, e, i) {
    (t._hasComputed = !0),
      Object.defineProperty(t, e, {
        enumerable: !0,
        get() {
          const { _computed: s, $props: n, $el: o } = t;
          if (
            !gt(s, e) &&
            ((s[e] = (i.get || i).call(t, n, o)),
            i.observe && t._computedObserver)
          ) {
            const r = i.observe.call(t, n);
            t._computedObserver.observe(
              ["~", "+", "-"].includes(r[0])
                ? o.parentElement
                : o.getRootNode(),
              Un
            );
          }
          return s[e];
        },
        set(s) {
          const { _computed: n } = t;
          (n[e] = i.set ? i.set.call(t, s) : s), X(n[e]) && delete n[e];
        },
      });
  }
  function Ca(t) {
    t._hasComputed &&
      (Xr(t, { read: () => Ta(t, Yn(t)), events: ["resize", "computed"] }),
      (t._computedObserver = os(t.$el, () => je(t, "computed"), Un)),
      t._disconnect.push(() => {
        t._computedObserver.disconnect(), (t._computedObserver = null), Yn(t);
      }));
  }
  function Yn(t) {
    const e = { ...t._computed };
    return (t._computed = {}), e;
  }
  function Pa(t) {
    for (const e of t.$options.events || [])
      if (gt(e, "handler")) Gn(t, e);
      else for (const i in e) Gn(t, { name: i, handler: e[i] });
  }
  function Gn(
    t,
    {
      name: e,
      el: i,
      handler: s,
      capture: n,
      passive: o,
      delegate: r,
      filter: a,
      self: l,
    }
  ) {
    (a && !a.call(t, t)) ||
      t._disconnect.push(
        y(
          i ? i.call(t, t) : t.$el,
          e,
          r == null ? void 0 : r.call(t, t),
          s.bind(t),
          { passive: o, capture: n, self: l }
        )
      );
  }
  function _a(t) {
    for (const e of t.$options.observe || []) Aa(t, e);
  }
  function Aa(t, e) {
    let {
      observe: i,
      target: s = t.$el,
      handler: n,
      options: o,
      filter: r,
      args: a,
    } = e;
    if (r && !r.call(t, t)) return;
    const l = `_observe${t._disconnect.length}`;
    nt(s) &&
      !gt(t, l) &&
      Vn(t, l, () => {
        const d = s.call(t, t);
        return J(d) ? T(d) : d;
      }),
      (n = H(n) ? t[n] : n.bind(t)),
      nt(o) && (o = o.call(t, t));
    const c = gt(t, l) ? t[l] : s,
      u = i(c, n, o, a);
    nt(s) && J(t[l]) && qn(t, { handler: Oa(u, o), immediate: !1 }, l),
      t._disconnect.push(() => u.disconnect());
  }
  function Oa(t, e) {
    return (i, s) => {
      for (const n of s)
        b(i, n) || (t.unobserve ? t.unobserve(n) : t.observe && t.disconnect());
      for (const n of i) (!b(s, n) || !t.unobserve) && t.observe(n, e);
    };
  }
  function Da(t) {
    const { $options: e, $props: i } = t,
      s = Xn(e);
    ft(i, s);
    const { computed: n, methods: o } = e;
    for (let r in i)
      r in s && (!n || !gt(n, r)) && (!o || !gt(o, r)) && (t[r] = i[r]);
  }
  function Xn(t) {
    const e = {},
      { args: i = [], props: s = {}, el: n, id: o } = t;
    if (!s) return e;
    for (const a in s) {
      const l = Bt(a);
      let c = Z(n, l);
      X(c) ||
        ((c = s[a] === Boolean && c === "" ? !0 : ms(s[a], c)),
        !(l === "target" && mt(c, "_")) && (e[a] = c));
    }
    const r = ge(Z(n, o), i);
    for (const a in r) {
      const l = Se(a);
      X(s[l]) || (e[l] = ms(s[l], r[a]));
    }
    return e;
  }
  const Ma = ct((t, e) => {
    const i = Object.keys(e),
      s = i
        .concat(t)
        .map((n) => [Bt(n), `data-${Bt(n)}`])
        .flat();
    return { attributes: i, filter: s };
  });
  function Ba(t) {
    const { $options: e, $props: i } = t,
      { id: s, props: n, el: o } = e;
    if (!n) return;
    const { attributes: r, filter: a } = Ma(s, n),
      l = new MutationObserver((c) => {
        const u = Xn(e);
        c.some(({ attributeName: d }) => {
          const f = d.replace("data-", "");
          return (f === s ? r : [Se(f), Se(d)]).some(
            (g) => !X(u[g]) && u[g] !== i[g]
          );
        }) && t.$reset();
      });
    l.observe(o, { attributes: !0, attributeFilter: a }),
      t._disconnect.push(() => l.disconnect());
  }
  function ve(t, e) {
    var i;
    (i = t.$options[e]) == null || i.forEach((s) => s.call(t));
  }
  function _s(t) {
    t._connected ||
      (Da(t),
      ve(t, "beforeConnect"),
      (t._connected = !0),
      (t._disconnect = []),
      Pa(t),
      Gr(t),
      Ia(t),
      _a(t),
      Ba(t),
      Ca(t),
      ve(t, "connected"),
      je(t));
  }
  function As(t) {
    t._connected &&
      (ve(t, "beforeDisconnect"),
      t._disconnect.forEach((e) => e()),
      (t._disconnect = null),
      ve(t, "disconnected"),
      (t._connected = !1));
  }
  let Na = 0;
  function Jn(t, e = {}) {
    (e.data = Ha(e, t.constructor.options)),
      (t.$options = We(t.constructor.options, e, t)),
      (t.$props = {}),
      (t._uid = Na++),
      za(t),
      Fa(t),
      Ea(t),
      ve(t, "created"),
      e.el && t.$mount(e.el);
  }
  function za(t) {
    const { data: e = {} } = t.$options;
    for (const i in e) t.$props[i] = t[i] = e[i];
  }
  function Fa(t) {
    const { methods: e } = t.$options;
    if (e) for (const i in e) t[i] = e[i].bind(t);
  }
  function Ha({ data: t = {} }, { args: e = [], props: i = {} }) {
    J(t) &&
      (t = t
        .slice(0, e.length)
        .reduce((s, n, o) => (Ie(n) ? ft(s, n) : (s[e[o]] = n), s), {}));
    for (const s in t) X(t[s]) ? delete t[s] : i[s] && (t[s] = ms(i[s], t[s]));
    return t;
  }
  const lt = function (t) {
    Jn(this, t);
  };
  (lt.util = Wr), (lt.options = {}), (lt.version = "3.23.1");
  const La = "uk-",
    Xt = "__uikit__",
    be = {};
  function Kn(t, e) {
    var i, s;
    const n = La + Bt(t);
    if (!e) return be[n].options || (be[n] = lt.extend(be[n])), be[n];
    (t = Se(t)), (lt[t] = (r, a) => Ye(t, r, a));
    const o = (i = e.options) != null ? i : { ...e };
    return (
      (o.id = n),
      (o.name = t),
      (s = o.install) == null || s.call(o, lt, o, t),
      lt._initialized &&
        !o.functional &&
        requestAnimationFrame(() => Ye(t, `[${n}],[data-${n}]`)),
      (be[n] = o)
    );
  }
  function Ye(t, e, i, ...s) {
    const n = Kn(t);
    return n.options.functional
      ? new n({ data: Ie(e) ? e : [e, i, ...s] })
      : e
      ? D(e).map(o)[0]
      : o();
    function o(r) {
      const a = Ti(r, t);
      if (a)
        if (i) a.$destroy();
        else return a;
      return new n({ el: r, data: i });
    }
  }
  function Ge(t) {
    return (t == null ? void 0 : t[Xt]) || {};
  }
  function Ti(t, e) {
    return Ge(t)[e];
  }
  function Wa(t, e) {
    t[Xt] || (t[Xt] = {}), (t[Xt][e.$options.name] = e);
  }
  function ja(t, e) {
    var i;
    (i = t[Xt]) == null || delete i[e.$options.name], ti(t[Xt]) && delete t[Xt];
  }
  function Ra(t) {
    (t.component = Kn),
      (t.getComponents = Ge),
      (t.getComponent = Ti),
      (t.update = Zn),
      (t.use = function (i) {
        if (!i.installed) return i.call(null, this), (i.installed = !0), this;
      }),
      (t.mixin = function (i, s) {
        (s = (H(s) ? this.component(s) : s) || this),
          (s.options = We(s.options, i));
      }),
      (t.extend = function (i) {
        i || (i = {});
        const s = this,
          n = function (r) {
            Jn(this, r);
          };
        return (
          (n.prototype = Object.create(s.prototype)),
          (n.prototype.constructor = n),
          (n.options = We(s.options, i)),
          (n.super = s),
          (n.extend = s.extend),
          n
        );
      });
    let e;
    Object.defineProperty(t, "container", {
      get() {
        return e || document.body;
      },
      set(i) {
        e = x(i);
      },
    });
  }
  function Zn(t, e) {
    t = t ? R(t) : document.body;
    for (const i of ce(t).reverse()) Qn(i, e);
    _t(t, (i) => Qn(i, e));
  }
  function Qn(t, e) {
    const i = Ge(t);
    for (const s in i) je(i[s], e);
  }
  function qa(t) {
    (t.prototype.$mount = function (e) {
      const i = this;
      Wa(e, i), (i.$options.el = e), e.isConnected && _s(i);
    }),
      (t.prototype.$destroy = function (e = !1) {
        const i = this,
          { el: s } = i.$options;
        s && As(i), ve(i, "destroy"), ja(s, i), e && Q(i.$el);
      }),
      (t.prototype.$create = Ye),
      (t.prototype.$emit = function (e) {
        je(this, e);
      }),
      (t.prototype.$update = function (e = this.$el, i) {
        Zn(e, i);
      }),
      (t.prototype.$reset = function () {
        As(this), _s(this);
      }),
      (t.prototype.$getComponent = Ti),
      Object.defineProperties(t.prototype, {
        $el: {
          get() {
            return this.$options.el;
          },
        },
        $container: Object.getOwnPropertyDescriptor(t, "container"),
      });
  }
  let Ua = 1;
  function Jt(t, e = null) {
    return (e == null ? void 0 : e.id) || `${t.$options.id}-${Ua++}`;
  }
  var Va = {
    i18n: {
      next: "Next slide",
      previous: "Previous slide",
      slideX: "Slide %s",
      slideLabel: "%s of %s",
      role: "String",
    },
    data: { selNav: !1, role: "region" },
    computed: {
      nav: ({ selNav: t }, e) => x(t, e),
      navChildren() {
        return B(this.nav);
      },
      selNavItem: ({ attrItem: t }) => `[${t}],[data-${t}]`,
      navItems(t, e) {
        return D(this.selNavItem, e);
      },
    },
    watch: {
      nav(t, e) {
        p(t, "role", "tablist"), this.padNavitems(), e && this.$emit();
      },
      list(t) {
        F(t, "ul") && p(t, "role", "presentation");
      },
      navChildren(t) {
        p(t, "role", "presentation"), this.padNavitems(), this.updateNav();
      },
      navItems(t) {
        for (const e of t) {
          const i = Z(e, this.attrItem),
            s = x("a,button", e) || e;
          let n,
            o = null;
          if (vt(i)) {
            const r = $t(i),
              a = this.slides[r];
            a && (a.id || (a.id = Jt(this, a)), (o = a.id)),
              (n = this.t("slideX", k(i) + 1)),
              p(s, "role", "tab");
          } else
            this.list &&
              (this.list.id || (this.list.id = Jt(this, this.list)),
              (o = this.list.id)),
              (n = this.t(i));
          p(s, { "aria-controls": o, "aria-label": p(s, "aria-label") || n });
        }
      },
      slides(t) {
        t.forEach((e, i) =>
          p(e, {
            role: this.nav ? "tabpanel" : "group",
            "aria-label": this.t("slideLabel", i + 1, this.length),
            "aria-roledescription": this.nav ? null : "slide",
          })
        ),
          this.padNavitems();
      },
    },
    connected() {
      p(this.$el, { role: this.role, "aria-roledescription": "carousel" });
    },
    update: [
      {
        write() {
          this.navItems
            .concat(this.nav)
            .forEach((t) => t && (t.hidden = !this.maxIndex)),
            this.updateNav();
        },
        events: ["resize"],
      },
    ],
    events: [
      {
        name: "click keydown",
        delegate: ({ selNavItem: t }) => t,
        filter: ({ parallax: t }) => !t,
        handler(t) {
          t.target.closest("a,button") &&
            (t.type === "click" || t.keyCode === M.SPACE) &&
            (t.preventDefault(), this.show(Z(t.current, this.attrItem)));
        },
      },
      {
        name: "itemshow",
        handler() {
          this.updateNav();
        },
      },
      {
        name: "keydown",
        delegate: ({ selNavItem: t }) => t,
        filter: ({ parallax: t }) => !t,
        handler(t) {
          const { current: e, keyCode: i } = t,
            s = Z(e, this.attrItem);
          if (!vt(s)) return;
          let n =
            i === M.HOME
              ? 0
              : i === M.END
              ? "last"
              : i === M.LEFT
              ? "previous"
              : i === M.RIGHT
              ? "next"
              : -1;
          ~n && (t.preventDefault(), this.show(n));
        },
      },
    ],
    methods: {
      updateNav() {
        const t = this.getValidIndex();
        for (const e of this.navItems) {
          const i = Z(e, this.attrItem),
            s = x("a,button", e) || e;
          if (vt(i)) {
            const o = $t(i) === t;
            L(e, this.clsActive, o),
              L(s, "uk-disabled", !!this.parallax),
              p(s, {
                "aria-selected": o,
                tabindex: o && !this.parallax ? null : -1,
              }),
              o && s && C(O(e), ":focus-within") && s.focus();
          } else
            L(
              e,
              "uk-invisible",
              this.finite &&
                ((i === "previous" && t === 0) ||
                  (i === "next" && t >= this.maxIndex))
            );
        }
      },
      padNavitems() {
        if (!this.nav) return;
        const t = [];
        for (let e = 0; e < this.length; e++) {
          const i = `${this.attrItem}="${e}"`;
          t[e] =
            this.navChildren.findLast((s) => s.matches(`[${i}]`)) ||
            x(`<li ${i}><a href></a></li>`);
        }
        Pe(t, this.navChildren) || bt(this.nav, t);
      },
    },
  };
  const Ya = "cubic-bezier(0.25, 0.46, 0.45, 0.94)",
    Ga = "cubic-bezier(0.165, 0.84, 0.44, 1)";
  var to = {
    mixins: [$a, ka, Va, Si],
    props: {
      clsActivated: String,
      easing: String,
      index: Number,
      finite: Boolean,
      velocity: Number,
    },
    data: () => ({
      easing: "ease",
      finite: !1,
      velocity: 1,
      index: 0,
      prevIndex: -1,
      stack: [],
      percent: 0,
      clsActive: "uk-active",
      clsActivated: "",
      clsEnter: "uk-slide-enter",
      clsLeave: "uk-slide-leave",
      clsSlideActive: "uk-slide-active",
      Transitioner: !1,
      transitionOptions: {},
    }),
    connected() {
      (this.prevIndex = -1),
        (this.index = this.getValidIndex(this.$props.index)),
        (this.stack = []);
    },
    disconnected() {
      _(this.slides, this.clsActive);
    },
    computed: {
      duration: ({ velocity: t }, e) => eo(e.offsetWidth / t),
      list: ({ selList: t }, e) => x(t, e),
      maxIndex() {
        return this.length - 1;
      },
      slides() {
        return B(this.list);
      },
      length() {
        return this.slides.length;
      },
    },
    watch: {
      slides(t, e) {
        e && this.$emit();
      },
    },
    events: {
      itemshow({ target: t }) {
        S(t, this.clsEnter, this.clsSlideActive);
      },
      itemshown({ target: t }) {
        _(t, this.clsEnter);
      },
      itemhide({ target: t }) {
        S(t, this.clsLeave);
      },
      itemhidden({ target: t }) {
        _(t, this.clsLeave, this.clsSlideActive);
      },
    },
    methods: {
      async show(t, e = !1) {
        var i;
        if (this.dragging || !this.length || this.parallax) return;
        const { stack: s } = this,
          n = e ? 0 : s.length,
          o = () => {
            s.splice(n, 1), s.length && this.show(s.shift(), !0);
          };
        if ((s[e ? "unshift" : "push"](t), !e && s.length > 1)) {
          s.length === 2 &&
            ((i = this._transitioner) == null ||
              i.forward(Math.min(this.duration, 200)));
          return;
        }
        const r = this.getIndex(this.index),
          a = $(this.slides, this.clsActive) && this.slides[r],
          l = this.getIndex(t, this.index),
          c = this.slides[l];
        if (a === c) {
          o();
          return;
        }
        if (
          ((this.dir = Xa(t, r)),
          (this.prevIndex = r),
          (this.index = l),
          (a && !v(a, "beforeitemhide", [this])) ||
            !v(c, "beforeitemshow", [this, a]))
        ) {
          (this.index = this.prevIndex), o();
          return;
        }
        a && v(a, "itemhide", [this]),
          v(c, "itemshow", [this]),
          await this._show(a, c, e),
          a && v(a, "itemhidden", [this]),
          v(c, "itemshown", [this]),
          s.shift(),
          (this._transitioner = null),
          s.length &&
            requestAnimationFrame(() => s.length && this.show(s.shift(), !0));
      },
      getIndex(t = this.index, e = this.index) {
        return K(
          ot(t, this.slides, e, this.finite),
          0,
          Math.max(0, this.maxIndex)
        );
      },
      getValidIndex(t = this.index, e = this.prevIndex) {
        return this.getIndex(t, e);
      },
      async _show(t, e, i) {
        if (
          ((this._transitioner = this._getTransitioner(t, e, this.dir, {
            easing: i ? (e.offsetWidth < 600 ? Ya : Ga) : this.easing,
            ...this.transitionOptions,
          })),
          !i && !t)
        ) {
          this._translate(1);
          return;
        }
        const { length: s } = this.stack;
        return this._transitioner[s > 1 ? "forward" : "show"](
          s > 1 ? Math.min(this.duration, 75 + 75 / (s - 1)) : this.duration,
          this.percent
        );
      },
      _translate(t, e = this.prevIndex, i = this.index) {
        const s = this._getTransitioner(e === i ? !1 : e, i);
        return s.translate(t), s;
      },
      _getTransitioner(
        t = this.prevIndex,
        e = this.index,
        i = this.dir || 1,
        s = this.transitionOptions
      ) {
        return new this.Transitioner(
          Ce(t) ? this.slides[t] : t,
          Ce(e) ? this.slides[e] : e,
          i * (U ? -1 : 1),
          s
        );
      },
    },
  };
  function Xa(t, e) {
    return t === "next" ? 1 : t === "previous" || t < e ? -1 : 1;
  }
  function eo(t) {
    return 0.5 * t + 300;
  }
  var io = {
      mixins: [to],
      props: { animation: String },
      data: {
        animation: "slide",
        clsActivated: "uk-transition-active",
        Animations: Cs,
        Transitioner: xa,
      },
      computed: {
        animation({ animation: t, Animations: e }) {
          return { ...(e[t] || e.slide), name: t };
        },
        transitionOptions() {
          return { animation: this.animation };
        },
      },
      observe: dt(),
      events: {
        itemshow({ target: t }) {
          S(t, this.clsActive);
        },
        itemshown({ target: t }) {
          S(t, this.clsActivated);
        },
        itemhidden({ target: t }) {
          _(t, this.clsActive, this.clsActivated);
        },
      },
    },
    Ja = {
      ...Cs,
      fade: {
        show() {
          return [{ opacity: 0, zIndex: 0 }, { zIndex: -1 }];
        },
        percent(t) {
          return 1 - h(t, "opacity");
        },
        translate(t) {
          return [{ opacity: 1 - t, zIndex: 0 }, { zIndex: -1 }];
        },
      },
      scale: {
        show() {
          return [
            { opacity: 0, transform: we(1 + 0.5), zIndex: 0 },
            { zIndex: -1 },
          ];
        },
        percent(t) {
          return 1 - h(t, "opacity");
        },
        translate(t) {
          return [
            { opacity: 1 - t, transform: we(1 + 0.5 * t), zIndex: 0 },
            { zIndex: -1 },
          ];
        },
      },
      pull: {
        show(t) {
          return t < 0
            ? [
                { transform: j(30), zIndex: -1 },
                { transform: j(), zIndex: 0 },
              ]
            : [
                { transform: j(-100), zIndex: 0 },
                { transform: j(), zIndex: -1 },
              ];
        },
        percent(t, e, i) {
          return i < 0 ? 1 - Ve(e) : Ve(t);
        },
        translate(t, e) {
          return e < 0
            ? [
                { transform: j(30 * t), zIndex: -1 },
                { transform: j(-100 * (1 - t)), zIndex: 0 },
              ]
            : [
                { transform: j(-t * 100), zIndex: 0 },
                { transform: j(30 * (1 - t)), zIndex: -1 },
              ];
        },
      },
      push: {
        show(t) {
          return t < 0
            ? [
                { transform: j(100), zIndex: 0 },
                { transform: j(), zIndex: -1 },
              ]
            : [
                { transform: j(-30), zIndex: -1 },
                { transform: j(), zIndex: 0 },
              ];
        },
        percent(t, e, i) {
          return i > 0 ? 1 - Ve(e) : Ve(t);
        },
        translate(t, e) {
          return e < 0
            ? [
                { transform: j(t * 100), zIndex: 0 },
                { transform: j(-30 * (1 - t)), zIndex: -1 },
              ]
            : [
                { transform: j(-30 * t), zIndex: -1 },
                { transform: j(100 * (1 - t)), zIndex: 0 },
              ];
        },
      },
    };
  function we(t) {
    return `scale3d(${t}, ${t}, 1)`;
  }
  var so = {
      ...Cs,
      fade: {
        show() {
          return [{ opacity: 0 }, { opacity: 1 }];
        },
        percent(t) {
          return 1 - h(t, "opacity");
        },
        translate(t) {
          return [{ opacity: 1 - t }, { opacity: t }];
        },
      },
      scale: {
        show() {
          return [
            { opacity: 0, transform: we(1 - 0.2) },
            { opacity: 1, transform: we(1) },
          ];
        },
        percent(t) {
          return 1 - h(t, "opacity");
        },
        translate(t) {
          return [
            { opacity: 1 - t, transform: we(1 - 0.2 * t) },
            { opacity: t, transform: we(1 - 0.2 + 0.2 * t) },
          ];
        },
      },
    },
    no = {
      i18n: { counter: "%s / %s" },
      mixins: [Es, io],
      functional: !0,
      props: {
        counter: Boolean,
        preload: Number,
        nav: Boolean,
        slidenav: Boolean,
        delayControls: Number,
        videoAutoplay: Boolean,
        template: String,
      },
      data: () => ({
        counter: !1,
        preload: 1,
        nav: !1,
        slidenav: !0,
        delayControls: 3e3,
        videoAutoplay: !1,
        items: [],
        cls: "uk-open",
        clsPage: "uk-lightbox-page",
        clsFit: "uk-lightbox-items-fit",
        clsZoom: "uk-lightbox-zoom",
        attrItem: "uk-lightbox-item",
        selList: ".uk-lightbox-items",
        selClose: ".uk-close-large",
        selNav: ".uk-lightbox-thumbnav, .uk-lightbox-dotnav",
        selCaption: ".uk-lightbox-caption",
        selCounter: ".uk-lightbox-counter",
        pauseOnHover: !1,
        velocity: 2,
        Animations: so,
        template:
          '<div class="uk-lightbox uk-overflow-hidden"> <div class="uk-lightbox-items"></div> <div class="uk-position-top-right uk-position-small uk-transition-fade" uk-inverse> <button class="uk-lightbox-close uk-close-large" type="button" uk-close></button> </div> <div class="uk-lightbox-slidenav uk-position-center-left uk-position-medium uk-transition-fade" uk-inverse> <a href uk-slidenav-previous uk-lightbox-item="previous"></a> </div> <div class="uk-lightbox-slidenav uk-position-center-right uk-position-medium uk-transition-fade" uk-inverse> <a href uk-slidenav-next uk-lightbox-item="next"></a> </div> <div class="uk-position-center-right uk-position-medium uk-transition-fade" uk-inverse style="max-height: 90vh; overflow: auto;"> <ul class="uk-lightbox-thumbnav uk-lightbox-thumbnav-vertical uk-thumbnav uk-thumbnav-vertical"></ul> <ul class="uk-lightbox-dotnav uk-dotnav uk-dotnav-vertical"></ul> </div> <div class="uk-lightbox-counter uk-text-large uk-position-top-left uk-position-small uk-transition-fade" uk-inverse></div> <div class="uk-lightbox-caption uk-position-bottom uk-text-center uk-transition-slide-bottom uk-transition-opaque"></div> </div>',
      }),
      created() {
        let t = x(this.template);
        F(t, "template") && (t = St(bt(t)));
        const e = x(this.selList, t),
          i = this.$props.nav;
        Q(D(this.selNav, t).filter((o) => !C(o, `.uk-${i}`)));
        for (const [o, r] of this.items.entries())
          W(e, "<div>"),
            i === "thumbnav" &&
              Ne(
                Ka(r, this.videoAutoplay),
                W(
                  x(this.selNav, t),
                  `<li uk-lightbox-item="${o}"><a href></a></li>`
                )
              );
        this.slidenav || Q(D(".uk-lightbox-slidenav", t)),
          this.counter || Q(x(this.selCounter, t)),
          S(e, this.clsFit);
        const s = x("[uk-close]", t),
          n = this.t("close");
        s && n && (s.dataset.i18n = JSON.stringify({ label: n })),
          this.$mount(W(this.container, t));
      },
      events: [
        {
          name: "click",
          self: !0,
          filter: ({ bgClose: t }) => t,
          delegate: ({ selList: t }) => `${t} > *`,
          handler(t) {
            t.defaultPrevented || this.hide();
          },
        },
        {
          name: "click",
          self: !0,
          delegate: ({ clsZoom: t }) => `.${t}`,
          handler(t) {
            t.defaultPrevented || L(this.list, this.clsFit);
          },
        },
        {
          name: `${oi} ${ut} keydown`,
          filter: ({ delayControls: t }) => t,
          handler() {
            this.showControls();
          },
        },
        {
          name: "shown",
          self: !0,
          handler() {
            this.showControls();
          },
        },
        {
          name: "hide",
          self: !0,
          handler() {
            this.hideControls(),
              _(this.slides, this.clsActive),
              N.stop(this.slides);
          },
        },
        {
          name: "hidden",
          self: !0,
          handler() {
            this.$destroy(!0);
          },
        },
        {
          name: "keyup",
          el: () => document,
          handler({ keyCode: t }) {
            if (!this.isToggled(this.$el) || !this.draggable) return;
            let e = -1;
            t === M.LEFT
              ? (e = "previous")
              : t === M.RIGHT
              ? (e = "next")
              : t === M.HOME
              ? (e = 0)
              : t === M.END && (e = "last"),
              ~e && this.show(e);
          },
        },
        {
          name: "beforeitemshow",
          handler(t) {
            bt(x(this.selCaption, this.$el), this.getItem().caption || ""),
              bt(
                x(this.selCounter, this.$el),
                this.t("counter", this.index + 1, this.slides.length)
              );
            for (let e = -this.preload; e <= this.preload; e++)
              this.loadItem(this.index + e);
            this.isToggled() ||
              ((this.draggable = !1),
              t.preventDefault(),
              this.toggleElement(this.$el, !0, !1),
              (this.animation = so.scale),
              _(t.target, this.clsActive),
              this.stack.splice(1, 0, this.index));
          },
        },
        {
          name: "itemshown",
          handler() {
            this.draggable = this.$props.draggable;
          },
        },
        {
          name: "itemload",
          async handler(t, e) {
            const { source: i, type: s, attrs: n = {} } = e;
            if ((this.setItem(e, "<span uk-spinner uk-inverse></span>"), !i))
              return;
            let o;
            const r = {
              allowfullscreen: "",
              style: "max-width: 100%; box-sizing: border-box;",
              "uk-responsive": "",
              "uk-video": `${!!this.videoAutoplay}`,
            };
            if (s === "image" || oo(i)) {
              const a = Dt("img");
              Nn(a, e.sources),
                p(a, { src: i, ...ei(e, ["alt", "srcset", "sizes"]), ...n }),
                y(a, "load", () => this.setItem(e, O(a) || a)),
                y(a, "error", () => this.setError(e));
            } else if (s === "video" || ro(i)) {
              const a = this.videoAutoplay === "inline",
                l = Dt("video", {
                  src: i,
                  playsinline: "",
                  controls: a ? null : "",
                  loop: a ? "" : null,
                  poster: this.videoAutoplay ? null : e.poster,
                  "uk-video": a ? "automute: true" : !!this.videoAutoplay,
                  ...n,
                });
              y(l, "loadedmetadata", () => this.setItem(e, l)),
                y(l, "error", () => this.setError(e));
            } else if (s === "iframe" || i.match(/\.(html|php)($|\?)/i))
              this.setItem(
                e,
                Dt("iframe", {
                  src: i,
                  allowfullscreen: "",
                  class: "uk-lightbox-iframe",
                  ...n,
                })
              );
            else if (
              (o = i.match(
                /\/\/(?:.*?youtube(-nocookie)?\..*?(?:[?&]v=|\/shorts\/)|youtu\.be\/)([\w-]{11})[&?]?(.*)?/
              ))
            )
              this.setItem(
                e,
                Dt("iframe", {
                  src: `https://www.youtube${o[1] || ""}.com/embed/${o[2]}${
                    o[3] ? `?${o[3]}` : ""
                  }`,
                  width: 1920,
                  height: 1080,
                  ...r,
                  ...n,
                })
              );
            else if ((o = i.match(/\/\/.*?vimeo\.[a-z]+\/(\d+)[&?]?(.*)?/)))
              try {
                const { height: a, width: l } = await (
                  await fetch(
                    `https://vimeo.com/api/oembed.json?maxwidth=1920&url=${encodeURI(
                      i
                    )}`,
                    { credentials: "omit" }
                  )
                ).json();
                this.setItem(
                  e,
                  Dt("iframe", {
                    src: `https://player.vimeo.com/video/${o[1]}${
                      o[2] ? `?${o[2]}` : ""
                    }`,
                    width: l,
                    height: a,
                    ...r,
                    ...n,
                  })
                );
              } catch {
                this.setError(e);
              }
          },
        },
        {
          name: "itemloaded",
          handler() {
            this.$emit("resize");
          },
        },
      ],
      update: {
        read() {
          for (const t of D(
            `${this.selList} :not([controls]):is(img,video)`,
            this.$el
          ))
            L(
              t,
              this.clsZoom,
              (t.naturalHeight || t.videoHeight) - this.$el.offsetHeight >
                Math.max(
                  0,
                  (t.naturalWidth || t.videoWidth) - this.$el.offsetWidth
                )
            );
        },
        events: ["resize"],
      },
      methods: {
        loadItem(t = this.index) {
          const e = this.getItem(t);
          this.getSlide(e).childElementCount || v(this.$el, "itemload", [e]);
        },
        getItem(t = this.index) {
          return this.items[ot(t, this.slides)];
        },
        setItem(t, e) {
          v(this.$el, "itemloaded", [this, bt(this.getSlide(t), e)]);
        },
        getSlide(t) {
          return this.slides[this.items.indexOf(t)];
        },
        setError(t) {
          this.setItem(
            t,
            '<span uk-icon="icon: bolt; ratio: 2" uk-inverse></span>'
          );
        },
        showControls() {
          clearTimeout(this.controlsTimer),
            (this.controlsTimer =
              this.delayControls &&
              setTimeout(this.hideControls, this.delayControls)),
            S(this.$el, "uk-active", "uk-transition-active");
        },
        hideControls() {
          _(this.$el, "uk-active", "uk-transition-active");
        },
      },
    };
  function Dt(t, e) {
    const i = St(`<${t}>`);
    return p(i, e), i;
  }
  function Ka(t, e) {
    const i =
      t.poster || (t.thumb && (t.type === "image" || oo(t.thumb)))
        ? Dt("img", { src: t.poster || t.thumb, alt: "" })
        : t.thumb && (t.type === "video" || ro(t.thumb))
        ? Dt("video", {
            src: t.thumb,
            loop: "",
            playsinline: "",
            "uk-video": `autoplay: ${!!e}; automute: true`,
          })
        : Dt("canvas");
    return t.thumbRatio && (i.style.aspectRatio = t.thumbRatio), i;
  }
  function oo(t) {
    return t == null
      ? void 0
      : t.match(/\.(avif|jpe?g|jfif|a?png|gif|svg|webp)($|\?)/i);
  }
  function ro(t) {
    return t == null ? void 0 : t.match(/\.(mp4|webm|ogv)($|\?)/i);
  }
  const Za = ".uk-disabled *, .uk-disabled, [disabled]";
  var Qa = {
    install: tl,
    props: { toggle: String },
    data: { toggle: "a" },
    computed: { toggles: ({ toggle: t }, e) => D(t, e) },
    watch: {
      toggles(t) {
        this.hide();
        for (const e of t) F(e, "a") && p(e, "role", "button");
      },
    },
    disconnected() {
      this.hide();
    },
    events: {
      name: "click",
      delegate: ({ toggle: t }) => t,
      handler(t) {
        t.defaultPrevented ||
          (t.preventDefault(), C(t.current, Za) || this.show(t.current));
      },
    },
    methods: {
      show(t) {
        let e = this.toggles.map(ao);
        if (
          (this.nav === "thumbnav" && el.call(this, this.toggles, e),
          (e = qs(e, "source")),
          se(t))
        ) {
          const { source: i } = ao(t);
          t = xt(e, ({ source: s }) => i === s);
        }
        return (
          (this.panel =
            this.panel ||
            this.$create("lightboxPanel", { ...this.$props, items: e })),
          y(this.panel.$el, "hidden", () => (this.panel = null)),
          this.panel.show(t)
        );
      },
      hide() {
        var t;
        return (t = this.panel) == null ? void 0 : t.hide();
      },
    },
  };
  function tl(t, e) {
    t.lightboxPanel || t.component("lightboxPanel", no),
      ft(e.props, t.component("lightboxPanel").options.props);
  }
  function el(t, e) {
    for (const [i, s] of Object.entries(t)) {
      if (e[i].thumb) continue;
      const n = ce(s)
        .reverse()
        .concat(s)
        .find(
          (r) =>
            this.$el.contains(r) && (r === s || D(this.toggle, r).length === 1)
        );
      if (!n) continue;
      const o = x("img,video", n);
      o &&
        ((e[i].thumb = o.currentSrc || o.poster || o.src),
        (e[i].thumbRatio =
          (o.naturalWidth || o.videoWidth) /
          (o.naturalHeight || o.videoHeight)));
    }
  }
  function ao(t) {
    const e = {};
    for (const i of t.getAttributeNames()) {
      const s = i.replace(/^data-/, "");
      e[s === "href" ? "source" : s] = t.getAttribute(i);
    }
    return (e.attrs = ge(e.attrs)), e;
  }
  var il = {
    mixins: [Ue],
    functional: !0,
    args: ["message", "status"],
    data: {
      message: "",
      status: "",
      timeout: 5e3,
      group: "",
      pos: "top-center",
      clsContainer: "uk-notification",
      clsClose: "uk-notification-close",
      clsMsg: "uk-notification-message",
    },
    install: sl,
    computed: {
      marginProp: ({ pos: t }) => `margin-${t.match(/[a-z]+(?=-)/)[0]}`,
      startProps() {
        return { opacity: 0, [this.marginProp]: -this.$el.offsetHeight };
      },
    },
    created() {
      const t = `${this.clsContainer}-${this.pos}`,
        e = `data-${this.clsContainer}-container`,
        i =
          x(`.${t}[${e}]`, this.container) ||
          W(
            this.container,
            `<div class="${this.clsContainer} ${t}" ${e}></div>`
          );
      this.$mount(
        W(
          i,
          `<div class="${this.clsMsg}${
            this.status ? ` ${this.clsMsg}-${this.status}` : ""
          }" role="alert"> <a href class="${
            this.clsClose
          }" data-uk-close></a> <div>${this.message}</div> </div>`
        )
      );
    },
    async connected() {
      const t = k(h(this.$el, this.marginProp));
      await N.start(h(this.$el, this.startProps), {
        opacity: 1,
        [this.marginProp]: t,
      }),
        this.timeout && (this.timer = setTimeout(this.close, this.timeout));
    },
    events: {
      click(t) {
        t.target.closest('a[href="#"],a[href=""]') && t.preventDefault(),
          this.close();
      },
      [jt]() {
        this.timer && clearTimeout(this.timer);
      },
      [le]() {
        this.timeout && (this.timer = setTimeout(this.close, this.timeout));
      },
    },
    methods: {
      async close(t) {
        const e = (i) => {
          const s = O(i);
          v(i, "close", [this]), Q(i), (s != null && s.hasChildNodes()) || Q(s);
        };
        this.timer && clearTimeout(this.timer),
          t || (await N.start(this.$el, this.startProps)),
          e(this.$el);
      },
    },
  };
  function sl(t) {
    t.notification.closeAll = function (e, i) {
      _t(document.body, (s) => {
        const n = t.getComponent(s, "notification");
        n && (!e || e === n.group) && n.close(i);
      });
    };
  }
  var Ei = {
    props: { media: Boolean },
    data: { media: !1 },
    connected() {
      const t = nl(this.media, this.$el);
      if (((this.matchMedia = !0), t)) {
        this.mediaObj = window.matchMedia(t);
        const e = () => {
          (this.matchMedia = this.mediaObj.matches),
            v(this.$el, de("mediachange", !1, !0, [this.mediaObj]));
        };
        (this.offMediaObj = y(this.mediaObj, "change", () => {
          e(), this.$emit("resize");
        })),
          e();
      }
    },
    disconnected() {
      var t;
      (t = this.offMediaObj) == null || t.call(this);
    },
  };
  function nl(t, e) {
    if (H(t)) {
      if (mt(t, "@")) t = k(h(e, `--uk-breakpoint-${t.slice(1)}`));
      else if (isNaN(t)) return t;
    }
    return t && vt(t) ? `(min-width: ${t}px)` : "";
  }
  function lo(t) {
    return q(t)
      ? Math.ceil(
          Math.max(
            0,
            ...D("[stroke]", t).map((e) => {
              var i;
              return ((i = e.getTotalLength) == null ? void 0 : i.call(e)) || 0;
            })
          )
        )
      : 0;
  }
  const Ci = {
      x: Pi,
      y: Pi,
      rotate: Pi,
      scale: Pi,
      color: Os,
      backgroundColor: Os,
      borderColor: Os,
      blur: Kt,
      hue: Kt,
      fopacity: Kt,
      grayscale: Kt,
      invert: Kt,
      saturate: Kt,
      sepia: Kt,
      opacity: rl,
      stroke: al,
      bgx: uo,
      bgy: uo,
    },
    { keys: ho } = Object;
  var co = {
    mixins: [Ei],
    props: vo(ho(Ci), "list"),
    data: vo(ho(Ci), void 0),
    computed: {
      props(t, e) {
        const i = {};
        for (const n in t) n in Ci && !X(t[n]) && (i[n] = t[n].slice());
        const s = {};
        for (const n in i) s[n] = Ci[n](n, e, i[n], i);
        return s;
      },
    },
    events: {
      load() {
        this.$emit();
      },
    },
    methods: {
      reset() {
        for (const t in this.getCss(0)) h(this.$el, t, "");
      },
      getCss(t) {
        const e = {};
        for (const i in this.props) this.props[i](e, K(t));
        return (e.willChange = Object.keys(e).map(hi).join(",")), e;
      },
    },
  };
  function Pi(t, e, i) {
    let s = Ai(i) || { x: "px", y: "px", rotate: "deg" }[t] || "",
      n;
    return (
      t === "x" || t === "y"
        ? ((t = `translate${Nt(t)}`),
          (n = (o) => k(k(o).toFixed(s === "px" ? 0 : 6))))
        : t === "scale" &&
          ((s = ""),
          (n = (o) => {
            var r;
            return Ai([o])
              ? G(o, "width", e, !0) /
                  e[
                    `offset${
                      (r = o.endsWith) != null && r.call(o, "vh")
                        ? "Height"
                        : "Width"
                    }`
                  ]
              : k(o);
          })),
      i.length === 1 && i.unshift(t === "scale" ? 1 : 0),
      (i = xe(i, n)),
      (o, r) => {
        o.transform = `${o.transform || ""} ${t}(${Xe(i, r)}${s})`;
      }
    );
  }
  function Os(t, e, i) {
    return (
      i.length === 1 && i.unshift(Je(e, t, "")),
      (i = xe(i, (s) => ol(e, s))),
      (s, n) => {
        const [o, r, a] = mo(i, n),
          l = o
            .map(
              (c, u) => (
                (c += a * (r[u] - c)), u === 3 ? k(c) : parseInt(c, 10)
              )
            )
            .join(",");
        s[t] = `rgba(${l})`;
      }
    );
  }
  function ol(t, e) {
    return Je(t, "color", e)
      .split(/[(),]/g)
      .slice(1, -1)
      .concat(1)
      .slice(0, 4)
      .map(k);
  }
  function Kt(t, e, i) {
    i.length === 1 && i.unshift(0);
    const s = Ai(i) || { blur: "px", hue: "deg" }[t] || "%";
    return (
      (t = { fopacity: "opacity", hue: "hue-rotate" }[t] || t),
      (i = xe(i)),
      (n, o) => {
        const r = Xe(i, o);
        n.filter = `${n.filter || ""} ${t}(${r + s})`;
      }
    );
  }
  function rl(t, e, i) {
    return (
      i.length === 1 && i.unshift(Je(e, t, "")),
      (i = xe(i)),
      (s, n) => {
        s[t] = Xe(i, n);
      }
    );
  }
  function al(t, e, i) {
    i.length === 1 && i.unshift(0);
    const s = Ai(i),
      n = lo(e);
    return (
      (i = xe(i.reverse(), (o) => ((o = k(o)), s === "%" ? (o * n) / 100 : o))),
      i.some(([o]) => o)
        ? (h(e, "strokeDasharray", n),
          (o, r) => {
            o.strokeDashoffset = Xe(i, r);
          })
        : A
    );
  }
  function uo(t, e, i, s) {
    i.length === 1 && i.unshift(0);
    const n = t === "bgy" ? "height" : "width";
    s[t] = xe(i, (a) => G(a, n, e));
    const o = ["bgx", "bgy"].filter((a) => a in s);
    if (o.length === 2 && t === "bgx") return A;
    if (Je(e, "backgroundSize", "") === "cover") return ll(t, e, i, s);
    const r = {};
    for (const a of o) r[a] = fo(e, a);
    return po(o, r, s);
  }
  function ll(t, e, i, s) {
    const n = hl(e);
    if (!n.width) return A;
    const o = { width: e.offsetWidth, height: e.offsetHeight },
      r = ["bgx", "bgy"].filter((u) => u in s),
      a = {};
    for (const u of r) {
      const d = s[u].map(([P]) => P),
        f = Math.min(...d),
        g = Math.max(...d),
        w = d.indexOf(f) < d.indexOf(g),
        I = g - f;
      (a[u] = `${(w ? -I : 0) - (w ? f : g)}px`),
        (o[u === "bgy" ? "height" : "width"] += I);
    }
    const l = Ri.cover(n, o);
    for (const u of r) {
      const d = u === "bgy" ? "height" : "width",
        f = l[d] - o[d];
      a[u] = `max(${fo(e, u)},-${f}px) + ${a[u]}`;
    }
    const c = po(r, a, s);
    return (u, d) => {
      c(u, d),
        (u.backgroundSize = `${l.width}px ${l.height}px`),
        (u.backgroundRepeat = "no-repeat");
    };
  }
  function fo(t, e) {
    return Je(t, `background-position-${e.slice(-1)}`, "");
  }
  function po(t, e, i) {
    return function (s, n) {
      for (const o of t) {
        const r = Xe(i[o], n);
        s[`background-position-${o.slice(-1)}`] = `calc(${e[o]} + ${r}px)`;
      }
    };
  }
  const go = {},
    _i = {};
  function hl(t) {
    const e = h(t, "backgroundImage").replace(
      /^none|url\(["']?(.+?)["']?\)$/,
      "$1"
    );
    if (_i[e]) return _i[e];
    const i = new Image();
    return e && ((i.src = e), !i.naturalWidth && !go[e])
      ? (z(i, "error load", () => {
          (_i[e] = Ds(i)), v(t, de("load", !1));
        }),
        (go[e] = !0),
        Ds(i))
      : (_i[e] = Ds(i));
  }
  function Ds(t) {
    return { width: t.naturalWidth, height: t.naturalHeight };
  }
  function xe(t, e = k) {
    const i = [],
      { length: s } = t;
    let n = 0;
    for (let o = 0; o < s; o++) {
      let [r, a] = H(t[o]) ? t[o].trim().split(/ (?![^(]*\))/) : [t[o]];
      if (
        ((r = e(r)),
        (a = a ? k(a) / 100 : null),
        o === 0
          ? a === null
            ? (a = 0)
            : a && i.push([r, 0])
          : o === s - 1 &&
            (a === null ? (a = 1) : a !== 1 && (i.push([r, a]), (a = 1))),
        i.push([r, a]),
        a === null)
      )
        n++;
      else if (n) {
        const l = i[o - n - 1][1],
          c = (a - l) / (n + 1);
        for (let u = n; u > 0; u--) i[o - u][1] = l + c * (n - u + 1);
        n = 0;
      }
    }
    return i;
  }
  function mo(t, e) {
    const i = xt(t.slice(1), ([, s]) => e <= s) + 1;
    return [t[i - 1][0], t[i][0], (e - t[i - 1][1]) / (t[i][1] - t[i - 1][1])];
  }
  function Xe(t, e) {
    const [i, s, n] = mo(t, e);
    return i + Math.abs(i - s) * n * (i < s ? 1 : -1);
  }
  const cl = /^-?\d+(?:\.\d+)?(\S+)?/;
  function Ai(t, e) {
    var i;
    for (const s of t) {
      const n = (i = s.match) == null ? void 0 : i.call(s, cl);
      if (n) return n[1];
    }
    return e;
  }
  function Je(t, e, i) {
    const s = t.style[e],
      n = h(h(t, e, i), e);
    return (t.style[e] = s), n;
  }
  function vo(t, e) {
    return t.reduce((i, s) => ((i[s] = e), i), {});
  }
  function bo(t, e) {
    return e >= 0 ? Math.pow(t, e + 1) : 1 - Math.pow(1 - t, 1 - e);
  }
  var ul = {
    mixins: [co],
    props: {
      target: String,
      viewport: Number,
      easing: Number,
      start: String,
      end: String,
    },
    data: { target: !1, viewport: 1, easing: 1, start: 0, end: 0 },
    computed: {
      target: ({ target: t }, e) => wo((t && tt(t, e)) || e),
      start({ start: t }) {
        return G(t, "height", this.target, !0);
      },
      end({ end: t, viewport: e }) {
        return G(
          t || ((e = (1 - e) * 100) && `${e}vh+${e}%`),
          "height",
          this.target,
          !0
        );
      },
    },
    observe: [
      vs(),
      Re({ target: ({ target: t }) => t }),
      dt({ target: ({ $el: t, target: e }) => [t, e, Ot(e, !0)] }),
    ],
    update: {
      read({ percent: t }, e) {
        if ((e.has("scroll") || (t = !1), !q(this.$el))) return !1;
        if (!this.matchMedia) return;
        const i = t;
        return (
          (t = bo(wi(this.target, this.start, this.end), this.easing)),
          { percent: t, style: i === t ? !1 : this.getCss(t) }
        );
      },
      write({ style: t }) {
        if (!this.matchMedia) {
          this.reset();
          return;
        }
        t && h(this.$el, t);
      },
      events: ["scroll", "resize"],
    },
  };
  function wo(t) {
    return t ? ("offsetTop" in t ? t : wo(O(t))) : document.documentElement;
  }
  var xo = {
    props: {
      parallax: Boolean,
      parallaxTarget: Boolean,
      parallaxStart: String,
      parallaxEnd: String,
      parallaxEasing: Number,
    },
    data: {
      parallax: !1,
      parallaxTarget: !1,
      parallaxStart: 0,
      parallaxEnd: 0,
      parallaxEasing: 0,
    },
    observe: [
      dt({
        target: ({ $el: t, parallaxTarget: e }) => [t, e],
        filter: ({ parallax: t }) => t,
      }),
      Re({ filter: ({ parallax: t }) => t }),
    ],
    computed: {
      parallaxTarget({ parallaxTarget: t }, e) {
        return (t && tt(t, e)) || this.list;
      },
    },
    update: {
      read() {
        if (!this.parallax) return !1;
        const t = this.parallaxTarget;
        if (!t) return !1;
        const e = G(this.parallaxStart, "height", t, !0),
          i = G(this.parallaxEnd, "height", t, !0),
          s = bo(wi(t, e, i), this.parallaxEasing);
        return { parallax: this.getIndexAt(s) };
      },
      write({ parallax: t }) {
        const [e, i] = t,
          s = this.getValidIndex(e + Math.ceil(i)),
          n = this.slides[e],
          o = this.slides[s],
          {
            triggerShow: r,
            triggerShown: a,
            triggerHide: l,
            triggerHidden: c,
          } = dl(this);
        if (~this.prevIndex)
          for (const d of new Set([this.index, this.prevIndex]))
            b([s, e], d) || (l(this.slides[d]), c(this.slides[d]));
        const u = this.prevIndex !== e || this.index !== s;
        (this.dir = 1),
          (this.prevIndex = e),
          (this.index = s),
          n !== o && l(n),
          r(o),
          u && a(n),
          this._translate(n === o ? 1 : i, n, o);
      },
      events: ["scroll", "resize"],
    },
    methods: {
      getIndexAt(t) {
        const e = t * (this.length - 1);
        return [Math.floor(e), e % 1];
      },
    },
  };
  function dl(t) {
    const { clsSlideActive: e, clsEnter: i, clsLeave: s } = t;
    return {
      triggerShow: n,
      triggerShown: o,
      triggerHide: r,
      triggerHidden: a,
    };
    function n(l) {
      $(l, s) && (r(l), a(l)),
        $(l, e) || (v(l, "beforeitemshow", [t]), v(l, "itemshow", [t]));
    }
    function o(l) {
      $(l, i) && v(l, "itemshown", [t]);
    }
    function r(l) {
      $(l, e) || n(l),
        $(l, i) && o(l),
        $(l, s) || (v(l, "beforeitemhide", [t]), v(l, "itemhide", [t]));
    }
    function a(l) {
      $(l, s) && v(l, "itemhidden", [t]);
    }
  }
  var $o = {
      update: {
        write() {
          if (this.stack.length || this.dragging || this.parallax) return;
          const t = this.getValidIndex();
          !~this.prevIndex || this.index !== t
            ? this.show(t)
            : this._translate(1);
        },
        events: ["resize"],
      },
    },
    yo = {
      observe: yi({
        target: ({ slides: t }) => t,
        targets: (t) => t.getAdjacentSlides(),
      }),
      methods: {
        getAdjacentSlides() {
          return [1, -1].map((t) => this.slides[this.getIndex(this.index + t)]);
        },
      },
    };
  function fl(t, e, i, { center: s, easing: n, list: o }) {
    const r = t ? Ke(t, o, s) : Ke(e, o, s) + m(e).width * i,
      a = e ? Ke(e, o, s) : r + m(t).width * i * (U ? -1 : 1),
      { promise: l, resolve: c } = Ln();
    return {
      dir: i,
      show(u, d = 0, f) {
        const g = f ? "linear" : n;
        return (
          (u -= Math.round(u * K(d, -1, 1))),
          h(o, "transitionProperty", "none"),
          this.translate(d),
          h(o, "transitionProperty", ""),
          (d = t ? d : K(d, 0, 1)),
          Gt(this.getItemIn(), "itemin", {
            percent: d,
            duration: u,
            timing: g,
            dir: i,
          }),
          t &&
            Gt(this.getItemIn(!0), "itemout", {
              percent: 1 - d,
              duration: u,
              timing: g,
              dir: i,
            }),
          N.start(o, { transform: j(-a * (U ? -1 : 1), "px") }, u, g).then(
            c,
            A
          ),
          l
        );
      },
      cancel() {
        return N.cancel(o);
      },
      reset() {
        h(o, "transform", "");
      },
      async forward(u, d = this.percent()) {
        return await this.cancel(), this.show(u, d, !0);
      },
      translate(u) {
        if (u === this.percent()) return;
        const d = this.getDistance() * i * (U ? -1 : 1);
        h(
          o,
          "transform",
          j(K(-a + (d - d * u), -$e(o), m(o).width) * (U ? -1 : 1), "px")
        );
        const f = this.getActives(),
          g = this.getItemIn(),
          w = this.getItemIn(!0);
        u = t ? K(u, -1, 1) : 0;
        for (const I of B(o)) {
          const P = b(f, I),
            ht = I === g,
            It = I === w,
            Mt =
              ht ||
              (!It &&
                (P || (i * (U ? -1 : 1) === -1) ^ (Oi(I, o) > Oi(t || e))));
          Gt(I, `itemtranslate${Mt ? "in" : "out"}`, {
            dir: i,
            percent: It ? 1 - u : ht ? u : P ? 1 : 0,
          });
        }
      },
      percent() {
        return Math.abs(
          (new DOMMatrix(h(o, "transform")).m41 * (U ? -1 : 1) + r) / (a - r)
        );
      },
      getDistance() {
        return Math.abs(a - r);
      },
      getItemIn(u = !1) {
        let d = this.getActives(),
          f = So(o, Ke(e || t, o, s));
        if (u) {
          const g = d;
          (d = f), (f = g);
        }
        return f[xt(f, (g) => !b(d, g))];
      },
      getActives() {
        return So(o, Ke(t || e, o, s));
      },
    };
  }
  function Ke(t, e, i) {
    const s = Oi(t, e);
    return i ? s - pl(t, e) : Math.min(s, ko(e));
  }
  function ko(t) {
    return Math.max(0, $e(t) - m(t).width);
  }
  function $e(t, e) {
    return Ht(B(t).slice(0, e), (i) => m(i).width);
  }
  function pl(t, e) {
    return m(e).width / 2 - m(t).width / 2;
  }
  function Oi(t, e) {
    return (
      (t && (es(t).left + (U ? m(t).width - m(e).width : 0)) * (U ? -1 : 1)) ||
      0
    );
  }
  function So(t, e) {
    e -= 1;
    const i = m(t).width,
      s = e + i + 2;
    return B(t).filter((n) => {
      const o = Oi(n, t),
        r = o + Math.min(m(n).width, i);
      return o >= e && r <= s;
    });
  }
  var gl = {
    mixins: [it, to, $o, xo, yo],
    props: { center: Boolean, sets: Boolean, active: String },
    data: {
      center: !1,
      sets: !1,
      attrItem: "uk-slider-item",
      selList: ".uk-slider-items",
      selNav: ".uk-slider-nav",
      clsContainer: "uk-slider-container",
      active: "all",
      Transitioner: fl,
    },
    computed: {
      finite({ finite: t }) {
        return t || ml(this.list, this.center);
      },
      maxIndex() {
        if (!this.finite || (this.center && !this.sets)) return this.length - 1;
        if (this.center) return Ft(this.sets);
        let t = 0;
        const e = ko(this.list),
          i = xt(this.slides, (s) => {
            if (t >= e - 0.005) return !0;
            t += m(s).width;
          });
        return ~i ? i : this.length - 1;
      },
      sets({ sets: t }) {
        if (!t || this.parallax) return;
        let e = 0;
        const i = [],
          s = m(this.list).width;
        for (let n = 0; n < this.length; n++) {
          const o = m(this.slides[n]).width;
          e + o > s && (e = 0),
            this.center
              ? e < s / 2 &&
                e + o + m(this.slides[ot(n + 1, this.slides)]).width / 2 >
                  s / 2 &&
                (i.push(n), (e = s / 2 - o / 2))
              : e === 0 && i.push(Math.min(n, this.maxIndex)),
            (e += o);
        }
        if (i.length) return i;
      },
      transitionOptions() {
        return { center: this.center, list: this.list };
      },
      slides() {
        return B(this.list).filter(q);
      },
    },
    connected() {
      L(this.$el, this.clsContainer, !x(`.${this.clsContainer}`, this.$el));
    },
    observe: dt({ target: ({ slides: t, $el: e }) => [e, ...t] }),
    update: {
      write() {
        for (const t of this.navItems) {
          const e = $t(Z(t, this.attrItem));
          e !== !1 &&
            (t.hidden =
              !this.maxIndex ||
              e > this.maxIndex ||
              (this.sets && !b(this.sets, e)));
        }
        this.reorder(),
          this.parallax || this._translate(1),
          this.updateActiveClasses();
      },
      events: ["resize"],
    },
    events: {
      beforeitemshow(t) {
        !this.dragging &&
          this.sets &&
          this.stack.length < 2 &&
          !b(this.sets, this.index) &&
          (this.index = this.getValidIndex());
        const e = Math.abs(
          this.index -
            this.prevIndex +
            ((this.dir > 0 && this.index < this.prevIndex) ||
            (this.dir < 0 && this.index > this.prevIndex)
              ? (this.maxIndex + 1) * this.dir
              : 0)
        );
        if (!this.dragging && e > 1) {
          for (let n = 0; n < e; n++)
            this.stack.splice(1, 0, this.dir > 0 ? "next" : "previous");
          t.preventDefault();
          return;
        }
        const i =
            this.dir < 0 || !this.slides[this.prevIndex]
              ? this.index
              : this.prevIndex,
          s = $e(this.list) / this.length;
        (this.duration = eo(s / this.velocity) * (m(this.slides[i]).width / s)),
          this.reorder();
      },
      itemshow() {
        ~this.prevIndex &&
          S(this._getTransitioner().getItemIn(), this.clsActive),
          this.updateActiveClasses(this.prevIndex);
      },
      itemshown() {
        this.updateActiveClasses();
      },
    },
    methods: {
      reorder() {
        if (this.finite) {
          h(this.slides, "order", "");
          return;
        }
        const t =
          this.dir > 0 && this.slides[this.prevIndex]
            ? this.prevIndex
            : this.index;
        if (
          (this.slides.forEach((n, o) =>
            h(
              n,
              "order",
              this.dir > 0 && o < t
                ? 1
                : this.dir < 0 && o >= this.index
                ? -1
                : ""
            )
          ),
          !this.center || !this.length)
        )
          return;
        const e = this.slides[t];
        let i = m(this.list).width / 2 - m(e).width / 2,
          s = 0;
        for (; i > 0; ) {
          const n = this.getIndex(--s + t, t),
            o = this.slides[n];
          h(o, "order", n > t ? -2 : -1), (i -= m(o).width);
        }
      },
      updateActiveClasses(t = this.index) {
        let e = this._getTransitioner(t).getActives();
        this.active !== "all" && (e = [this.slides[this.getValidIndex(t)]]);
        const i = [
          this.clsActive,
          !this.sets || b(this.sets, k(this.index)) ? this.clsActivated : "",
        ];
        for (const s of this.slides) {
          const n = b(e, s);
          L(s, i, n), p(s, "aria-hidden", !n);
          for (const o of D(he, s))
            gt(o, "_tabindex") || (o._tabindex = p(o, "tabindex")),
              p(o, "tabindex", n ? o._tabindex : -1);
        }
      },
      getValidIndex(t = this.index, e = this.prevIndex) {
        if (((t = this.getIndex(t, e)), !this.sets)) return t;
        let i;
        do {
          if (b(this.sets, t)) return t;
          (i = t), (t = this.getIndex(t + this.dir, e));
        } while (t !== i);
        return t;
      },
      getAdjacentSlides() {
        const { width: t } = m(this.list),
          e = -t,
          i = t * 2,
          s = m(this.slides[this.index]).width,
          n = this.center ? t / 2 - s / 2 : 0,
          o = new Set();
        for (const r of [-1, 1]) {
          let a = n + (r > 0 ? s : 0),
            l = 0;
          do {
            const c = this.slides[this.getIndex(this.index + r + l++ * r)];
            (a += m(c).width * r), o.add(c);
          } while (this.length > l && a > e && a < i);
        }
        return Array.from(o);
      },
      getIndexAt(t) {
        let e = -1;
        const i = this.center
          ? $e(this.list) -
            (m(this.slides[0]).width / 2 + m(Ft(this.slides)).width / 2)
          : $e(this.list, this.maxIndex);
        let s = t * i,
          n = 0;
        do {
          const o = m(this.slides[++e]).width,
            r = this.center ? o / 2 + m(this.slides[e + 1]).width / 2 : o;
          (n = (s / r) % 1), (s -= r);
        } while (s >= 0 && e < this.maxIndex);
        return [e, n];
      },
    },
  };
  function ml(t, e) {
    if (!t || t.length < 2) return !0;
    const { width: i } = m(t);
    if (!e) return Math.ceil($e(t)) < Math.trunc(i + vl(t));
    const s = B(t),
      n = Math.trunc(i / 2);
    for (const o in s) {
      const r = s[o],
        a = m(r).width,
        l = new Set([r]);
      let c = 0;
      for (const u of [-1, 1]) {
        let d = a / 2,
          f = 0;
        for (; d < n; ) {
          const g = s[ot(+o + u + f++ * u, s)];
          if (l.has(g)) return !0;
          (d += m(g).width), l.add(g);
        }
        c = Math.max(c, a / 2 + m(s[ot(+o + u, s)]).width / 2 - (d - n));
      }
      if (
        Math.trunc(c) >
        Ht(
          s.filter((u) => !l.has(u)),
          (u) => m(u).width
        )
      )
        return !0;
    }
    return !1;
  }
  function vl(t) {
    return Math.max(0, ...B(t).map((e) => m(e).width));
  }
  var Io = {
    mixins: [co],
    beforeConnect() {
      this.item = this.$el.closest(
        `.${this.$options.id.replace("parallax", "items")} > *`
      );
    },
    disconnected() {
      this.item = null;
    },
    events: [
      {
        name: "itemin itemout",
        self: !0,
        el: ({ item: t }) => t,
        handler({
          type: t,
          detail: { percent: e, duration: i, timing: s, dir: n },
        }) {
          At.read(() => {
            if (!this.matchMedia) return;
            const o = this.getCss(Eo(t, n, e)),
              r = this.getCss(To(t) ? 0.5 : n > 0 ? 1 : 0);
            At.write(() => {
              h(this.$el, o), N.start(this.$el, r, i, s).catch(A);
            });
          });
        },
      },
      {
        name: "transitioncanceled transitionend",
        self: !0,
        el: ({ item: t }) => t,
        handler() {
          N.cancel(this.$el);
        },
      },
      {
        name: "itemtranslatein itemtranslateout",
        self: !0,
        el: ({ item: t }) => t,
        handler({ type: t, detail: { percent: e, dir: i } }) {
          At.read(() => {
            if (!this.matchMedia) {
              this.reset();
              return;
            }
            const s = this.getCss(Eo(t, i, e));
            At.write(() => h(this.$el, s));
          });
        },
      },
    ],
  };
  function To(t) {
    return ee(t, "in");
  }
  function Eo(t, e, i) {
    return (i /= 2), To(t) ^ (e < 0) ? i : 1 - i;
  }
  var bl = {
      mixins: [it, io, $o, xo, yo],
      props: { ratio: String, minHeight: String, maxHeight: String },
      data: {
        ratio: "16:9",
        minHeight: void 0,
        maxHeight: void 0,
        selList: ".uk-slideshow-items",
        attrItem: "uk-slideshow-item",
        selNav: ".uk-slideshow-nav",
        Animations: Ja,
      },
      watch: {
        list(t) {
          h(t, {
            aspectRatio: this.ratio ? this.ratio.replace(":", "/") : void 0,
            minHeight: this.minHeight,
            maxHeight: this.maxHeight,
            width: "100%",
          });
        },
      },
      methods: {
        getAdjacentSlides() {
          return [1, -1].map((t) => this.slides[this.getIndex(this.index + t)]);
        },
      },
    },
    wl = {
      mixins: [it, On],
      props: {
        group: String,
        threshold: Number,
        clsItem: String,
        clsPlaceholder: String,
        clsDrag: String,
        clsDragState: String,
        clsBase: String,
        clsNoDrag: String,
        clsEmpty: String,
        clsCustom: String,
        handle: String,
      },
      data: {
        group: !1,
        threshold: 5,
        clsItem: "uk-sortable-item",
        clsPlaceholder: "uk-sortable-placeholder",
        clsDrag: "uk-sortable-drag",
        clsDragState: "uk-drag",
        clsBase: "uk-sortable",
        clsNoDrag: "uk-sortable-nodrag",
        clsEmpty: "uk-sortable-empty",
        clsCustom: "",
        handle: !1,
        pos: {},
      },
      events: {
        name: ut,
        passive: !1,
        handler(t) {
          this.init(t);
        },
      },
      computed: {
        target: (t, e) => (e.tBodies || [e])[0],
        items() {
          return B(this.target);
        },
        isEmpty() {
          return !this.items.length;
        },
        handles({ handle: t }, e) {
          return t ? D(t, e) : this.items;
        },
      },
      watch: {
        isEmpty(t) {
          L(this.target, this.clsEmpty, t);
        },
        handles(t, e) {
          h(e, { touchAction: "", userSelect: "" }),
            h(t, { touchAction: "none", userSelect: "none" });
        },
      },
      update: {
        write(t) {
          if (!this.drag || !O(this.placeholder)) return;
          const {
            pos: { x: e, y: i },
            origin: { offsetTop: s, offsetLeft: n },
            placeholder: o,
          } = this;
          h(this.drag, { top: i - s, left: e - n });
          const r = this.getSortable(document.elementFromPoint(e, i));
          if (!r) return;
          const { items: a } = r;
          if (a.some(N.inProgress)) return;
          const l = kl(a, { x: e, y: i });
          if (a.length && (!l || l === o)) return;
          const c = this.getSortable(o),
            u = Sl(r.target, l, o, e, i, r === c && t.moved !== l);
          u !== !1 &&
            ((u && o === u) ||
              (r !== c ? (c.remove(o), (t.moved = l)) : delete t.moved,
              r.insert(o, u),
              this.touched.add(r)));
        },
        events: ["move"],
      },
      methods: {
        init(t) {
          const { target: e, button: i, defaultPrevented: s } = t,
            [n] = this.items.filter((o) => o.contains(e));
          !n ||
            s ||
            i > 0 ||
            ai(e) ||
            e.closest(`.${this.clsNoDrag}`) ||
            (this.handle && !e.closest(this.handle)) ||
            (t.preventDefault(),
            (this.pos = kt(t)),
            (this.touched = new Set([this])),
            (this.placeholder = n),
            (this.origin = { target: e, index: yt(n), ...this.pos }),
            y(document, oi, this.move),
            y(document, Ct, this.end),
            this.threshold || this.start(t));
        },
        start(t) {
          this.drag = yl(this.$container, this.placeholder);
          const { left: e, top: i } = m(this.placeholder);
          ft(this.origin, {
            offsetLeft: this.pos.x - e,
            offsetTop: this.pos.y - i,
          }),
            S(this.drag, this.clsDrag, this.clsCustom),
            S(this.placeholder, this.clsPlaceholder),
            S(this.items, this.clsItem),
            S(document.documentElement, this.clsDragState),
            v(this.$el, "start", [this, this.placeholder]),
            xl(this.pos),
            this.move(t);
        },
        move: Tl(function (t) {
          ft(this.pos, kt(t)),
            !this.drag &&
              (Math.abs(this.pos.x - this.origin.x) > this.threshold ||
                Math.abs(this.pos.y - this.origin.y) > this.threshold) &&
              this.start(t),
            this.$emit("move");
        }),
        end() {
          if (
            (Rt(document, oi, this.move),
            Rt(document, Ct, this.end),
            !this.drag)
          )
            return;
          $l();
          const t = this.getSortable(this.placeholder);
          this === t
            ? this.origin.index !== yt(this.placeholder) &&
              v(this.$el, "moved", [this, this.placeholder])
            : (v(t.$el, "added", [t, this.placeholder]),
              v(this.$el, "removed", [this, this.placeholder])),
            v(this.$el, "stop", [this, this.placeholder]),
            Q(this.drag),
            (this.drag = null);
          for (const { clsPlaceholder: e, clsItem: i } of this.touched)
            for (const s of this.touched) _(s.items, e, i);
          (this.touched = null), _(document.documentElement, this.clsDragState);
        },
        insert(t, e) {
          S(this.items, this.clsItem),
            e && e.previousElementSibling !== t
              ? this.animate(() => ui(e, t))
              : !e &&
                this.target.lastElementChild !== t &&
                this.animate(() => W(this.target, t));
        },
        remove(t) {
          this.target.contains(t) && this.animate(() => Q(t));
        },
        getSortable(t) {
          do {
            const e = this.$getComponent(t, "sortable");
            if (
              e &&
              (e === this || (this.group !== !1 && e.group === this.group))
            )
              return e;
          } while ((t = O(t)));
        },
      },
    };
  let Co;
  function xl(t) {
    let e = Date.now();
    Co = setInterval(() => {
      let { x: i, y: s } = t;
      s += document.scrollingElement.scrollTop;
      const n = (Date.now() - e) * 0.3;
      (e = Date.now()),
        Ut(document.elementFromPoint(i, t.y))
          .reverse()
          .some((o) => {
            let { scrollTop: r, scrollHeight: a } = o;
            const { top: l, bottom: c, height: u } = rt(o);
            if (l < s && l + 35 > s) r -= n;
            else if (c > s && c - 35 < s) r += n;
            else return;
            if (r > 0 && r < a - u) return (o.scrollTop = r), !0;
          });
    }, 15);
  }
  function $l() {
    clearInterval(Co);
  }
  function yl(t, e) {
    let i;
    if (F(e, "li", "tr")) {
      (i = x("<div>")), W(i, e.cloneNode(!0).children);
      for (const s of e.getAttributeNames()) p(i, s, e.getAttribute(s));
    } else i = e.cloneNode(!0);
    return (
      W(t, i),
      h(i, "margin", "0", "important"),
      h(i, {
        boxSizing: "border-box",
        width: e.offsetWidth,
        height: e.offsetHeight,
        padding: h(e, "padding"),
      }),
      et(i.firstElementChild, et(e.firstElementChild)),
      i
    );
  }
  function kl(t, e) {
    return t[xt(t, (i) => si(e, m(i)))];
  }
  function Sl(t, e, i, s, n, o) {
    if (!B(t).length) return;
    const r = m(e);
    if (!o)
      return Il(t, i) || n < r.top + r.height / 2 ? e : e.nextElementSibling;
    const a = m(i),
      l = Po([r.top, r.bottom], [a.top, a.bottom]),
      [c, u, d, f] = l
        ? [s, "width", "left", "right"]
        : [n, "height", "top", "bottom"],
      g = a[u] < r[u] ? r[u] - a[u] : 0;
    return a[d] < r[d]
      ? g && c < r[d] + g
        ? !1
        : e.nextElementSibling
      : g && c > r[f] - g
      ? !1
      : e;
  }
  function Il(t, e) {
    const i = B(t).length === 1;
    i && W(t, e);
    const s = B(t),
      n = s.some((o, r) => {
        const a = m(o);
        return s.slice(r + 1).some((l) => {
          const c = m(l);
          return !Po([a.left, a.right], [c.left, c.right]);
        });
      });
    return i && Q(e), n;
  }
  function Po(t, e) {
    return t[1] > e[0] && e[1] > t[0];
  }
  function Tl(t) {
    let e;
    return function (...i) {
      e ||
        ((e = !0), t.call(this, ...i), requestAnimationFrame(() => (e = !1)));
    };
  }
  var El = {
    mixins: [Ue, Yt, Fn],
    data: {
      pos: "top",
      animation: ["uk-animation-scale-up"],
      duration: 100,
      cls: "uk-active",
    },
    connected() {
      Cl(this.$el);
    },
    disconnected() {
      this.hide();
    },
    methods: {
      show() {
        if (this.isToggled(this.tooltip || null)) return;
        const { delay: t = 0, title: e } = _l(this.$options);
        if (!e) return;
        const i = p(this.$el, "title"),
          s = y(this.$el, ["blur", le], (o) => !pt(o) && this.hide());
        this.reset = () => {
          p(this.$el, { title: i, "aria-describedby": null }), s();
        };
        const n = Jt(this);
        p(this.$el, { title: null, "aria-describedby": n }),
          clearTimeout(this.showTimer),
          (this.showTimer = setTimeout(() => this._show(e, n), t));
      },
      async hide() {
        var t;
        C(this.$el, "input:focus") ||
          (clearTimeout(this.showTimer),
          this.isToggled(this.tooltip || null) &&
            (await this.toggleElement(this.tooltip, !1, !1)),
          (t = this.reset) == null || t.call(this),
          Q(this.tooltip),
          (this.tooltip = null));
      },
      async _show(t, e) {
        (this.tooltip = W(
          this.container,
          `<div id="${e}" class="uk-${this.$options.name}" role="tooltip"> <div class="uk-${this.$options.name}-inner">${t}</div> </div>`
        )),
          y(this.tooltip, "toggled", (i, s) => {
            if (!s) return;
            const n = () => this.positionAt(this.tooltip, this.$el);
            n();
            const [o, r] = Pl(this.tooltip, this.$el, this.pos);
            this.origin = this.axis === "y" ? `${gi(o)}-${r}` : `${r}-${gi(o)}`;
            const a = [
              z(
                document,
                `keydown ${ut}`,
                this.hide,
                !1,
                (l) =>
                  (l.type === ut && !this.$el.contains(l.target)) ||
                  (l.type === "keydown" && l.keyCode === M.ESC)
              ),
              y([document, ...Vt(this.$el)], "scroll", n, { passive: !0 }),
            ];
            z(this.tooltip, "hide", () => a.forEach((l) => l()), { self: !0 });
          }),
          (await this.toggleElement(this.tooltip, !0)) || this.hide();
      },
    },
    events: {
      [`focus ${jt} ${ut}`](t) {
        (!pt(t) || t.type === ut) &&
          document.readyState !== "loading" &&
          this.show();
      },
    },
  };
  function Cl(t) {
    li(t) || p(t, "tabindex", "0");
  }
  function Pl(t, e, [i, s]) {
    const n = E(t),
      o = E(e),
      r = [
        ["left", "right"],
        ["top", "bottom"],
      ];
    for (const l of r) {
      if (n[l[0]] >= o[l[1]]) {
        i = l[1];
        break;
      }
      if (n[l[1]] <= o[l[0]]) {
        i = l[0];
        break;
      }
    }
    return (
      (s = (b(r[0], i) ? r[1] : r[0]).find((l) => n[l] === o[l]) || "center"),
      [i, s]
    );
  }
  function _l(t) {
    const { el: e, id: i, data: s } = t;
    return ["delay", "title"].reduce((n, o) => ({ [o]: Z(e, o), ...n }), {
      ...ge(Z(e, i), ["title"]),
      ...s,
    });
  }
  var Al = {
    mixins: [Si],
    i18n: {
      invalidMime: "Invalid File Type: %s",
      invalidName: "Invalid File Name: %s",
      invalidSize: "Invalid File Size: %s Kilobytes Max",
    },
    props: {
      allow: String,
      clsDragover: String,
      concurrent: Number,
      maxSize: Number,
      method: String,
      mime: String,
      multiple: Boolean,
      name: String,
      params: Object,
      type: String,
      url: String,
    },
    data: {
      allow: !1,
      clsDragover: "uk-dragover",
      concurrent: 1,
      maxSize: 0,
      method: "POST",
      mime: !1,
      multiple: !1,
      name: "files[]",
      params: {},
      type: "",
      url: "",
      abort: A,
      beforeAll: A,
      beforeSend: A,
      complete: A,
      completeAll: A,
      error: A,
      fail: A,
      load: A,
      loadEnd: A,
      loadStart: A,
      progress: A,
    },
    events: {
      change(t) {
        C(t.target, 'input[type="file"]') &&
          (t.preventDefault(),
          t.target.files && this.upload(t.target.files),
          (t.target.value = ""));
      },
      drop(t) {
        Di(t);
        const e = t.dataTransfer;
        e != null &&
          e.files &&
          (_(this.$el, this.clsDragover), this.upload(e.files));
      },
      dragenter(t) {
        Di(t);
      },
      dragover(t) {
        Di(t), S(this.$el, this.clsDragover);
      },
      dragleave(t) {
        Di(t), _(this.$el, this.clsDragover);
      },
    },
    methods: {
      async upload(t) {
        if (((t = ie(t)), !t.length)) return;
        v(this.$el, "upload", [t]);
        for (const s of t) {
          if (this.maxSize && this.maxSize * 1e3 < s.size) {
            this.fail(this.t("invalidSize", this.maxSize));
            return;
          }
          if (this.allow && !_o(this.allow, s.name)) {
            this.fail(this.t("invalidName", this.allow));
            return;
          }
          if (this.mime && !_o(this.mime, s.type)) {
            this.fail(this.t("invalidMime", this.mime));
            return;
          }
        }
        this.multiple || (t = t.slice(0, 1)), this.beforeAll(this, t);
        const e = Ol(t, this.concurrent),
          i = async (s) => {
            const n = new FormData();
            s.forEach((o) => n.append(this.name, o));
            for (const o in this.params) n.append(o, this.params[o]);
            try {
              const o = await Dl(this.url, {
                data: n,
                method: this.method,
                responseType: this.type,
                beforeSend: (r) => {
                  const { xhr: a } = r;
                  y(a.upload, "progress", this.progress);
                  for (const l of ["loadStart", "load", "loadEnd", "abort"])
                    y(a, l.toLowerCase(), this[l]);
                  return this.beforeSend(r);
                },
              });
              this.complete(o),
                e.length ? await i(e.shift()) : this.completeAll(o);
            } catch (o) {
              this.error(o);
            }
          };
        await i(e.shift());
      },
    },
  };
  function _o(t, e) {
    return e.match(
      new RegExp(
        `^${t
          .replace(/\//g, "\\/")
          .replace(/\*\*/g, "(\\/[^\\/]+)*")
          .replace(/\*/g, "[^\\/]+")
          .replace(/((?!\\))\?/g, "$1.")}$`,
        "i"
      )
    );
  }
  function Ol(t, e) {
    const i = [];
    for (let s = 0; s < t.length; s += e) i.push(t.slice(s, s + e));
    return i;
  }
  function Di(t) {
    t.preventDefault(), t.stopPropagation();
  }
  async function Dl(t, e) {
    const i = {
      data: null,
      method: "GET",
      headers: {},
      xhr: new XMLHttpRequest(),
      beforeSend: A,
      responseType: "",
      ...e,
    };
    return await i.beforeSend(i), Ml(t, i);
  }
  function Ml(t, e) {
    return new Promise((i, s) => {
      const { xhr: n } = e;
      for (const o in e)
        if (o in n)
          try {
            n[o] = e[o];
          } catch {}
      n.open(e.method.toUpperCase(), t);
      for (const o in e.headers) n.setRequestHeader(o, e.headers[o]);
      y(n, "load", () => {
        n.status === 0 ||
        (n.status >= 200 && n.status < 300) ||
        n.status === 304
          ? i(n)
          : s(ft(Error(n.statusText), { xhr: n, status: n.status }));
      }),
        y(n, "error", () => s(ft(Error("Network Error"), { xhr: n }))),
        y(n, "timeout", () => s(ft(Error("Network Timeout"), { xhr: n }))),
        n.send(e.data);
    });
  }
  var Bl = Object.freeze({
    __proto__: null,
    Countdown: Rr,
    Filter: sa,
    Lightbox: Qa,
    LightboxPanel: no,
    Notification: il,
    Parallax: ul,
    Slider: gl,
    SliderParallax: Io,
    Slideshow: bl,
    SlideshowParallax: Io,
    Sortable: wl,
    Tooltip: El,
    Upload: Al,
  });
  function Nl(t) {
    Wt &&
      window.MutationObserver &&
      (document.body
        ? requestAnimationFrame(() => Ao(t))
        : new MutationObserver((e, i) => {
            document.body && (Ao(t), i.disconnect());
          }).observe(document.documentElement, { childList: !0 }));
  }
  function Ao(t) {
    v(document, "uikit:init", t),
      document.body && _t(document.body, Oo),
      new MutationObserver(zl).observe(document, {
        subtree: !0,
        childList: !0,
        attributes: !0,
      }),
      (t._initialized = !0);
  }
  function zl(t) {
    var e;
    for (const {
      addedNodes: i,
      removedNodes: s,
      target: n,
      attributeName: o,
    } of t) {
      for (const a of i) _t(a, Oo);
      for (const a of s) _t(a, Fl);
      const r = o && Do(o);
      r && (Et(n, o) ? Ye(r, n) : (e = Ti(n, r)) == null || e.$destroy());
    }
  }
  function Oo(t) {
    const e = Ge(t);
    for (const i in e) _s(e[i]);
    for (const i of t.getAttributeNames()) {
      const s = Do(i);
      s && Ye(s, t);
    }
  }
  function Fl(t) {
    const e = Ge(t);
    for (const i in e) As(e[i]);
  }
  function Do(t) {
    mt(t, "data-") && (t = t.slice(5));
    const e = be[t];
    return e && (e.options || e).name;
  }
  Ra(lt), qa(lt);
  var Mo = {
    mixins: [it, Yt],
    props: {
      animation: Boolean,
      targets: String,
      active: null,
      collapsible: Boolean,
      multiple: Boolean,
      toggle: String,
      content: String,
      offset: Number,
    },
    data: {
      targets: "> *",
      active: !1,
      animation: !0,
      collapsible: !0,
      multiple: !1,
      clsOpen: "uk-open",
      toggle: "> .uk-accordion-title",
      content: "> .uk-accordion-content",
      offset: 0,
    },
    computed: {
      items: ({ targets: t }, e) => D(t, e),
      toggles({ toggle: t }) {
        return this.items.map((e) => x(t, e));
      },
      contents({ content: t }) {
        return this.items.map((e) => {
          var i;
          return (
            ((i = e._wrapper) == null ? void 0 : i.firstElementChild) || x(t, e)
          );
        });
      },
    },
    watch: {
      items(t, e) {
        if (e || $(t, this.clsOpen)) return;
        const i =
          (this.active !== !1 && t[Number(this.active)]) ||
          (!this.collapsible && t[0]);
        i && this.toggle(i, !1);
      },
      toggles() {
        this.$emit();
      },
      contents(t) {
        for (const e of t) {
          const i = $(
            this.items.find((s) => s.contains(e)),
            this.clsOpen
          );
          Mi(e, !i);
        }
        this.$emit();
      },
    },
    observe: yi(),
    events: [
      {
        name: "click keydown",
        delegate: ({ targets: t, $props: e }) => `${t} ${e.toggle}`,
        async handler(t) {
          var e;
          (t.type === "keydown" && t.keyCode !== M.SPACE) ||
            (t.preventDefault(),
            (e = this._off) == null || e.call(this),
            (this._off = Ll(t.target)),
            await this.toggle(yt(this.toggles, t.current)),
            this._off());
        },
      },
      {
        name: "shown hidden",
        self: !0,
        delegate: ({ targets: t }) => t,
        handler() {
          this.$emit();
        },
      },
    ],
    update() {
      const t = Oe(this.items, `.${this.clsOpen}`);
      for (const e in this.items) {
        const i = this.toggles[e],
          s = this.contents[e];
        if (!i || !s) continue;
        (i.id = Jt(this, i)), (s.id = Jt(this, s));
        const n = b(t, this.items[e]);
        p(i, {
          role: F(i, "a") ? "button" : null,
          "aria-controls": s.id,
          "aria-expanded": n,
          "aria-disabled": !this.collapsible && t.length < 2 && n,
        }),
          p(s, { role: "region", "aria-labelledby": i.id }),
          F(s, "ul") && p(B(s), "role", "presentation");
      }
    },
    methods: {
      toggle(t, e) {
        t = this.items[ot(t, this.items)];
        let i = [t];
        const s = Oe(this.items, `.${this.clsOpen}`);
        if (
          (!this.multiple && !b(s, i[0]) && (i = i.concat(s)),
          !(!this.collapsible && s.length < 2 && b(s, t)))
        )
          return Promise.all(
            i.map((n) =>
              this.toggleElement(n, !b(s, n), (o, r) => {
                if ((L(o, this.clsOpen, r), e === !1 || !this.animation)) {
                  Mi(x(this.content, o), !r);
                  return;
                }
                return Hl(o, r, this);
              })
            )
          );
      },
    },
  };
  function Mi(t, e) {
    t && (t.hidden = e);
  }
  async function Hl(
    t,
    e,
    { content: i, duration: s, velocity: n, transition: o }
  ) {
    var r;
    (i = ((r = t._wrapper) == null ? void 0 : r.firstElementChild) || x(i, t)),
      t._wrapper || (t._wrapper = Ne(i, "<div>"));
    const a = t._wrapper;
    h(a, "overflow", "hidden");
    const l = k(h(a, "height"));
    await N.cancel(a), Mi(i, !1);
    const c = Ht(["marginTop", "marginBottom"], (d) => h(i, d)) + m(i).height,
      u = l / c;
    (s = (n * c + s) * (e ? 1 - u : u)),
      h(a, "height", l),
      await N.start(a, { height: e ? c : 0 }, s, o),
      ze(i),
      delete t._wrapper,
      e || Mi(i, !0);
  }
  function Ll(t) {
    const e = Ot(t, !0);
    let i;
    return (
      (function s() {
        i = requestAnimationFrame(() => {
          const { top: n } = m(t);
          n < 0 && (e.scrollTop += n), s();
        });
      })(),
      () => requestAnimationFrame(() => cancelAnimationFrame(i))
    );
  }
  var Wl = {
    mixins: [it, Yt],
    args: "animation",
    props: { animation: Boolean, close: String },
    data: { animation: !0, selClose: ".uk-alert-close", duration: 150 },
    events: {
      name: "click",
      delegate: ({ selClose: t }) => t,
      handler(t) {
        t.preventDefault(), this.close();
      },
    },
    methods: {
      async close() {
        await this.toggleElement(this.$el, !1, jl), this.$destroy(!0);
      },
    },
  };
  function jl(t, e, { duration: i, transition: s, velocity: n }) {
    const o = k(h(t, "height"));
    return (
      h(t, "height", o),
      N.start(
        t,
        {
          height: 0,
          marginTop: 0,
          marginBottom: 0,
          paddingTop: 0,
          paddingBottom: 0,
          borderTop: 0,
          borderBottom: 0,
          opacity: 0,
        },
        n * o + i,
        s
      )
    );
  }
  var Bo = {
    args: "autoplay",
    props: { automute: Boolean, autoplay: Boolean },
    data: { automute: !1, autoplay: !0 },
    beforeConnect() {
      this.autoplay === "inview" &&
        !Et(this.$el, "preload") &&
        (this.$el.preload = "none"),
        F(this.$el, "iframe") &&
          !Et(this.$el, "allow") &&
          (this.$el.allow = "autoplay"),
        this.autoplay === "hover" &&
          (F(this.$el, "video")
            ? (this.$el.tabindex = 0)
            : (this.autoplay = !0)),
        this.automute && cn(this.$el);
    },
    events: [
      {
        name: `${jt} focusin`,
        filter: ({ autoplay: t }) => b(t, "hover"),
        handler(t) {
          !pt(t) || !Rl(this.$el) ? rs(this.$el) : bi(this.$el);
        },
      },
      {
        name: `${le} focusout`,
        filter: ({ autoplay: t }) => b(t, "hover"),
        handler(t) {
          pt(t) || bi(this.$el);
        },
      },
    ],
    observe: [
      me({
        filter: ({ autoplay: t }) => t !== "hover",
        handler([{ isIntersecting: t }]) {
          document.fullscreenElement ||
            (t ? this.autoplay && rs(this.$el) : bi(this.$el));
        },
        args: { intersecting: !1 },
        options: ({ $el: t, autoplay: e }) => ({
          root: e === "inview" ? null : O(t).closest(":not(a)"),
        }),
      }),
    ],
  };
  function Rl(t) {
    return !t.paused && !t.ended;
  }
  var ql = {
    mixins: [Bo],
    props: { width: Number, height: Number },
    data: { automute: !0 },
    created() {
      this.useObjectFit = F(this.$el, "img", "video");
    },
    observe: dt({
      target: ({ $el: t }) => No(t) || O(t),
      filter: ({ useObjectFit: t }) => !t,
    }),
    update: {
      read() {
        if (this.useObjectFit) return !1;
        const { ratio: t, cover: e } = Ri,
          { $el: i, width: s, height: n } = this;
        let o = { width: s, height: n };
        if (!s || !n) {
          const c = {
            width: i.naturalWidth || i.videoWidth || i.clientWidth,
            height: i.naturalHeight || i.videoHeight || i.clientHeight,
          };
          s ? (o = t(c, "width", s)) : n ? (o = t(c, "height", n)) : (o = c);
        }
        const { offsetHeight: r, offsetWidth: a } = No(i) || O(i),
          l = e(o, { width: a, height: r });
        return !l.width || !l.height ? !1 : l;
      },
      write({ height: t, width: e }) {
        h(this.$el, { height: t, width: e });
      },
      events: ["resize"],
    },
  };
  function No(t) {
    for (; (t = O(t)); ) if (h(t, "position") !== "static") return t;
  }
  let Y;
  var zo = {
    mixins: [Ue, Fn, Yt],
    args: "pos",
    props: {
      mode: "list",
      toggle: Boolean,
      boundary: Boolean,
      boundaryX: Boolean,
      boundaryY: Boolean,
      target: Boolean,
      targetX: Boolean,
      targetY: Boolean,
      stretch: Boolean,
      delayShow: Number,
      delayHide: Number,
      autoUpdate: Boolean,
      clsDrop: String,
      animateOut: Boolean,
      bgScroll: Boolean,
      closeOnScroll: Boolean,
    },
    data: {
      mode: ["click", "hover"],
      toggle: "- *",
      boundary: !1,
      boundaryX: !1,
      boundaryY: !1,
      target: !1,
      targetX: !1,
      targetY: !1,
      stretch: !1,
      delayShow: 0,
      delayHide: 800,
      autoUpdate: !0,
      clsDrop: !1,
      animateOut: !1,
      bgScroll: !0,
      animation: ["uk-animation-fade"],
      cls: "uk-open",
      container: !1,
      closeOnScroll: !1,
    },
    computed: {
      boundary({ boundary: t, boundaryX: e, boundaryY: i }, s) {
        return [tt(e || t, s) || window, tt(i || t, s) || window];
      },
      target({ target: t, targetX: e, targetY: i }, s) {
        return (
          e || (e = t || this.targetEl),
          i || (i = t || this.targetEl),
          [e === !0 ? window : tt(e, s), i === !0 ? window : tt(i, s)]
        );
      },
    },
    created() {
      this.tracker = new an();
    },
    beforeConnect() {
      this.clsDrop = this.$props.clsDrop || this.$options.id;
    },
    connected() {
      S(this.$el, "uk-drop", this.clsDrop),
        this.toggle && !this.targetEl && (this.targetEl = Vl(this)),
        (this._style = ei(this.$el.style, ["width", "height"]));
    },
    disconnected() {
      this.isActive() && (this.hide(!1), (Y = null)), h(this.$el, this._style);
    },
    events: [
      {
        name: "click",
        delegate: () => ".uk-drop-close",
        handler(t) {
          t.preventDefault(), this.hide(!1);
        },
      },
      {
        name: "click",
        delegate: () => 'a[href*="#"]',
        handler({ defaultPrevented: t, current: e }) {
          const { hash: i } = e;
          !t && i && ue(e) && !this.$el.contains(x(i)) && this.hide(!1);
        },
      },
      {
        name: "beforescroll",
        handler() {
          this.hide(!1);
        },
      },
      {
        name: "toggle",
        self: !0,
        handler(t, e) {
          t.preventDefault(),
            this.isToggled()
              ? this.hide(!1)
              : this.show(e == null ? void 0 : e.$el, !1);
        },
      },
      {
        name: "toggleshow",
        self: !0,
        handler(t, e) {
          t.preventDefault(), this.show(e == null ? void 0 : e.$el);
        },
      },
      {
        name: "togglehide",
        self: !0,
        handler(t) {
          t.preventDefault(), C(this.$el, ":focus,:hover") || this.hide();
        },
      },
      {
        name: `${jt} focusin`,
        filter: ({ mode: t }) => b(t, "hover"),
        handler(t) {
          pt(t) || this.clearTimers();
        },
      },
      {
        name: `${le} focusout`,
        filter: ({ mode: t }) => b(t, "hover"),
        handler(t) {
          !pt(t) && t.relatedTarget && this.hide();
        },
      },
      {
        name: "toggled",
        self: !0,
        handler(t, e) {
          e && (this.clearTimers(), this.position());
        },
      },
      {
        name: "show",
        self: !0,
        handler() {
          (Y = this),
            this.tracker.init(),
            p(this.targetEl, "aria-expanded", !0);
          const t = [
            Yl(this),
            Gl(this),
            Jl(this),
            this.autoUpdate && Fo(this),
            this.closeOnScroll && Xl(this),
          ];
          z(this.$el, "hide", () => t.forEach((e) => e && e()), { self: !0 }),
            this.bgScroll || z(this.$el, "hidden", zn(this.$el), { self: !0 });
        },
      },
      {
        name: "beforehide",
        self: !0,
        handler() {
          this.clearTimers();
        },
      },
      {
        name: "hide",
        handler({ target: t }) {
          if (this.$el !== t) {
            Y =
              Y === null && this.$el.contains(t) && this.isToggled() ? this : Y;
            return;
          }
          (Y = this.isActive() ? null : Y),
            this.tracker.cancel(),
            p(this.targetEl, "aria-expanded", null);
        },
      },
    ],
    update: {
      write() {
        this.isToggled() && !$(this.$el, this.clsEnter) && this.position();
      },
    },
    methods: {
      show(t = this.targetEl, e = !0) {
        if (
          (this.isToggled() &&
            t &&
            this.targetEl &&
            t !== this.targetEl &&
            this.hide(!1, !1),
          (this.targetEl = t),
          this.clearTimers(),
          !this.isActive())
        ) {
          if (Y) {
            if (e && Y.isDelaying()) {
              this.showTimer = setTimeout(
                () => C(t, ":hover") && this.show(),
                10
              );
              return;
            }
            let i;
            for (; Y && i !== Y && !Y.$el.contains(this.$el); )
              (i = Y), Y.hide(!1, !1);
          }
          this.container &&
            O(this.$el) !== this.container &&
            W(this.container, this.$el),
            (this.showTimer = setTimeout(
              () => this.toggleElement(this.$el, !0),
              (e && this.delayShow) || 0
            ));
        }
      },
      hide(t = !0, e = !0) {
        const i = () => this.toggleElement(this.$el, !1, this.animateOut && e);
        this.clearTimers(),
          (this.isDelayedHide = t),
          t && this.isDelaying()
            ? (this.hideTimer = setTimeout(this.hide, 50))
            : t && this.delayHide
            ? (this.hideTimer = setTimeout(i, this.delayHide))
            : i();
      },
      clearTimers() {
        clearTimeout(this.showTimer),
          clearTimeout(this.hideTimer),
          (this.showTimer = null),
          (this.hideTimer = null);
      },
      isActive() {
        return Y === this;
      },
      isDelaying() {
        return [this.$el, ...D(".uk-drop", this.$el)].some((t) =>
          this.tracker.movesTo(t)
        );
      },
      position() {
        const t = Ts(this.$el);
        _(this.$el, "uk-drop-stack"),
          h(this.$el, this._style),
          (this.$el.hidden = !0);
        const e = this.target.map((o) => Ul(this.$el, o)),
          i = this.getViewportOffset(this.$el),
          s = [
            [0, ["x", "width", "left", "right"]],
            [1, ["y", "height", "top", "bottom"]],
          ];
        for (const [o, [r, a]] of s)
          this.axis !== r &&
            b([r, !0], this.stretch) &&
            h(this.$el, {
              [a]: Math.min(E(this.boundary[o])[a], e[o][a] - 2 * i),
              [`overflow-${r}`]: "auto",
            });
        const n = e[0].width - 2 * i;
        (this.$el.hidden = !1),
          h(this.$el, "maxWidth", ""),
          this.$el.offsetWidth > n && S(this.$el, "uk-drop-stack"),
          h(this.$el, "maxWidth", n),
          this.positionAt(this.$el, this.target, this.boundary);
        for (const [o, [r, a, l, c]] of s)
          if (this.axis === r && b([r, !0], this.stretch)) {
            const u = Math.abs(this.getPositionOffset()),
              d = E(this.target[o]),
              f = E(this.$el);
            h(this.$el, {
              [a]:
                (d[l] > f[l]
                  ? d[this.inset ? c : l] -
                    Math.max(E(this.boundary[o])[l], e[o][l] + i)
                  : Math.min(E(this.boundary[o])[c], e[o][c] - i) -
                    d[this.inset ? l : c]) - u,
              [`overflow-${r}`]: "auto",
            }),
              this.positionAt(this.$el, this.target, this.boundary);
          }
        t();
      },
    },
  };
  function Ul(t, e) {
    return rt(Vt(e).find((i) => i.contains(t)));
  }
  function Vl(t) {
    const { $el: e } = t.$create("toggle", tt(t.toggle, t.$el), {
      target: t.$el,
      mode: t.mode,
    });
    return p(e, "aria-haspopup", !0), e;
  }
  function Yl(t) {
    const e = () => t.$emit(),
      i = [ns(e), Le(Vt(t.$el).concat(t.target), e)];
    return () => i.map((s) => s.disconnect());
  }
  function Fo(t, e = () => t.$emit()) {
    return y([document, ...Vt(t.$el)], "scroll", e, { passive: !0 });
  }
  function Gl(t) {
    return y(document, "keydown", (e) => {
      e.keyCode === M.ESC && t.hide(!1);
    });
  }
  function Xl(t) {
    return Fo(t, () => t.hide(!1));
  }
  function Jl(t) {
    return y(document, ut, ({ target: e }) => {
      t.$el.contains(e) ||
        z(
          document,
          `${Ct} ${ri} scroll`,
          ({ defaultPrevented: i, type: s, target: n }) => {
            var o;
            !i &&
              s === Ct &&
              e === n &&
              !((o = t.targetEl) != null && o.contains(e)) &&
              t.hide(!1);
          },
          !0
        );
    });
  }
  var Ho = {
    mixins: [it, Ue],
    props: {
      align: String,
      clsDrop: String,
      boundary: Boolean,
      dropbar: Boolean,
      dropbarAnchor: Boolean,
      duration: Number,
      mode: Boolean,
      offset: Boolean,
      stretch: Boolean,
      delayShow: Boolean,
      delayHide: Boolean,
      target: Boolean,
      targetX: Boolean,
      targetY: Boolean,
      animation: Boolean,
      animateOut: Boolean,
      closeOnScroll: Boolean,
    },
    data: {
      align: U ? "right" : "left",
      clsDrop: "uk-dropdown",
      clsDropbar: "uk-dropnav-dropbar",
      boundary: !0,
      dropbar: !1,
      dropbarAnchor: !1,
      duration: 200,
      container: !1,
      selNavItem: "> li > a, > ul > li > a",
    },
    computed: {
      dropbarAnchor: ({ dropbarAnchor: t }, e) => tt(t, e) || e,
      dropbar({ dropbar: t }) {
        return t
          ? ((t =
              this._dropbar ||
              tt(t, this.$el) ||
              x(`+ .${this.clsDropbar}`, this.$el)),
            t || (this._dropbar = x("<div></div>")))
          : null;
      },
      dropContainer(t, e) {
        return this.container || e;
      },
      dropdowns({ clsDrop: t }, e) {
        var i;
        const s = D(`.${t}`, e);
        if (this.dropContainer !== e)
          for (const n of D(`.${t}`, this.dropContainer)) {
            const o = (i = this.getDropdown(n)) == null ? void 0 : i.targetEl;
            !b(s, n) && o && this.$el.contains(o) && s.push(n);
          }
        return s;
      },
      items({ selNavItem: t }, e) {
        return D(t, e);
      },
    },
    watch: {
      dropbar(t) {
        S(
          t,
          "uk-dropbar",
          "uk-dropbar-top",
          this.clsDropbar,
          `uk-${this.$options.name}-dropbar`
        );
      },
      dropdowns() {
        this.initializeDropdowns();
      },
    },
    connected() {
      this.initializeDropdowns();
    },
    disconnected() {
      Q(this._dropbar), delete this._dropbar;
    },
    events: [
      {
        name: "mouseover focusin",
        delegate: ({ selNavItem: t }) => t,
        handler({ current: t }) {
          const e = this.getActive();
          e &&
            b(e.mode, "hover") &&
            e.targetEl &&
            !t.contains(e.targetEl) &&
            !e.isDelaying() &&
            e.hide(!1);
        },
      },
      {
        name: "keydown",
        self: !0,
        delegate: ({ selNavItem: t }) => t,
        handler(t) {
          var e;
          const { current: i, keyCode: s } = t,
            n = this.getActive();
          if (s === M.DOWN)
            if ((n == null ? void 0 : n.targetEl) === i)
              t.preventDefault(), (e = x(he, n.$el)) == null || e.focus();
            else {
              const o = this.dropdowns.find((r) => {
                var a;
                return (
                  ((a = this.getDropdown(r)) == null ? void 0 : a.targetEl) ===
                  i
                );
              });
              o &&
                (t.preventDefault(),
                i.click(),
                z(o, "show", (r) => {
                  var a;
                  return (a = x(he, r.target)) == null ? void 0 : a.focus();
                }));
            }
          Lo(t, this.items, n);
        },
      },
      {
        name: "keydown",
        el: ({ dropContainer: t }) => t,
        delegate: ({ clsDrop: t }) => `.${t}`,
        handler(t) {
          var e;
          const { current: i, keyCode: s, target: n } = t;
          if (ai(n) || !b(this.dropdowns, i)) return;
          const o = this.getActive();
          let r = -1;
          if (
            (s === M.HOME
              ? (r = 0)
              : s === M.END
              ? (r = "last")
              : s === M.UP
              ? (r = "previous")
              : s === M.DOWN
              ? (r = "next")
              : s === M.ESC && ((e = o.targetEl) == null || e.focus()),
            ~r)
          ) {
            t.preventDefault();
            const a = D(he, i);
            a[
              ot(
                r,
                a,
                xt(a, (l) => C(l, ":focus"))
              )
            ].focus();
            return;
          }
          Lo(t, this.items, o);
        },
      },
      {
        name: "mouseleave",
        el: ({ dropbar: t }) => t,
        filter: ({ dropbar: t }) => t,
        handler() {
          const t = this.getActive();
          t &&
            b(t.mode, "hover") &&
            !this.dropdowns.some((e) => C(e, ":hover")) &&
            t.hide();
        },
      },
      {
        name: "beforeshow",
        el: ({ dropContainer: t }) => t,
        filter: ({ dropbar: t }) => t,
        handler({ target: t }) {
          this.isDropbarDrop(t) &&
            (this.dropbar.previousElementSibling !== this.dropbarAnchor &&
              di(this.dropbarAnchor, this.dropbar),
            S(t, `${this.clsDrop}-dropbar`));
        },
      },
      {
        name: "show",
        el: ({ dropContainer: t }) => t,
        filter: ({ dropbar: t }) => t,
        handler({ target: t }) {
          if (!this.isDropbarDrop(t)) return;
          const e = this.getDropdown(t),
            i = () => {
              const s = Math.max(
                ...ce(t, `.${this.clsDrop}`)
                  .concat(t)
                  .map((n) => E(n).bottom)
              );
              E(this.dropbar, {
                left: E(this.dropbar).left,
                top: this.getDropbarOffset(e.getPositionOffset()),
              }),
                this.transitionTo(
                  s - E(this.dropbar).top + k(h(t, "marginBottom")),
                  t
                );
            };
          (this._observer = Le([e.$el, ...e.target], i)), i();
        },
      },
      {
        name: "beforehide",
        el: ({ dropContainer: t }) => t,
        filter: ({ dropbar: t }) => t,
        handler(t) {
          const e = this.getActive();
          C(this.dropbar, ":hover") &&
            e.$el === t.target &&
            this.isDropbarDrop(e.$el) &&
            b(e.mode, "hover") &&
            e.isDelayedHide &&
            !this.items.some((i) => e.targetEl !== i && C(i, ":focus")) &&
            t.preventDefault();
        },
      },
      {
        name: "hide",
        el: ({ dropContainer: t }) => t,
        filter: ({ dropbar: t }) => t,
        handler({ target: t }) {
          var e;
          if (!this.isDropbarDrop(t)) return;
          (e = this._observer) == null || e.disconnect();
          const i = this.getActive();
          (!i || i.$el === t) && this.transitionTo(0);
        },
      },
    ],
    methods: {
      getActive() {
        var t;
        return b(this.dropdowns, (t = Y) == null ? void 0 : t.$el) && Y;
      },
      async transitionTo(t, e) {
        const { dropbar: i } = this,
          s = et(i);
        if (((e = s < t && e), await N.cancel([e, i]), e)) {
          const n = E(e).top - E(i).top - s;
          n > 0 && h(e, "transitionDelay", `${(n / t) * this.duration}ms`);
        }
        h(e, "clipPath", `polygon(0 0,100% 0,100% ${s}px,0 ${s}px)`),
          et(i, s),
          await Promise.all([
            N.start(i, { height: t }, this.duration),
            N.start(
              e,
              { clipPath: `polygon(0 0,100% 0,100% ${t}px,0 ${t}px)` },
              this.duration
            ).finally(() => h(e, { clipPath: "", transitionDelay: "" })),
          ]).catch(A);
      },
      getDropdown(t) {
        return (
          this.$getComponent(t, "drop") || this.$getComponent(t, "dropdown")
        );
      },
      isDropbarDrop(t) {
        return b(this.dropdowns, t) && $(t, this.clsDrop);
      },
      getDropbarOffset(t) {
        const { $el: e, target: i, targetY: s } = this,
          { top: n, height: o } = E(tt(s || i || e, e));
        return n + o + t;
      },
      initializeDropdowns() {
        this.$create(
          "drop",
          this.dropdowns.filter((t) => !this.getDropdown(t)),
          {
            ...this.$props,
            flip: !1,
            shift: !0,
            pos: `bottom-${this.align}`,
            boundary: this.boundary === !0 ? this.$el : this.boundary,
          }
        );
      },
    },
  };
  function Lo(t, e, i) {
    var s, n, o;
    const { current: r, keyCode: a } = t;
    let l = -1;
    a === M.HOME
      ? (l = 0)
      : a === M.END
      ? (l = "last")
      : a === M.LEFT
      ? (l = "previous")
      : a === M.RIGHT
      ? (l = "next")
      : a === M.TAB &&
        ((s = i.targetEl) == null || s.focus(),
        (n = i.hide) == null || n.call(i, !1)),
      ~l &&
        (t.preventDefault(),
        (o = i.hide) == null || o.call(i, !1),
        e[ot(l, e, e.indexOf(i.targetEl || r))].focus());
  }
  var Kl = {
      mixins: [it],
      args: "target",
      props: { target: Boolean },
      data: { target: !1 },
      computed: {
        input: (t, e) => x(Ae, e),
        state() {
          return this.input.nextElementSibling;
        },
        target({ target: t }, e) {
          return (
            t &&
            ((t === !0 &&
              O(this.input) === e &&
              this.input.nextElementSibling) ||
              x(t, e))
          );
        },
      },
      update() {
        var t;
        const { target: e, input: i } = this;
        if (!e) return;
        let s;
        const n = ai(e) ? "value" : "textContent",
          o = e[n],
          r =
            (t = i.files) != null && t[0]
              ? i.files[0].name
              : C(i, "select") &&
                (s = D("option", i).filter((a) => a.selected)[0])
              ? s.textContent
              : i.value;
        o !== r && (e[n] = r);
      },
      events: [
        {
          name: "change",
          handler() {
            this.$emit();
          },
        },
        {
          name: "reset",
          el: ({ $el: t }) => t.closest("form"),
          handler() {
            this.$emit();
          },
        },
      ],
    },
    Zl = {
      extends: Tn,
      mixins: [it],
      name: "grid",
      props: {
        masonry: Boolean,
        parallax: String,
        parallaxStart: String,
        parallaxEnd: String,
        parallaxJustify: Boolean,
      },
      data: {
        margin: "uk-grid-margin",
        clsStack: "uk-grid-stack",
        masonry: !1,
        parallax: 0,
        parallaxStart: 0,
        parallaxEnd: 0,
        parallaxJustify: !1,
      },
      connected() {
        this.masonry && S(this.$el, "uk-flex-top", "uk-flex-wrap-top");
      },
      observe: Re({ filter: ({ parallax: t, parallaxJustify: e }) => t || e }),
      update: [
        {
          write({ rows: t }) {
            L(this.$el, this.clsStack, !t.some((e) => e.length > 1));
          },
          events: ["resize"],
        },
        {
          read(t) {
            const { rows: e } = t;
            let {
              masonry: i,
              parallax: s,
              parallaxJustify: n,
              margin: o,
            } = this;
            if (
              ((s = Math.max(0, G(s))),
              !(i || s || n) ||
                Wo(e) ||
                e[0].some((w, I) =>
                  e.some((P) => P[I] && P[I].offsetWidth !== w.offsetWidth)
                ))
            )
              return (t.translates = t.scrollColumns = !1);
            let r = th(e, o),
              a,
              l;
            i ? ([a, l] = Ql(e, r, i === "next")) : (a = eh(e));
            const c = a.map((w) => Ht(w, "offsetHeight") + r * (w.length - 1)),
              u = Math.max(0, ...c);
            let d, f, g;
            return (
              (s || n) &&
                ((d = c.map((w, I) => (n ? u - w + s : s / (I % 2 || 8)))),
                n || (s = Math.max(...c.map((w, I) => w + d[I] - u))),
                (f = G(this.parallaxStart, "height", this.$el, !0)),
                (g = G(this.parallaxEnd, "height", this.$el, !0))),
              {
                columns: a,
                translates: l,
                scrollColumns: d,
                parallaxStart: f,
                parallaxEnd: g,
                padding: s,
                height: l ? u : "",
              }
            );
          },
          write({ height: t, padding: e }) {
            h(this.$el, "paddingBottom", e || ""),
              t !== !1 && h(this.$el, "height", t);
          },
          events: ["resize"],
        },
        {
          read({
            rows: t,
            scrollColumns: e,
            parallaxStart: i,
            parallaxEnd: s,
          }) {
            return { scrolled: e && !Wo(t) ? wi(this.$el, i, s) : !1 };
          },
          write({ columns: t, scrolled: e, scrollColumns: i, translates: s }) {
            (!e && !s) ||
              t.forEach((n, o) =>
                n.forEach((r, a) => {
                  let [l, c] = (s && s[o][a]) || [0, 0];
                  e && (c += e * i[o]),
                    h(r, "transform", `translate(${l}px, ${c}px)`);
                })
              );
          },
          events: ["scroll", "resize"],
        },
      ],
    };
  function Wo(t) {
    return t.flat().some((e) => h(e, "position") === "absolute");
  }
  function Ql(t, e, i) {
    const s = [],
      n = [],
      o = Array(t[0].length).fill(0);
    let r = 0;
    for (let a of t) {
      U && a.reverse();
      let l = 0;
      for (const c in a) {
        const { offsetWidth: u, offsetHeight: d } = a[c],
          f = i ? c : o.indexOf(Math.min(...o));
        Ms(s, f, a[c]),
          Ms(n, f, [(f - c) * u * (U ? -1 : 1), o[f] - r]),
          (o[f] += d + e),
          (l = Math.max(l, d));
      }
      r += l + e;
    }
    return [s, n];
  }
  function th(t, e) {
    const i = t.flat().find((s) => $(s, e));
    return k(i ? h(i, "marginTop") : h(t[0][0], "paddingLeft"));
  }
  function eh(t) {
    const e = [];
    for (const i of t) for (const s in i) Ms(e, s, i[s]);
    return e;
  }
  function Ms(t, e, i) {
    t[e] || (t[e] = []), t[e].push(i);
  }
  var ih = {
    args: "target",
    props: { target: String, row: Boolean },
    data: { target: "> *", row: !0 },
    computed: { elements: ({ target: t }, e) => D(t, e) },
    observe: dt({
      target: ({ $el: t, elements: e }) =>
        e.reduce((i, s) => i.concat(s, ...s.children), [t]),
    }),
    events: {
      name: "loadingdone",
      el: () => document.fonts,
      handler() {
        this.$emit("resize");
      },
    },
    update: {
      read() {
        return {
          rows: (this.row ? bs(this.elements) : [this.elements]).map(sh),
        };
      },
      write({ rows: t }) {
        for (const { heights: e, elements: i } of t)
          i.forEach((s, n) => h(s, "minHeight", e[n]));
      },
      events: ["resize"],
    },
  };
  function sh(t) {
    if (t.length < 2) return { heights: [""], elements: t };
    let e = t.map(nh);
    const i = Math.max(...e);
    return {
      heights: t.map((s, n) => (e[n].toFixed(2) === i.toFixed(2) ? "" : i)),
      elements: t,
    };
  }
  function nh(t) {
    const e = ei(t.style, ["display", "minHeight"]);
    q(t) || h(t, "display", "block", "important"), h(t, "minHeight", "");
    const i = m(t).height - fe(t, "height", "content-box");
    return h(t, e), i;
  }
  var oh = {
      args: "target",
      props: { target: String },
      data: { target: "" },
      computed: {
        target: {
          get: ({ target: t }, e) => tt(t, e),
          observe: ({ target: t }) => t,
        },
      },
      observe: dt({ target: ({ target: t }) => t }),
      update: {
        read() {
          return this.target ? { height: this.target.offsetHeight } : !1;
        },
        write({ height: t }) {
          h(this.$el, "minHeight", t);
        },
        events: ["resize"],
      },
    },
    rh = {
      props: {
        expand: Boolean,
        offsetTop: Boolean,
        offsetBottom: Boolean,
        minHeight: Number,
        property: String,
      },
      data: {
        expand: !1,
        offsetTop: !1,
        offsetBottom: !1,
        minHeight: 0,
        property: "min-height",
      },
      observe: [
        vs({ filter: ({ expand: t }) => t }),
        dt({ target: ({ $el: t }) => Ut(t) }),
      ],
      update: {
        read() {
          if (!q(this.$el)) return !1;
          let t = "";
          const e = fe(this.$el, "height", "content-box"),
            { body: i, scrollingElement: s } = document,
            n = Ot(this.$el),
            { height: o } = rt(n === i ? s : n),
            r = s === n || i === n;
          if (((t = `calc(${r ? "100vh" : `${o}px`}`), this.expand)) {
            const a = m(n).height - m(this.$el).height;
            t += ` - ${a}px`;
          } else {
            if (this.offsetTop)
              if (r) {
                const a =
                    this.offsetTop === !0
                      ? this.$el
                      : tt(this.offsetTop, this.$el),
                  { top: l } = E(a);
                t += l > 0 && l < o / 2 ? ` - ${l}px` : "";
              } else t += ` - ${fe(n, "height", h(n, "boxSizing"))}px`;
            this.offsetBottom === !0
              ? (t += ` - ${m(this.$el.nextElementSibling).height}px`)
              : vt(this.offsetBottom)
              ? (t += ` - ${this.offsetBottom}vh`)
              : this.offsetBottom && ee(this.offsetBottom, "px")
              ? (t += ` - ${k(this.offsetBottom)}px`)
              : H(this.offsetBottom) &&
                (t += ` - ${m(tt(this.offsetBottom, this.$el)).height}px`);
          }
          return (t += `${e ? ` - ${e}px` : ""})`), { minHeight: t };
        },
        write({ minHeight: t }) {
          h(this.$el, this.property, `max(${this.min || 0}px, ${t})`);
        },
        events: ["resize"],
      },
    },
    ah =
      '<svg width="14" height="14" viewBox="0 0 14 14"><line fill="none" stroke="#000" stroke-width="1.1" x1="1" y1="1" x2="13" y2="13"/><line fill="none" stroke="#000" stroke-width="1.1" x1="13" y1="1" x2="1" y2="13"/></svg>',
    lh =
      '<svg width="20" height="20" viewBox="0 0 20 20"><line fill="none" stroke="#000" stroke-width="1.4" x1="1" y1="1" x2="19" y2="19"/><line fill="none" stroke="#000" stroke-width="1.4" x1="19" y1="1" x2="1" y2="19"/></svg>',
    hh =
      '<svg width="12" height="12" viewBox="0 0 12 12"><polyline fill="none" stroke="#000" stroke-width="1.1" points="1 3.5 6 8.5 11 3.5"/></svg>',
    ch =
      '<svg width="20" height="20" viewBox="0 0 20 20"><rect width="1" height="11" x="9" y="4"/><rect width="11" height="1" x="4" y="9"/></svg>',
    uh =
      '<svg width="14" height="14" viewBox="0 0 14 14"><polyline fill="none" stroke="#000" stroke-width="1.1" points="1 4 7 10 13 4"/></svg>',
    dh =
      '<svg width="12" height="12" viewBox="0 0 12 12"><polyline fill="none" stroke="#000" stroke-width="1.1" points="1 3.5 6 8.5 11 3.5"/></svg>',
    fh =
      '<svg width="12" height="12" viewBox="0 0 12 12"><polyline fill="none" stroke="#000" stroke-width="1.1" points="1 3.5 6 8.5 11 3.5"/></svg>',
    ph =
      '<svg width="20" height="20" viewBox="0 0 20 20"><style>.uk-navbar-toggle-icon svg&gt;[class*=&quot;line-&quot;]{transition:0.2s ease-in-out;transition-property:transform, opacity;transform-origin:center;opacity:1}.uk-navbar-toggle-icon svg&gt;.line-3{opacity:0}.uk-navbar-toggle-animate[aria-expanded=&quot;true&quot;] svg&gt;.line-3{opacity:1}.uk-navbar-toggle-animate[aria-expanded=&quot;true&quot;] svg&gt;.line-2{transform:rotate(45deg)}.uk-navbar-toggle-animate[aria-expanded=&quot;true&quot;] svg&gt;.line-3{transform:rotate(-45deg)}.uk-navbar-toggle-animate[aria-expanded=&quot;true&quot;] svg&gt;.line-1,.uk-navbar-toggle-animate[aria-expanded=&quot;true&quot;] svg&gt;.line-4{opacity:0}.uk-navbar-toggle-animate[aria-expanded=&quot;true&quot;] svg&gt;.line-1{transform:translateY(6px) scaleX(0)}.uk-navbar-toggle-animate[aria-expanded=&quot;true&quot;] svg&gt;.line-4{transform:translateY(-6px) scaleX(0)}</style><rect width="20" height="2" y="3" class="line-1"/><rect width="20" height="2" y="9" class="line-2"/><rect width="20" height="2" y="9" class="line-3"/><rect width="20" height="2" y="15" class="line-4"/></svg>',
    gh =
      '<svg width="40" height="40" viewBox="0 0 40 40"><rect width="1" height="40" x="19" y="0"/><rect width="40" height="1" x="0" y="19"/></svg>',
    mh =
      '<svg width="7" height="12" viewBox="0 0 7 12"><polyline fill="none" stroke="#000" stroke-width="1.2" points="1 1 6 6 1 11"/></svg>',
    vh =
      '<svg width="7" height="12" viewBox="0 0 7 12"><polyline fill="none" stroke="#000" stroke-width="1.2" points="6 1 1 6 6 11"/></svg>',
    jo =
      '<svg width="20" height="20" viewBox="0 0 20 20"><circle fill="none" stroke="#000" stroke-width="1.1" cx="9" cy="9" r="7"/><path fill="none" stroke="#000" stroke-width="1.1" d="M14,14 L18,18 L14,14 Z"/></svg>',
    bh =
      '<svg width="40" height="40" viewBox="0 0 40 40"><circle fill="none" stroke="#000" stroke-width="1.8" cx="17.5" cy="17.5" r="16.5"/><line fill="none" stroke="#000" stroke-width="1.8" x1="38" y1="39" x2="29" y2="30"/></svg>',
    wh =
      '<svg width="24" height="24" viewBox="0 0 24 24"><circle fill="none" stroke="#000" stroke-width="1.1" cx="10.5" cy="10.5" r="9.5"/><line fill="none" stroke="#000" stroke-width="1.1" x1="23" y1="23" x2="17" y2="17"/></svg>',
    xh =
      '<svg width="25" height="40" viewBox="0 0 25 40"><polyline fill="none" stroke="#000" stroke-width="2" points="4.002,38.547 22.527,20.024 4,1.5"/></svg>',
    $h =
      '<svg width="14" height="24" viewBox="0 0 14 24"><polyline fill="none" stroke="#000" stroke-width="1.4" points="1.225,23 12.775,12 1.225,1"/></svg>',
    yh =
      '<svg width="25" height="40" viewBox="0 0 25 40"><polyline fill="none" stroke="#000" stroke-width="2" points="20.527,1.5 2,20.024 20.525,38.547"/></svg>',
    kh =
      '<svg width="14" height="24" viewBox="0 0 14 24"><polyline fill="none" stroke="#000" stroke-width="1.4" points="12.775,1 1.225,12 12.775,23"/></svg>',
    Sh =
      '<svg width="30" height="30" viewBox="0 0 30 30"><circle fill="none" stroke="#000" cx="15" cy="15" r="14"/></svg>',
    Ih =
      '<svg width="18" height="10" viewBox="0 0 18 10"><polyline fill="none" stroke="#000" stroke-width="1.2" points="1 9 9 1 17 9"/></svg>',
    Ro = {
      args: "src",
      props: { width: Number, height: Number, ratio: Number },
      data: { ratio: 1 },
      connected() {
        this.svg = this.getSvg().then((t) => {
          if (!this._connected) return;
          const e = Th(t, this.$el);
          return (
            this.svgEl && e !== this.svgEl && Q(this.svgEl),
            Eh.call(this, e, t),
            (this.svgEl = e)
          );
        }, A);
      },
      disconnected() {
        this.svg.then((t) => {
          this._connected ||
            (qi(this.$el) && (this.$el.hidden = !1), Q(t), (this.svgEl = null));
        }),
          (this.svg = null);
      },
      methods: { async getSvg() {} },
    };
  function Th(t, e) {
    if (qi(e) || F(e, "canvas")) {
      e.hidden = !0;
      const s = e.nextElementSibling;
      return qo(t, s) ? s : di(e, t);
    }
    const i = e.lastElementChild;
    return qo(t, i) ? i : W(e, t);
  }
  function qo(t, e) {
    return F(t, "svg") && F(e, "svg") && t.innerHTML === e.innerHTML;
  }
  function Eh(t, e) {
    const i = ["width", "height"];
    let s = i.map((o) => this[o]);
    s.some((o) => o) || (s = i.map((o) => p(e, o)));
    const n = p(e, "viewBox");
    n && !s.some((o) => o) && (s = n.split(" ").slice(2)),
      s.forEach((o, r) => p(t, i[r], k(o) * this.ratio || null));
  }
  function Uo(t, e) {
    return e && b(t, "<symbol") && (t = Ch(t)[e] || t), T(St(t)).filter(se)[0];
  }
  const Vo = /<symbol([^]*?id=(['"])(.+?)\2[^]*?<\/)symbol>/g,
    Ch = ct(function (t) {
      const e = {};
      Vo.lastIndex = 0;
      let i;
      for (; (i = Vo.exec(t)); ) e[i[3]] = `<svg ${i[1]}svg>`;
      return e;
    }),
    Bi = {
      spinner: Sh,
      totop: Ih,
      marker: ch,
      "close-icon": ah,
      "close-large": lh,
      "drop-parent-icon": hh,
      "nav-parent-icon": dh,
      "nav-parent-icon-large": uh,
      "navbar-parent-icon": fh,
      "navbar-toggle-icon": ph,
      "overlay-icon": gh,
      "pagination-next": mh,
      "pagination-previous": vh,
      "search-icon": jo,
      "search-medium": wh,
      "search-large": bh,
      "search-toggle-icon": jo,
      "slidenav-next": $h,
      "slidenav-next-large": xh,
      "slidenav-previous": kh,
      "slidenav-previous-large": yh,
    },
    Bs = {
      install: Fh,
      mixins: [Ro],
      args: "icon",
      props: { icon: String },
      isIcon: !0,
      beforeConnect() {
        S(this.$el, "uk-icon");
      },
      methods: {
        async getSvg() {
          const t = Lh(this.icon);
          if (!t) throw "Icon not found.";
          return t;
        },
      },
    },
    Zt = {
      args: !1,
      extends: Bs,
      data: (t) => ({ icon: Bt(t.constructor.options.name) }),
      beforeConnect() {
        S(this.$el, this.$options.id);
      },
    },
    Ph = {
      extends: Zt,
      beforeConnect() {
        const t = this.$props.icon;
        this.icon = this.$el.closest(".uk-nav-primary") ? `${t}-large` : t;
      },
    },
    _h = {
      extends: Zt,
      mixins: [Si],
      i18n: { toggle: "Open Search", submit: "Submit Search" },
      beforeConnect() {
        const t =
          $(this.$el, "uk-search-toggle") || $(this.$el, "uk-navbar-toggle");
        if (
          ((this.icon = t
            ? "search-toggle-icon"
            : $(this.$el, "uk-search-icon") &&
              this.$el.closest(".uk-search-large")
            ? "search-large"
            : this.$el.closest(".uk-search-medium")
            ? "search-medium"
            : this.$props.icon),
          !Et(this.$el, "aria-label"))
        )
          if (t) {
            const e = this.t("toggle");
            p(this.$el, "aria-label", e);
          } else {
            const e = this.$el.closest("a,button");
            if (e) {
              const i = this.t("submit");
              p(e, "aria-label", i);
            }
          }
      },
    },
    Ah = {
      extends: Zt,
      beforeConnect() {
        p(this.$el, "role", "status");
      },
      methods: {
        async getSvg() {
          const t = await Bs.methods.getSvg.call(this);
          return (
            this.ratio !== 1 &&
              h(x("circle", t), "strokeWidth", 1 / this.ratio),
            t
          );
        },
      },
    },
    Qt = {
      extends: Zt,
      mixins: [Si],
      beforeConnect() {
        const t = this.$el.closest("a,button");
        p(t, "role", this.role !== null && F(t, "a") ? "button" : this.role);
        const e = this.t("label");
        e && !Et(t, "aria-label") && p(t, "aria-label", e);
      },
    },
    Yo = {
      extends: Qt,
      beforeConnect() {
        S(this.$el, "uk-slidenav");
        const t = this.$props.icon;
        this.icon = $(this.$el, "uk-slidenav-large") ? `${t}-large` : t;
      },
    },
    Oh = { extends: Qt, i18n: { label: "Open menu" } },
    Dh = {
      extends: Qt,
      i18n: { label: "Close" },
      beforeConnect() {
        this.icon = `close-${$(this.$el, "uk-close-large") ? "large" : "icon"}`;
      },
    },
    Mh = { extends: Qt, i18n: { label: "Open" } },
    Bh = { extends: Qt, i18n: { label: "Back to top" } },
    Nh = { extends: Qt, i18n: { label: "Next page" }, data: { role: null } },
    zh = {
      extends: Qt,
      i18n: { label: "Previous page" },
      data: { role: null },
    },
    Ni = {};
  function Fh(t) {
    t.icon.add = (e, i) => {
      const s = H(e) ? { [e]: i } : e;
      oe(s, (n, o) => {
        (Bi[o] = n), delete Ni[o];
      }),
        t._initialized &&
          _t(document.body, (n) =>
            oe(t.getComponents(n), (o) => {
              o.$options.isIcon && o.icon in s && o.$reset();
            })
          );
    };
  }
  const Hh = { twitter: "x" };
  function Lh(t) {
    return (
      (t = Hh[t] || t),
      Bi[t]
        ? (Ni[t] || (Ni[t] = Uo(Bi[Wh(t)] || Bi[t])), Ni[t].cloneNode(!0))
        : null
    );
  }
  function Wh(t) {
    return U ? Wi(Wi(t, "left", "right"), "previous", "next") : t;
  }
  var jh = {
    props: { target: String, selActive: String },
    data: { target: !1, selActive: !1 },
    computed: { target: ({ target: t }, e) => (t ? D(t, e) : e) },
    observe: [
      me({
        handler(t) {
          (this.isIntersecting = t.some(({ isIntersecting: e }) => e)),
            this.$emit();
        },
        target: ({ target: t }) => t,
        args: { intersecting: !1 },
      }),
      $i({
        target: ({ target: t }) => t,
        options: {
          attributes: !0,
          attributeFilter: ["class"],
          attributeOldValue: !0,
        },
      }),
      {
        target: ({ target: t }) => t,
        observe: (t, e) => {
          const i = Le([...T(t), document.documentElement], e),
            s = [
              y(document, "scroll itemshown itemhidden", e, {
                passive: !0,
                capture: !0,
              }),
              y(
                document,
                "show hide transitionstart",
                (n) => (e(), i.observe(n.target))
              ),
              y(
                document,
                "shown hidden transitionend transitioncancel",
                (n) => (e(), i.unobserve(n.target))
              ),
            ];
          return {
            observe: i.observe.bind(i),
            unobserve: i.unobserve.bind(i),
            disconnect() {
              i.disconnect(), s.map((n) => n());
            },
          };
        },
        handler() {
          this.$emit();
        },
      },
    ],
    update: {
      read() {
        if (!this.isIntersecting) return !1;
        for (const t of T(this.target)) {
          let e = !this.selActive || C(t, this.selActive) ? Rh(t) : "";
          e !== !1 && ni(t, "uk-light uk-dark", e);
        }
      },
    },
  };
  function Rh(t) {
    const e = m(t),
      i = m(window);
    if (!ii(e, i)) return !1;
    const { left: s, top: n, height: o, width: r } = e;
    let a;
    for (const l of [0.25, 0.5, 0.75]) {
      const c = t.ownerDocument.elementsFromPoint(
        Math.max(0, Math.min(s + r * l, i.width - 1)),
        Math.max(0, Math.min(n + o / 2, i.height - 1))
      );
      for (const u of c) {
        if (
          t.contains(u) ||
          !qh(u) ||
          (u.closest('[class*="-leave"]') &&
            c.some((f) => u !== f && C(f, '[class*="-enter"]')))
        )
          continue;
        const d = h(u, "--uk-inverse");
        if (d) {
          if (d === a) return `uk-${d}`;
          a = d;
          break;
        }
      }
    }
    return a ? `uk-${a}` : "";
  }
  function qh(t) {
    if (h(t, "visibility") !== "visible") return !1;
    for (; t; ) {
      if (h(t, "opacity") === "0") return !1;
      t = O(t);
    }
    return !0;
  }
  var Uh = {
      mixins: [it, Ei],
      props: { fill: String },
      data: {
        fill: "",
        clsWrapper: "uk-leader-fill",
        clsHide: "uk-leader-hide",
        attrFill: "data-fill",
      },
      computed: {
        fill: ({ fill: t }, e) => t || h(e, "--uk-leader-fill-content"),
      },
      connected() {
        [this.wrapper] = ts(this.$el, `<span class="${this.clsWrapper}">`);
      },
      disconnected() {
        ze(this.wrapper.childNodes);
      },
      observe: dt(),
      update: {
        read() {
          return {
            width: Math.trunc(this.$el.offsetWidth / 2),
            fill: this.fill,
            hide: !this.matchMedia,
          };
        },
        write({ width: t, fill: e, hide: i }) {
          L(this.wrapper, this.clsHide, i),
            p(this.wrapper, this.attrFill, new Array(t).join(e));
        },
        events: ["resize"],
      },
    },
    Vh = {
      install: Yh,
      mixins: [Es],
      data: {
        clsPage: "uk-modal-page",
        selPanel: ".uk-modal-dialog",
        selClose: '[class*="uk-modal-close"]',
      },
      events: [
        {
          name: "fullscreenchange webkitendfullscreen",
          capture: !0,
          handler(t) {
            F(t.target, "video") &&
              this.isToggled() &&
              !document.fullscreenElement &&
              this.hide();
          },
        },
        {
          name: "show",
          self: !0,
          handler() {
            $(this.panel, "uk-margin-auto-vertical")
              ? S(this.$el, "uk-flex")
              : h(this.$el, "display", "block"),
              et(this.$el);
          },
        },
        {
          name: "hidden",
          self: !0,
          handler() {
            h(this.$el, "display", ""), _(this.$el, "uk-flex");
          },
        },
      ],
    };
  function Yh({ modal: t }) {
    (t.dialog = function (i, s) {
      const n = t(x(`<div><div class="uk-modal-dialog">${i}</div></div>`), {
        stack: !0,
        role: "alertdialog",
        ...s,
      });
      return (
        n.show(),
        y(
          n.$el,
          "hidden",
          async () => {
            await Promise.resolve(), n.$destroy(!0);
          },
          { self: !0 }
        ),
        n
      );
    }),
      (t.alert = function (i, s) {
        return e(
          ({ i18n: n }) =>
            `<div class="uk-modal-body">${
              H(i) ? i : bt(i)
            }</div> <div class="uk-modal-footer uk-text-right"> <button class="uk-button uk-button-primary uk-modal-close" autofocus>${
              n.ok
            }</button> </div>`,
          s
        );
      }),
      (t.confirm = function (i, s) {
        return e(
          ({ i18n: n }) =>
            `<form> <div class="uk-modal-body">${
              H(i) ? i : bt(i)
            }</div> <div class="uk-modal-footer uk-text-right"> <button class="uk-button uk-button-default uk-modal-close" type="button">${
              n.cancel
            }</button> <button class="uk-button uk-button-primary" autofocus>${
              n.ok
            }</button> </div> </form>`,
          s,
          () => Promise.reject()
        );
      }),
      (t.prompt = function (i, s, n) {
        const o = e(
            ({ i18n: l }) =>
              `<form class="uk-form-stacked"> <div class="uk-modal-body"> <label>${
                H(i) ? i : bt(i)
              }</label> <input class="uk-input" autofocus> </div> <div class="uk-modal-footer uk-text-right"> <button class="uk-button uk-button-default uk-modal-close" type="button">${
                l.cancel
              }</button> <button class="uk-button uk-button-primary">${
                l.ok
              }</button> </div> </form>`,
            n,
            () => null,
            () => a.value
          ),
          { $el: r } = o.dialog,
          a = x("input", r);
        return (a.value = s || ""), y(r, "show", () => a.select()), o;
      }),
      (t.i18n = { ok: "Ok", cancel: "Cancel" });
    function e(i, s, n = A, o = A) {
      s = {
        bgClose: !1,
        escClose: !0,
        ...s,
        i18n: { ...t.i18n, ...(s == null ? void 0 : s.i18n) },
      };
      const r = t.dialog(i(s), s);
      return ft(
        new Promise((a) => {
          const l = y(r.$el, "hide", () => a(n()));
          y(r.$el, "submit", "form", (c) => {
            c.preventDefault(), a(o(r)), l(), r.hide();
          });
        }),
        { dialog: r }
      );
    }
  }
  var Gh = {
    extends: Mo,
    data: { targets: "> .uk-parent", toggle: "> a", content: "> ul" },
  };
  const Ns = "uk-navbar-transparent";
  var Xh = {
    extends: Ho,
    props: { dropbarTransparentMode: Boolean },
    data: {
      clsDrop: "uk-navbar-dropdown",
      selNavItem:
        ".uk-navbar-nav > li > a,a.uk-navbar-item,button.uk-navbar-item,.uk-navbar-item a,.uk-navbar-item button,.uk-navbar-toggle",
      dropbarTransparentMode: !1,
    },
    computed: { navbarContainer: (t, e) => e.closest(".uk-navbar-container") },
    watch: {
      items() {
        const t = $(this.$el, "uk-navbar-justify"),
          e = D(".uk-navbar-nav, .uk-navbar-left, .uk-navbar-right", this.$el);
        for (const i of e) {
          const s = t
            ? D(
                ".uk-navbar-nav > li > a, .uk-navbar-item, .uk-navbar-toggle",
                i
              ).length
            : "";
          h(i, "flexGrow", s);
        }
      },
    },
    events: [
      {
        name: "show",
        el: ({ dropContainer: t }) => t,
        handler({ target: t }) {
          this.getTransparentMode(t) === "remove" &&
            $(this.navbarContainer, Ns) &&
            (_(this.navbarContainer, Ns), (this._transparent = !0));
        },
      },
      {
        name: "hide",
        el: ({ dropContainer: t }) => t,
        async handler() {
          await Jh(),
            this._transparent &&
              (!Y || !this.dropContainer.contains(Y.$el)) &&
              (S(this.navbarContainer, Ns), (this._transparent = null));
        },
      },
    ],
    methods: {
      getTransparentMode(t) {
        if (!this.navbarContainer) return;
        if (this.dropbar && this.isDropbarDrop(t))
          return this.dropbarTransparentMode;
        const e = this.getDropdown(t);
        if (e && $(t, "uk-dropbar")) return e.inset ? "behind" : "remove";
      },
      getDropbarOffset(t) {
        const { top: e, height: i } = E(this.navbarContainer);
        return e + (this.dropbarTransparentMode === "behind" ? 0 : i + t);
      },
    },
  };
  function Jh() {
    return new Promise((t) => setTimeout(t));
  }
  var Kh = {
    mixins: [Es],
    args: "mode",
    props: { mode: String, flip: Boolean, overlay: Boolean, swiping: Boolean },
    data: {
      mode: "slide",
      flip: !1,
      overlay: !1,
      clsPage: "uk-offcanvas-page",
      clsContainer: "uk-offcanvas-container",
      selPanel: ".uk-offcanvas-bar",
      clsFlip: "uk-offcanvas-flip",
      clsContainerAnimation: "uk-offcanvas-container-animation",
      clsSidebarAnimation: "uk-offcanvas-bar-animation",
      clsMode: "uk-offcanvas",
      clsOverlay: "uk-offcanvas-overlay",
      selClose: ".uk-offcanvas-close",
      container: !1,
      swiping: !0,
    },
    computed: {
      clsFlip: ({ flip: t, clsFlip: e }) => (t ? e : ""),
      clsOverlay: ({ overlay: t, clsOverlay: e }) => (t ? e : ""),
      clsMode: ({ mode: t, clsMode: e }) => `${e}-${t}`,
      clsSidebarAnimation: ({ mode: t, clsSidebarAnimation: e }) =>
        t === "none" || t === "reveal" ? "" : e,
      clsContainerAnimation: ({ mode: t, clsContainerAnimation: e }) =>
        t !== "push" && t !== "reveal" ? "" : e,
      transitionElement({ mode: t }) {
        return t === "reveal" ? O(this.panel) : this.panel;
      },
    },
    observe: In({ filter: ({ swiping: t }) => t }),
    update: {
      read() {
        this.isToggled() && !q(this.$el) && this.hide();
      },
      events: ["resize"],
    },
    events: [
      {
        name: "touchmove",
        self: !0,
        passive: !1,
        filter: ({ overlay: t }) => t,
        handler(t) {
          t.cancelable && t.preventDefault();
        },
      },
      {
        name: "show",
        self: !0,
        handler() {
          this.mode === "reveal" &&
            !$(O(this.panel), this.clsMode) &&
            S(Ne(this.panel, "<div>"), this.clsMode);
          const { body: t, scrollingElement: e } = document;
          S(t, this.clsContainer, this.clsFlip),
            h(t, "touchAction", "pan-y pinch-zoom"),
            h(this.$el, "display", "block"),
            h(this.panel, "maxWidth", e.clientWidth),
            S(this.$el, this.clsOverlay),
            S(
              this.panel,
              this.clsSidebarAnimation,
              this.mode === "reveal" ? "" : this.clsMode
            ),
            et(t),
            S(t, this.clsContainerAnimation),
            this.clsContainerAnimation && Zh();
        },
      },
      {
        name: "hide",
        self: !0,
        handler() {
          _(document.body, this.clsContainerAnimation),
            h(document.body, "touchAction", "");
        },
      },
      {
        name: "hidden",
        self: !0,
        handler() {
          this.clsContainerAnimation && Qh(),
            this.mode === "reveal" &&
              $(O(this.panel), this.clsMode) &&
              ze(this.panel),
            _(this.panel, this.clsSidebarAnimation, this.clsMode),
            _(this.$el, this.clsOverlay),
            h(this.$el, "display", ""),
            h(this.panel, "maxWidth", ""),
            _(document.body, this.clsContainer, this.clsFlip);
        },
      },
      {
        name: "swipeLeft swipeRight",
        handler(t) {
          this.isToggled() && ee(t.type, "Left") ^ this.flip && this.hide();
        },
      },
    ],
  };
  function Zh() {
    Go().content += ",user-scalable=0";
  }
  function Qh() {
    const t = Go();
    t.content = t.content.replace(/,user-scalable=0$/, "");
  }
  function Go() {
    return (
      x('meta[name="viewport"]', document.head) ||
      W(document.head, '<meta name="viewport">')
    );
  }
  var tc = {
      mixins: [it],
      props: { selContainer: String, selContent: String, minHeight: Number },
      data: {
        selContainer: ".uk-modal",
        selContent: ".uk-modal-dialog",
        minHeight: 150,
      },
      computed: {
        container: ({ selContainer: t }, e) => e.closest(t),
        content: ({ selContent: t }, e) => e.closest(t),
      },
      observe: dt({ target: ({ container: t, content: e }) => [t, e] }),
      update: {
        read() {
          return !this.content || !this.container || !q(this.$el)
            ? !1
            : {
                max: Math.max(
                  this.minHeight,
                  et(this.container) - (m(this.content).height - et(this.$el))
                ),
              };
        },
        write({ max: t }) {
          h(this.$el, { minHeight: this.minHeight, maxHeight: t });
        },
        events: ["resize"],
      },
    },
    ec = {
      props: ["width", "height"],
      connected() {
        S(this.$el, "uk-responsive-width"),
          h(this.$el, "aspectRatio", `${this.width}/${this.height}`);
      },
    },
    ic = {
      props: { offset: Number },
      data: { offset: 0 },
      connected() {
        sc(this);
      },
      disconnected() {
        nc(this);
      },
      methods: {
        async scrollTo(t) {
          (t = (t && x(t)) || document.body),
            v(this.$el, "beforescroll", [this, t]) &&
              (await pn(t, { offset: this.offset }),
              v(this.$el, "scrolled", [this, t]));
        },
      },
    };
  const Ze = new Set();
  function sc(t) {
    Ze.size || y(document, "click", Xo), Ze.add(t);
  }
  function nc(t) {
    Ze.delete(t), Ze.size || Rt(document, "click", Xo);
  }
  function Xo(t) {
    if (!t.defaultPrevented)
      for (const e of Ze)
        e.$el.contains(t.target) &&
          ue(e.$el) &&
          (t.preventDefault(),
          window.location.href !== e.$el.href &&
            window.history.pushState({}, "", e.$el.href),
          e.scrollTo(Ui(e.$el)));
  }
  const zs = "uk-scrollspy-inview";
  var oc = {
      args: "cls",
      props: {
        cls: String,
        target: String,
        hidden: Boolean,
        margin: String,
        repeat: Boolean,
        delay: Number,
      },
      data: () => ({
        cls: "",
        target: !1,
        hidden: !0,
        margin: "-1px",
        repeat: !1,
        delay: 0,
      }),
      computed: { elements: ({ target: t }, e) => (t ? D(t, e) : [e]) },
      watch: {
        elements(t) {
          this.hidden && h(Oe(t, `:not(.${zs})`), "opacity", 0);
        },
      },
      connected() {
        this.elementData = new Map();
      },
      disconnected() {
        for (const [t, e] of this.elementData.entries())
          _(t, zs, (e == null ? void 0 : e.cls) || "");
        delete this.elementData;
      },
      observe: me({
        target: ({ elements: t }) => t,
        handler(t) {
          const e = this.elementData;
          for (const { target: i, isIntersecting: s } of t) {
            e.has(i) ||
              e.set(i, { cls: Z(i, "uk-scrollspy-class") || this.cls });
            const n = e.get(i);
            (!this.repeat && n.show) || (n.show = s);
          }
          this.$emit();
        },
        options: ({ margin: t }) => ({ rootMargin: t }),
        args: { intersecting: !1 },
      }),
      update: [
        {
          write(t) {
            for (const [e, i] of this.elementData.entries())
              i.show && !i.inview && !i.queued
                ? ((i.queued = !0),
                  (t.promise = (t.promise || Promise.resolve())
                    .then(() => new Promise((s) => setTimeout(s, this.delay)))
                    .then(() => {
                      this.toggle(e, !0),
                        setTimeout(() => {
                          (i.queued = !1), this.$emit();
                        }, 300);
                    })))
                : !i.show &&
                  i.inview &&
                  !i.queued &&
                  this.repeat &&
                  this.toggle(e, !1);
          },
        },
      ],
      methods: {
        toggle(t, e) {
          var i, s;
          const n = (i = this.elementData) == null ? void 0 : i.get(t);
          if (!n) return;
          (s = n.off) == null || s.call(n),
            h(t, "opacity", !e && this.hidden ? 0 : ""),
            L(t, zs, e),
            L(t, n.cls);
          let o;
          if ((o = n.cls.match(/\buk-animation-[\w-]+/g))) {
            const r = () => _(t, o);
            e
              ? (n.off = z(t, "animationcancel animationend", r, { self: !0 }))
              : r();
          }
          v(t, e ? "inview" : "outview"), (n.inview = e);
        },
      },
    },
    rc = {
      props: {
        cls: String,
        closest: Boolean,
        scroll: Boolean,
        target: String,
        offset: Number,
      },
      data: {
        cls: "uk-active",
        closest: !1,
        scroll: !1,
        target: 'a[href]:not([role="button"])',
        offset: 0,
      },
      computed: {
        links: ({ target: t }, e) => D(t, e).filter((i) => ue(i)),
        elements({ closest: t }) {
          return this.links.map((e) => e.closest(t || "*"));
        },
      },
      watch: {
        links(t) {
          this.scroll && this.$create("scroll", t, { offset: this.offset });
        },
      },
      observe: [me(), Re()],
      update: [
        {
          read() {
            const t = this.links.map((l) => Ui(l)).filter(Boolean),
              { length: e } = t;
            if (!e || !q(this.$el)) return !1;
            const i = Ot(t, !0),
              { scrollTop: s, scrollHeight: n } = i,
              o = rt(i),
              r = n - o.height;
            let a = !1;
            if (s >= r) a = e - 1;
            else {
              const l = this.offset + m(us()).height + o.height * 0.1;
              for (
                let c = 0;
                c < t.length && !(E(t[c]).top - o.top - l > 0);
                c++
              )
                a = +c;
            }
            return { active: a };
          },
          write({ active: t }) {
            const e = t !== !1 && !$(this.elements[t], this.cls);
            this.links.forEach((i) => i.blur());
            for (let i = 0; i < this.elements.length; i++)
              L(this.elements[i], this.cls, +i === t);
            e && v(this.$el, "active", [t, this.elements[t]]);
          },
          events: ["scroll", "resize"],
        },
      ],
    },
    ac = {
      mixins: [it, Ei],
      props: {
        position: String,
        top: null,
        bottom: null,
        start: null,
        end: null,
        offset: String,
        offsetEnd: String,
        overflowFlip: Boolean,
        animation: String,
        clsActive: String,
        clsInactive: String,
        clsFixed: String,
        clsBelow: String,
        selTarget: String,
        showOnUp: Boolean,
        targetOffset: Number,
      },
      data: {
        position: "top",
        top: !1,
        bottom: !1,
        start: !1,
        end: !1,
        offset: 0,
        offsetEnd: 0,
        overflowFlip: !1,
        animation: "",
        clsActive: "uk-active",
        clsInactive: "",
        clsFixed: "uk-sticky-fixed",
        clsBelow: "uk-sticky-below",
        selTarget: "",
        showOnUp: !1,
        targetOffset: !1,
      },
      computed: { target: ({ selTarget: t }, e) => (t && x(t, e)) || e },
      connected() {
        (this.start = Jo(this.start || this.top)),
          (this.end = Jo(this.end || this.bottom)),
          (this.placeholder =
            x("+ .uk-sticky-placeholder", this.$el) ||
            x('<div class="uk-sticky-placeholder"></div>')),
          (this.isFixed = !1),
          this.setActive(!1);
      },
      beforeDisconnect() {
        this.isFixed && (this.hide(), _(this.target, this.clsInactive)),
          Ko(this.$el),
          Q(this.placeholder),
          (this.placeholder = null);
      },
      observe: [
        vs(),
        Re({ target: () => document.scrollingElement }),
        dt({
          target: ({ $el: t }) => [t, zi(t), document.scrollingElement],
          handler(t) {
            this.$emit(
              this._data.resized &&
                t.some(({ target: e }) => e === zi(this.$el))
                ? "update"
                : "resize"
            ),
              (this._data.resized = !0);
          },
        }),
      ],
      events: [
        {
          name: "load hashchange popstate",
          el: () => window,
          filter: ({ targetOffset: t }) => t !== !1,
          handler() {
            const { scrollingElement: t } = document;
            !location.hash ||
              t.scrollTop === 0 ||
              setTimeout(() => {
                const e = E(x(location.hash)),
                  i = E(this.$el);
                this.isFixed &&
                  ii(e, i) &&
                  (t.scrollTop = Math.ceil(
                    e.top -
                      i.height -
                      G(this.targetOffset, "height", this.placeholder) -
                      G(this.offset, "height", this.placeholder)
                  ));
              });
          },
        },
      ],
      update: [
        {
          read({ height: t, width: e, margin: i, sticky: s }, n) {
            if (
              ((this.inactive =
                !this.matchMedia || !q(this.$el) || !this.$el.offsetHeight),
              this.inactive)
            )
              return;
            const o = et(window),
              r = Math.max(0, document.scrollingElement.scrollHeight - o);
            if (!r) {
              this.inactive = !0;
              return;
            }
            const a = this.isFixed && n.has("update");
            a && (Ls(this.target), this.hide()),
              this.active ||
                (({ height: t, width: e } = m(this.$el)),
                (i = h(this.$el, "margin"))),
              a && this.show();
            const l = G("100vh", "height");
            let c = this.position;
            this.overflowFlip && t > l && (c = c === "top" ? "bottom" : "top");
            const u = this.isFixed ? this.placeholder : this.$el;
            let [d, f] = [this.offset, this.offsetEnd].map((Mt) =>
              G(Mt, "height", s ? this.$el : u)
            );
            c === "bottom" && (t < o || this.overflowFlip) && (d += o - t);
            const g = t + d + f,
              w = this.overflowFlip ? 0 : Math.max(0, g - l),
              I = E(u).top - new DOMMatrix(h(u, "transform")).m42,
              P = m(this.$el).height,
              ht = (this.start === !1 ? I : Fs(this.start, this.$el, I)) - d,
              It =
                this.end === !1
                  ? r
                  : Math.min(r, Fs(this.end, this.$el, I + t, !0) - P - d + w);
            return (
              (s =
                !this.showOnUp &&
                ht + d === I &&
                It === Math.min(r, Fs(!0, this.$el, 0, !0) - P - d + w) &&
                h(zi(this.$el), "overflowY") !== "hidden"),
              {
                start: ht,
                end: It,
                offset: d,
                overflow: w,
                height: t,
                elHeight: P,
                width: e,
                margin: i,
                top: Fe(u)[0],
                sticky: s,
                viewport: l,
                maxScrollHeight: r,
              }
            );
          },
          write({ height: t, width: e, margin: i, offset: s, sticky: n }) {
            if (
              ((this.inactive || n || !this.isFixed) && Ko(this.$el),
              this.inactive)
            )
              return;
            n && ((t = e = i = 0), h(this.$el, { position: "sticky", top: s }));
            const { placeholder: o } = this;
            h(o, { height: t, width: e, margin: i }),
              (O(o) !== O(this.$el) || n ^ (yt(o) < yt(this.$el))) &&
                ((n ? ui : di)(this.$el, o), (o.hidden = !0));
          },
          events: ["resize"],
        },
        {
          read({
            scroll: t = 0,
            dir: e = "down",
            overflow: i,
            overflowScroll: s = 0,
            start: n,
            end: o,
            elHeight: r,
            height: a,
            sticky: l,
            maxScrollHeight: c,
          }) {
            const u = Math.min(document.scrollingElement.scrollTop, c),
              d = t <= u ? "down" : "up",
              f = this.isFixed ? this.placeholder : this.$el;
            return {
              dir: d,
              prevDir: e,
              scroll: u,
              prevScroll: t,
              below: u > E(f).top + (l ? Math.min(a, r) : a),
              offsetParentTop: E(f.offsetParent).top,
              overflowScroll: K(s + K(u, n, o) - K(t, n, o), 0, i),
            };
          },
          write(t, e) {
            const i = e.has("scroll"),
              {
                initTimestamp: s = 0,
                dir: n,
                prevDir: o,
                scroll: r,
                prevScroll: a = 0,
                top: l,
                start: c,
                below: u,
              } = t;
            if (
              r < 0 ||
              (r === a && i) ||
              (this.showOnUp && !i && !this.isFixed)
            )
              return;
            const d = Date.now();
            if (
              ((d - s > 300 || n !== o) &&
                ((t.initScroll = r), (t.initTimestamp = d)),
              !(
                this.showOnUp &&
                !this.isFixed &&
                Math.abs(t.initScroll - r) <= 30 &&
                Math.abs(a - r) <= 10
              ))
            )
              if (
                this.inactive ||
                r < c ||
                (this.showOnUp &&
                  (r <= c ||
                    (n === "down" && i) ||
                    (n === "up" && !this.isFixed && !u)))
              ) {
                if (!this.isFixed) {
                  Pt.inProgress(this.$el) &&
                    l > r &&
                    (Pt.cancel(this.$el), this.hide());
                  return;
                }
                if (this.animation && u) {
                  if ($(this.$el, "uk-animation-leave")) return;
                  Pt.out(this.$el, this.animation).then(() => this.hide(), A);
                } else this.hide();
              } else
                this.isFixed
                  ? this.update()
                  : this.animation && u
                  ? (this.show(), Pt.in(this.$el, this.animation).catch(A))
                  : (Ls(this.target), this.show());
          },
          events: ["resize", "resizeViewport", "scroll"],
        },
      ],
      methods: {
        show() {
          (this.isFixed = !0), this.update(), (this.placeholder.hidden = !1);
        },
        hide() {
          const { offset: t, sticky: e } = this._data;
          this.setActive(!1),
            _(this.$el, this.clsFixed, this.clsBelow),
            e
              ? h(this.$el, "top", t)
              : h(this.$el, {
                  position: "",
                  top: "",
                  width: "",
                  marginTop: "",
                }),
            (this.placeholder.hidden = !0),
            (this.isFixed = !1);
        },
        update() {
          let {
            width: t,
            scroll: e = 0,
            overflow: i,
            overflowScroll: s = 0,
            start: n,
            end: o,
            offset: r,
            offsetParentTop: a,
            sticky: l,
            below: c,
          } = this._data;
          const u = n !== 0 || e > n;
          if (!l) {
            let d = "fixed";
            e > o && ((r += o - a + s - i), (d = "absolute")),
              h(this.$el, { position: d, width: t, marginTop: 0 }, "important");
          }
          h(this.$el, "top", r - s),
            this.setActive(u),
            L(this.$el, this.clsBelow, c),
            S(this.$el, this.clsFixed);
        },
        setActive(t) {
          const e = this.active;
          (this.active = t),
            t
              ? (ni(this.target, this.clsInactive, this.clsActive),
                e !== t && v(this.$el, "active"))
              : (ni(this.target, this.clsActive, this.clsInactive),
                e !== t && (Ls(this.target), v(this.$el, "inactive")));
        },
      },
    };
  function Fs(t, e, i, s) {
    if (!t) return 0;
    if (vt(t) || (H(t) && t.match(/^-?\d/))) return i + G(t, "height", e, !0);
    {
      const n = t === !0 ? zi(e) : tt(t, e);
      return (
        E(n).bottom -
        (s && n != null && n.contains(e)
          ? k(h(n, "paddingBottom")) + k(h(n, "borderBottomWidth"))
          : 0)
      );
    }
  }
  function Jo(t) {
    return t === "true" ? !0 : t === "false" ? !1 : t;
  }
  function Ko(t) {
    h(t, { position: "", top: "", marginTop: "", width: "" });
  }
  const Hs = "uk-transition-disable";
  function Ls(t) {
    $(t, Hs) || (S(t, Hs), requestAnimationFrame(() => _(t, Hs)));
  }
  function zi(t) {
    for (; (t = O(t)); ) if (q(t)) return t;
  }
  var lc = {
    mixins: [Ro],
    args: "src",
    props: {
      src: String,
      icon: String,
      attributes: "list",
      strokeAnimation: Boolean,
    },
    data: { strokeAnimation: !1 },
    observe: [
      $i({
        async handler() {
          const t = await this.svg;
          t && Zo.call(this, t);
        },
        options: { attributes: !0, attributeFilter: ["id", "class", "style"] },
      }),
    ],
    async connected() {
      b(this.src, "#") && ([this.src, this.icon] = this.src.split("#", 2));
      const t = await this.svg;
      t && (Zo.call(this, t), this.strokeAnimation && cc(t));
    },
    methods: {
      async getSvg() {
        return (
          F(this.$el, "img") &&
            !this.$el.complete &&
            this.$el.loading === "lazy" &&
            (await new Promise((t) => z(this.$el, "load", t))),
          Uo(await hc(this.src), this.icon) || Promise.reject("SVG not found.")
        );
      },
    },
  };
  function Zo(t) {
    const { $el: e } = this;
    S(t, p(e, "class"), "uk-svg");
    for (let i = 0; i < e.style.length; i++) {
      const s = e.style[i];
      h(t, s, h(e, s));
    }
    for (const i in this.attributes) {
      const [s, n] = this.attributes[i].split(":", 2);
      p(t, s, n);
    }
    this.$el.id || _e(t, "id");
  }
  const hc = ct(async (t) => {
    if (t) {
      if (mt(t, "data:")) return decodeURIComponent(t.split(",", 2)[1]);
      {
        const e = await fetch(t);
        if (e.headers.get("Content-Type") === "image/svg+xml") return e.text();
      }
    }
    return Promise.reject();
  });
  function cc(t) {
    const e = lo(t);
    e && h(t, "--uk-animation-stroke", e);
  }
  const Ws = ".uk-disabled *, .uk-disabled, [disabled]";
  var Qo = {
      mixins: [Yt],
      args: "connect",
      props: {
        connect: String,
        toggle: String,
        itemNav: String,
        active: Number,
        followFocus: Boolean,
        swiping: Boolean,
      },
      data: {
        connect: "~.uk-switcher",
        toggle: "> * > :first-child",
        itemNav: !1,
        active: 0,
        cls: "uk-active",
        attrItem: "uk-switcher-item",
        selVertical: ".uk-nav",
        followFocus: !1,
        swiping: !0,
      },
      computed: {
        connects: {
          get: ({ connect: t }, e) => De(t, e),
          observe: ({ connect: t }) => t,
        },
        connectChildren() {
          return this.connects.map((t) => B(t)).flat();
        },
        toggles: ({ toggle: t }, e) => D(t, e),
        children(t, e) {
          return B(e).filter((i) => this.toggles.some((s) => i.contains(s)));
        },
      },
      watch: {
        connects(t) {
          this.swiping && h(t, "touchAction", "pan-y pinch-zoom"), this.$emit();
        },
        connectChildren() {
          let t = Math.max(0, this.index());
          for (const e of this.connects)
            B(e).forEach((i, s) => L(i, this.cls, s === t));
          this.$emit();
        },
        toggles(t) {
          this.$emit();
          const e = this.index();
          this.show(~e ? e : t[this.active] || t[0]);
        },
      },
      connected() {
        p(this.$el, "role", "tablist");
      },
      observe: [
        yi({ targets: ({ connectChildren: t }) => t }),
        In({ target: ({ connects: t }) => t, filter: ({ swiping: t }) => t }),
      ],
      events: [
        {
          name: "click keydown",
          delegate: ({ toggle: t }) => t,
          handler(t) {
            !C(t.current, Ws) &&
              (t.type === "click" || t.keyCode === M.SPACE) &&
              (t.preventDefault(), this.show(t.current));
          },
        },
        {
          name: "keydown",
          delegate: ({ toggle: t }) => t,
          handler(t) {
            const { current: e, keyCode: i } = t,
              s = C(this.$el, this.selVertical);
            let n =
              i === M.HOME
                ? 0
                : i === M.END
                ? "last"
                : (i === M.LEFT && !s) || (i === M.UP && s)
                ? "previous"
                : (i === M.RIGHT && !s) || (i === M.DOWN && s)
                ? "next"
                : -1;
            if (~n) {
              t.preventDefault();
              const o = this.toggles.filter((a) => !C(a, Ws)),
                r = o[ot(n, o, o.indexOf(e))];
              r.focus(), this.followFocus && this.show(r);
            }
          },
        },
        {
          name: "click",
          el: ({ $el: t, connects: e, itemNav: i }) =>
            e.concat(i ? De(i, t) : []),
          delegate: ({ attrItem: t }) => `[${t}],[data-${t}]`,
          handler(t) {
            t.target.closest("a,button") &&
              (t.preventDefault(), this.show(Z(t.current, this.attrItem)));
          },
        },
        {
          name: "swipeRight swipeLeft",
          filter: ({ swiping: t }) => t,
          el: ({ connects: t }) => t,
          handler({ type: t }) {
            this.show(ee(t, "Left") ? "next" : "previous");
          },
        },
      ],
      update() {
        var t;
        for (const e of this.connects)
          F(e, "ul") && p(e, "role", "presentation");
        p(B(this.$el), "role", "presentation");
        for (const e in this.toggles) {
          const i = this.toggles[e],
            s = (t = this.connects[0]) == null ? void 0 : t.children[e];
          p(i, "role", "tab"),
            s &&
              ((i.id = Jt(this, i)),
              (s.id = Jt(this, s)),
              p(i, "aria-controls", s.id),
              p(s, { role: "tabpanel", "aria-labelledby": i.id }));
        }
        p(
          this.$el,
          "aria-orientation",
          C(this.$el, this.selVertical) ? "vertical" : null
        );
      },
      methods: {
        index() {
          return xt(this.children, (t) => $(t, this.cls));
        },
        show(t) {
          const e = this.toggles.filter((r) => !C(r, Ws)),
            i = this.index(),
            s = ot(!Ee(t) || b(e, t) ? t : 0, e, ot(this.toggles[i], e)),
            n = ot(e[s], this.toggles);
          this.children.forEach((r, a) => {
            L(r, this.cls, n === a),
              p(this.toggles[a], {
                "aria-selected": n === a,
                tabindex: n === a ? null : -1,
              });
          });
          const o = i >= 0 && i !== s;
          this.connects.forEach(async ({ children: r }) => {
            const a = ie(r).filter((l, c) => c !== n && $(l, this.cls));
            (await this.toggleElement(a, !1, o)) &&
              (await this.toggleElement(r[n], !0, o));
          });
        },
      },
    },
    uc = {
      mixins: [it],
      extends: Qo,
      props: { media: Boolean },
      data: {
        media: 960,
        attrItem: "uk-tab-item",
        selVertical: ".uk-tab-left,.uk-tab-right",
      },
      connected() {
        const t = $(this.$el, "uk-tab-left")
          ? "uk-tab-left"
          : $(this.$el, "uk-tab-right")
          ? "uk-tab-right"
          : !1;
        t &&
          this.$create("toggle", this.$el, {
            cls: t,
            mode: "media",
            media: this.media,
          });
      },
    };
  const dc = 13,
    fc = 32;
  var pc = {
      mixins: [Ei, Yt],
      args: "target",
      props: { href: String, target: null, mode: "list", queued: Boolean },
      data: { href: !1, target: !1, mode: "click", queued: !0 },
      computed: {
        target: {
          get: ({ target: t }, e) => (
            (t = De(t || e.hash, e)), t.length ? t : [e]
          ),
          observe: ({ target: t }) => t,
        },
      },
      connected() {
        b(this.mode, "media") ||
          (li(this.$el) || p(this.$el, "tabindex", "0"),
          !this.cls && F(this.$el, "a") && p(this.$el, "role", "button"));
      },
      observe: yi({ targets: ({ target: t }) => t }),
      events: [
        {
          name: ut,
          filter: ({ mode: t }) => b(t, "hover"),
          handler(t) {
            (this._preventClick = null),
              !(!pt(t) || ne(this._showState) || this.$el.disabled) &&
                (v(this.$el, "focus"),
                z(
                  document,
                  ut,
                  () => v(this.$el, "blur"),
                  !0,
                  (e) => !this.$el.contains(e.target)
                ),
                b(this.mode, "click") && (this._preventClick = !0));
          },
        },
        {
          name: `mouseenter mouseleave ${jt} ${le} focus blur`,
          filter: ({ mode: t }) => b(t, "hover"),
          handler(t) {
            if (pt(t) || this.$el.disabled || document.readyState === "loading")
              return;
            const e = b(["mouseenter", jt, "focus"], t.type),
              i = this.isToggled(this.target);
            if (
              !e &&
              (!ne(this._showState) ||
                (t.type !== "blur" && C(this.$el, ":focus")) ||
                (t.type === "blur" && C(this.$el, ":hover")))
            ) {
              i === this._showState && (this._showState = null);
              return;
            }
            (e && ne(this._showState) && i !== this._showState) ||
              ((this._showState = e ? i : null),
              this.toggle(`toggle${e ? "show" : "hide"}`));
          },
        },
        {
          name: "keydown",
          filter: ({ $el: t, mode: e }) => b(e, "click") && !F(t, "input"),
          handler(t) {
            (t.keyCode === fc || t.keyCode === dc) &&
              (t.preventDefault(), this.$el.click());
          },
        },
        {
          name: "click",
          filter: ({ mode: t }) => ["click", "hover"].some((e) => b(t, e)),
          handler(t) {
            let e;
            (this._preventClick ||
              t.target.closest('a[href="#"], a[href=""]') ||
              ((e = t.target.closest("a[href]")) &&
                (!this.isToggled(this.target) ||
                  (e.hash && C(this.target, e.hash))))) &&
              t.preventDefault(),
              !this._preventClick && b(this.mode, "click") && this.toggle();
          },
        },
        {
          name: "mediachange",
          filter: ({ mode: t }) => b(t, "media"),
          el: ({ target: t }) => t,
          handler(t, e) {
            e.matches ^ this.isToggled(this.target) && this.toggle();
          },
        },
      ],
      methods: {
        async toggle(t) {
          if (!v(this.target, t || "toggle", [this])) return;
          if (
            (Et(this.$el, "aria-expanded") &&
              p(this.$el, "aria-expanded", !this.isToggled(this.target)),
            !this.queued)
          )
            return this.toggleElement(this.target);
          const e = this.target.filter((s) => $(s, this.clsLeave));
          if (e.length) {
            for (const s of this.target) {
              const n = b(e, s);
              this.toggleElement(s, n, n);
            }
            return;
          }
          const i = this.target.filter(this.isToggled);
          (await this.toggleElement(i, !1)) &&
            (await this.toggleElement(
              this.target.filter((s) => !b(i, s)),
              !0
            ));
        },
      },
    },
    gc = Object.freeze({
      __proto__: null,
      Accordion: Mo,
      Alert: Wl,
      Close: Dh,
      Cover: ql,
      Drop: zo,
      DropParentIcon: Zt,
      Dropdown: zo,
      Dropnav: Ho,
      FormCustom: Kl,
      Grid: Zl,
      HeightMatch: ih,
      HeightPlaceholder: oh,
      HeightViewport: rh,
      Icon: Bs,
      Img: ha,
      Inverse: jh,
      Leader: Uh,
      Margin: Tn,
      Marker: Mh,
      Modal: Vh,
      Nav: Gh,
      NavParentIcon: Ph,
      Navbar: Xh,
      NavbarParentIcon: Zt,
      NavbarToggleIcon: Oh,
      Offcanvas: Kh,
      OverflowAuto: tc,
      OverlayIcon: Zt,
      PaginationNext: Nh,
      PaginationPrevious: zh,
      Responsive: ec,
      Scroll: ic,
      Scrollspy: oc,
      ScrollspyNav: rc,
      SearchIcon: _h,
      SlidenavNext: Yo,
      SlidenavPrevious: Yo,
      Spinner: Ah,
      Sticky: ac,
      Svg: lc,
      Switcher: Qo,
      Tab: uc,
      Toggle: pc,
      Totop: Bh,
      Video: Bo,
    });
  return (
    oe(gc, (t, e) => lt.component(e, t)),
    Nl(lt),
    oe(Bl, (t, e) => lt.component(e, t)),
    lt
  );
});
